import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
    en: {
        navbar: {
            home: 'Home',
            jewelleriesStones: 'Jewelleries & Stones',
            gemHistory: 'Gem History',
            blogs: 'Blogs',
            aboutUs: 'About Us',
            contactUs: 'Contact Us',
        },
        footer: {
            description: 'Marino Gems is a premier jewellery company in Sri Lanka, specializing in exquisite gold, silver, and gemstone creations.',
            linksTitle: 'Links',
            contactTitle: 'Contact',
            copyright: '© Copyright {{year}} by Marino Gems',
            developedBy: 'Developed by',
        },
        contact: {
            title: "Contact Us",
            feelFree: "Feel Free To Contact US",
            weAreHere: "We’re Here to Help You Every Step of the Way",
            description: "Contact Marino Gems & Jewellery for expert guidance and support on your gem and jewellery needs.",
            callCenter: "Call Center",
            email: "Email",
            ourLocation: "Our Location",
            socialNetwork: "Social Network",
            getInTouch: "Get In Touch",
            formIntro: "We’d love to hear from you — our team is ready to answer your questions and guide you forward.",
            nameLabel: "Name",
            emailLabel: "Email",
            contactNumberLabel: "Contact Number",
            messageLabel: "Message",
            sendButton: "Send Message",
            sending: "Sending...",
            successMessage: "Your message has been sent to WhatsApp!",
            errorMessage: "Failed to open WhatsApp. Please try again.",
            findUs: "Find Us"
        },
        gemhistory: {
            hero: {
                title: "Gem History",
                alt: "Gem History Background",
                subtitle: {
                    part1: "At Marino Gems & Jewelleries, we celebrate the rich history of",
                    highlight: "gems and craftsmanship",
                    part2: "that have shaped timeless treasures for centuries."
                }
            },
            history: {
                title: "History of Gems in Sri Lanka",
                subtitle: "Sri Lanka, known as the \"Gem Island,\" has a storied legacy of gem mining and trading dating back over 2,000 years.",
                imageAlt: "History of Gems in Sri Lanka",
                text: "Sri Lanka, often called the \"Gem Island,\" has been a global hub for precious and semi-precious gems for over 2,000 years. Renowned for its sapphires, rubies, and other gemstones, the island’s rich deposits in areas like Ratnapura have fueled a vibrant trade since ancient times. From the courts of kings to modern markets, Sri Lankan gems have adorned royalty and collectors worldwide, with traditional mining techniques still practiced alongside modern methods. Marino Gems & Jewelleries continues this legacy, sourcing ethically mined gems to craft exquisite jewellery."
            },
            industry: {
                title: "About Gem Industry",
                subtitle: "The global gem industry blends ancient craftsmanship with modern innovation, creating timeless value.",
                imageAlt: "About Gem Industry",
                text: "The gem industry is a dynamic blend of tradition and technology, spanning mining, cutting, trading, and jewellery design. Valued at over $80 billion globally, it thrives on the allure of precious and semi-precious stones like sapphires, diamonds, and emeralds. From ancient trade routes to modern markets, the industry supports millions of livelihoods, with key hubs in Sri Lanka, Thailand, and India. At Marino Gems & Jewelleries, we contribute to this vibrant industry by prioritizing ethical sourcing and sustainable practices, ensuring every piece reflects quality and responsibility."
            },
            importance: {
                title: "Importance of Gems in",
                country: "Sri Lanka",
                subtitle: "Discover why gems are a cornerstone of Sri Lanka’s heritage, economy, and global reputation.",
                items: {
                    culturalSignificance: {
                        title: "Cultural Significance",
                        description: "Gems have been integral to Sri Lankan culture, adorning royal regalia and religious artifacts for centuries, symbolizing power and spirituality."
                    },
                    economicImpact: {
                        title: "Economic Impact",
                        description: "The gem industry is a major contributor to Sri Lanka’s economy, providing jobs and supporting communities in mining regions like Ratnapura."
                    },
                    globalReputation: {
                        title: "Global Reputation",
                        description: "Sri Lanka’s sapphires and rubies are world-renowned, attracting international buyers and establishing the country as a premier gem hub."
                    },
                    sustainablePractices: {
                        title: "Sustainable Practices",
                        description: "Marino Gems & Jewelleries promotes ethical mining and sustainable practices, preserving Sri Lanka’s natural resources and gem heritage."
                    }
                }
            }
        },
        ourproducts: {
            hero: {
                alt: "Our Products Background",
                timeless: "Timeless Elegance",
                title: "Our Exquisite Jewellery",
                description: "Discover our collection of meticulously crafted gemstones and jewellery, designed to celebrate individuality and timeless beauty."
            },
            section: {
                title: "Jewelleries and Stones",
                subtitle: "Explore our diverse range of gold and silver jewellery, along with precious and semi-precious stones, crafted to elevate your style."
            },
            viewMore: "View More",
            categories: {
                gold: {
                    title: "Gold Jewelleries",
                    desc: "Exquisite gold jewellery crafted with precision, blending timeless elegance with modern design."
                },
                silver: {
                    title: "Silver Jewelleries",
                    desc: "Elegant silver pieces that combine affordability with stunning craftsmanship for everyday wear."
                },
                precious: {
                    title: "Precious Stones",
                    desc: "Rare and vibrant precious stones, ethically sourced to create breathtaking jewellery."
                },
                semiPrecious: {
                    title: "Semi Precious Stones",
                    desc: "Colorful and unique semi-precious stones, perfect for bespoke and personalized designs."
                }
            }
        },
        // English (en)
        aboutus: {
            hero: {
                alt: "About Us Background",
                title: "About Us",
                subtitle: {
                    part1: "At Marino Gems & Jewellery, we bring the timeless beauty of",
                    highlight: "exquisite gems and craftsmanship",
                    part2: "to create unforgettable treasures."
                }
            },
            whoWeAre: {
                title: "Who We Are",
                subtitle: "Trusted, ethical, and exceptional gem and jewellery solutions backed by decades of expertise and a passion for craftsmanship.",
                imageAlt: "Marino Gems & Jewellery",
                text: {
                    part1: "At",
                    part2: ", we are dedicated to crafting exquisite gemstones and jewellery that reflect timeless beauty and exceptional quality. Our team has successfully sourced and crafted over",
                    pieces: "1000",
                    part3: "unique pieces, serving clients across",
                    regions: "Asia, Europe, North America, and beyond",
                    part4: ". With a deep commitment to ethical sourcing and masterful craftsmanship, we create bespoke designs that celebrate individuality and elegance."
                }
            },
            brandName: "Marino Gems & Jewellery",
            chairman: {
                title: "Chairman's Message",
                alt: "Chairman's Message",
                message: "\"At Marino Gems & Jewellery, our vision is to create timeless pieces that tell stories of elegance and craftsmanship. For over three decades, we have been committed to excellence, blending tradition with innovation to craft jewellery that resonates with beauty and meaning. Our passion drives us to uphold the highest standards of ethical sourcing and quality, ensuring that every piece we create becomes a cherished heirloom. I invite you to join us on this journey of creating extraordinary moments through our artistry.\"",
                signature: "- Chairman, Marino Gems & Jewellery"
            },
            team: {
                title: "Our Team",
                alt: "Our Team",
                text: {
                    part1: "Our team at",
                    part2: "comprises passionate artisans, skilled gemologists, and dedicated professionals who bring decades of expertise to every piece we create. With a shared commitment to excellence, our team collaborates to deliver",
                    highlight: "bespoke designs",
                    part3: "that embody elegance and precision, serving clients across",
                    regions: "Asia, Europe, North America, and beyond",
                    part4: ". We take pride in fostering creativity and innovation while upholding the highest standards of ethical craftsmanship."
                }
            },
            services: {
                title: "Our Services",
                subtitle: "Marino Gems & Jewellery offers a range of premium services, delivering exceptional craftsmanship and personalized experiences to clients worldwide.",
                alt: "Our Services",
                intro: "Our services are designed to provide unparalleled quality and satisfaction, ensuring every client’s vision is brought to life through:",
                crafting: "Crafting bespoke jewellery with exceptional quality",
                sourcing: "Sourcing ethically mined gemstones globally",
                consultations: "Providing personalized design consultations",
                repair: "Offering repair and restoration services"
            },
            contact: {
                alt: "About Contact Background",
                title: "Crafting Your Timeless Treasures",
                text: "Thank you for exploring Marino Gems & Jewellery. We are passionate about transforming your vision into exquisite, timeless pieces. From bespoke designs to expert consultations, our team is here to guide you every step of the way. Contact us today to begin your journey toward creating or restoring your cherished jewellery.",
                button: "Contact Us"
            }
        },
        // English (en)
        home: {
            hero: {
                title: "Discover Exquisite Gems & Jewellery",
                subtitle: {
                    highlight: "Explore our collection of world-class gems",
                    part2: "crafted with passion and precision."
                },
                buttons: {
                    explore: "Explore Collections",
                    contact: "Contact Us"
                }
            },
            kandy: {
                title: "Marino Gems and Jewellery",
                subtitle: "Experience the artistry and heritage of Marino Gems & Jewellery, crafted with excellence in the heart of Kandy."
            },
            services: {
                items: {
                    ethicalSourcing: {
                        title: "Ethical Gem Sourcing",
                        desc: "We source our gemstones responsibly from trusted mines, ensuring sustainability and support for local communities in Sri Lanka."
                    },
                    bespokeDesign: {
                        title: "Bespoke Jewellery Design",
                        desc: "Our artisans collaborate with you to create custom jewellery, blending your vision with our expertise for unique, timeless pieces."
                    },
                    expertCraftsmanship: {
                        title: "Expert Craftsmanship",
                        desc: "Every piece is handcrafted with precision in our Kandy workshop, using techniques honed over generations for unmatched quality."
                    },
                    globalExpertise: {
                        title: "Global Gem Expertise",
                        desc: "With deep knowledge of gemology, we offer world-class gems, including Sri Lankan sapphires, to clients across the globe."
                    },
                    trustedLegacy: {
                        title: "Trusted Legacy",
                        desc: "Marino Gems & Jewellery has built a reputation for excellence in Kandy, trusted by customers for quality and authenticity."
                    }
                }
            },
            achievements: {
                title: "Our Achievements",
                items: {
                    goldProducts: { title: "Gold Products" },
                    silverProducts: { title: "Silver Products" },
                    gemStones: { title: "Gem Stones" },
                    customers: { title: "Customers" }
                }
            },
            products: {
                title: "Our Products",
                subtitle: "Discover our exquisite range of jewellery and gemstones.",
                viewMore: "View More",
                view: "View",
                items: {
                    gold: {
                        title: "Gold Jewelleries",
                        desc: "Exquisite gold jewellery crafted with elegance and precision."
                    },
                    silver: {
                        title: "Silver Jewelleries",
                        desc: "Stunning silver pieces blending tradition and modernity."
                    },
                    precious: {
                        title: "Precious Stones",
                        desc: "Rare gemstones, including sapphires, for timeless beauty."
                    },
                    semiPrecious: {
                        title: "Semi Precious Stones",
                        desc: "Vibrant semi-precious stones for unique, affordable luxury."
                    }
                }
            },
            gallery: {
                title: "Our Gallery",
                subtitle: "A glimpse into our success stories, events, and the journeys we've made possible worldwide",
                images: {
                    gallery1: "Jewellery showcase event",
                    gallery2: "Handcrafted gold necklace display",
                    gallery3: "Kandy workshop crafting session",
                    gallery4: "Sri Lankan sapphire cutting process",
                    gallery5: "Customer jewellery consultation",
                    gallery6: "Marino Gems store opening event",
                    gallery7: "Silver jewellery collection launch",
                    gallery8: "Gemstone sourcing in Sri Lanka",
                    gallery9: "Bespoke jewellery design session",
                    gallery10: "Marino Gems team at trade show",
                    gallery11: "Customer trying on sapphire ring",
                    gallery12: "Award ceremony for craftsmanship"
                }
            },
            kandyImages: {
                kandy1: "Marino Gems Kandy store front",
                kandy2: "Interior showroom display",
                kandy3: "Gem cutting workshop",
                kandy4: "Jewellery crafting in progress",
                kandy5: "Customer consultation area"
            },
            testimonials: {
                title: "What Our Customers Say"
            }
        },
        // English (en)
        goldjewelleries: {
            hero: {
                alt: "Gold Jewelleries Background",
                title: "Exquisite Gold Jewellery",
                subtitle: {
                    highlight: "Timeless craftsmanship and elegance",
                    part2: "in every gold piece, designed for you."
                },
                buttons: {
                    categories: "Categories",
                    shopNow: "Shop Now"
                }
            },
            nav: {
                gold: "Gold Jewelleries",
                silver: "Silver Jewelleries",
                precious: "Precious Stones",
                semiPrecious: "Semi Precious Stones"
            },
            goldItems: {
                title: "Gold Items",
                subtitle: "Discover our stunning collection of gold jewellery, crafted with precision and elegance for every occasion."
            },
            categories: {
                rings: {
                    label: "Rings",
                    desc: "Elegant gold rings crafted with intricate designs for timeless beauty.",
                    images: {
                        1: "Gold Ring 1",
                        2: "Gold Ring 2",
                        3: "Gold Ring 3",
                        4: "Gold Ring 4"
                    }
                },
                pendants: {
                    label: "Pendants",
                    desc: "Stunning gold pendants to complement any necklace with sophistication.",
                    images: {
                        1: "Gold Pendant 1",
                        2: "Gold Pendant 2",
                        3: "Gold Pendant 3",
                        4: "Gold Pendant 4"
                    }
                },
                necklaces: {
                    label: "Necklaces",
                    desc: "Exquisite gold necklaces that elevate your style for any occasion.",
                    images: {
                        1: "Gold Necklace 1",
                        2: "Gold Necklace 2",
                        3: "Gold Necklace 3",
                        4: "Gold Necklace 4"
                    }
                },
                earrings: {
                    label: "Earrings",
                    desc: "Chic gold earrings blending modern trends with classic elegance.",
                    images: {
                        1: "Gold Earring 1",
                        2: "Gold Earring 2",
                        3: "Gold Earring 3",
                        4: "Gold Earring 4"
                    }
                },
                bracelets: {
                    label: "Bracelets",
                    desc: "Graceful gold bracelets designed to adorn your wrist with luxury.",
                    images: {
                        1: "Gold Bracelet 1",
                        2: "Gold Bracelet 2",
                        3: "Gold Bracelet 3",
                        4: "Gold Bracelet 4"
                    }
                },
                chains: {
                    label: "Chains",
                    desc: "Versatile gold chains, perfect for pendants or standalone wear.",
                    images: {
                        1: "Gold Chain 1",
                        2: "Gold Chain 2",
                        3: "Gold Chain 3",
                        4: "Gold Chain 4"
                    }
                },
                tiePins: {
                    label: "Tie Pins",
                    desc: "Sophisticated gold tie pins to add flair to formal attire.",
                    images: {
                        1: "Gold Tie Pin 1",
                        2: "Gold Tie Pin 2",
                        3: "Gold Tie Pin 3",
                        4: "Gold Tie Pin 4"
                    }
                },
                other: {
                    label: "Other Items",
                    desc: "Curated collection of gold items for a polished look.",
                    images: {
                        1: "Gold Item 1",
                        2: "Gold Item 2",
                        3: "Gold Item 3",
                        4: "Gold Item 4"
                    }
                }
            },
            view: "View"
        },
        // English (en)
        silverjewelleries: {
            hero: {
                alt: "Silver Jewelleries Background",
                title: "Exquisite Silver Jewellery",
                subtitle: {
                    highlight: "Modern elegance and craftsmanship",
                    part2: "in every silver piece, designed for you."
                },
                buttons: {
                    categories: "Categories",
                    shopNow: "Shop Now"
                }
            },
            nav: {
                gold: "Gold Jewelleries",
                silver: "Silver Jewelleries",
                precious: "Precious Stones",
                semiPrecious: "Semi Precious Stones"
            },
            silverItems: {
                title: "Silver Items",
                subtitle: "Explore our exquisite collection of silver jewellery, crafted with precision and style for every occasion."
            },
            categories: {
                rings: {
                    label: "Rings",
                    desc: "Sleek silver rings with modern designs for everyday elegance.",
                    images: {
                        1: "Silver Ring 1",
                        2: "Silver Ring 2",
                        3: "Silver Ring 3",
                        4: "Silver Ring 4"
                    }
                },
                pendants: {
                    label: "Pendants",
                    desc: "Chic silver pendants that add a touch of sophistication.",
                    images: {
                        1: "Silver Pendant 1",
                        2: "Silver Pendant 2",
                        3: "Silver Pendant 3",
                        4: "Silver Pendant 4"
                    }
                },
                necklaces: {
                    label: "Necklaces",
                    desc: "Stylish silver necklaces for a refined and versatile look.",
                    images: {
                        1: "Silver Necklace 1",
                        2: "Silver Necklace 2"
                    }
                },
                earrings: {
                    label: "Earrings",
                    desc: "Elegant silver earrings that blend trend with timeless charm.",
                    images: {
                        1: "Silver Earring 1",
                        2: "Silver Earring 2",
                        3: "Silver Earring 3"
                    }
                },
                bracelets: {
                    label: "Bracelets",
                    desc: "Sophisticated silver bracelets for a touch of luxury.",
                    images: {
                        1: "Silver Bracelet 1",
                        2: "Silver Bracelet 2",
                        3: "Silver Bracelet 3"
                    }
                },
                chains: {
                    label: "Chains",
                    desc: "Versatile silver chains, ideal for pendants or solo wear.",
                    images: {
                        1: "Silver Chain 1",
                        2: "Silver Chain 2",
                        3: "Silver Chain 3",
                        4: "Silver Chain 4"
                    }
                },
                tiePins: {
                    label: "Tie Pins",
                    desc: "Polished silver tie pins to enhance formal attire.",
                    images: {
                        1: "Silver Tie Pin 1"
                    }
                },
                bangles: {
                    label: "Bangles",
                    desc: "Classic silver bangles for a timeless accessory choice.",
                    images: {
                        1: "Silver Bangle 1"
                    }
                }
            },
            view: "View"
        },
        // English (en)
        preciousstones: {
            hero: {
                alt: "Precious Stones Background",
                title: "Exquisite Precious Stones",
                subtitle: {
                    highlight: "Timeless beauty and brilliance",
                    part2: "in every precious stone, crafted for you."
                },
                buttons: {
                    categories: "Categories",
                    shopNow: "Shop Now"
                }
            },
            nav: {
                gold: "Gold Jewelleries",
                silver: "Silver Jewelleries",
                precious: "Precious Stones",
                semiPrecious: "Semi Precious Stones"
            },
            stones: {
                title: "Precious Stones",
                subtitle: "Discover the brilliance of our precious stones, each selected for its exceptional quality and beauty.",
                sapphire: {
                    title: "Sapphires",
                    desc: "Deep blue sapphires, known for their stunning clarity and durability, perfect for elegant jewellery pieces."
                },
                ruby: {
                    title: "Ruby",
                    desc: "Vibrant red rubies, symbolizing passion and strength, ideal for bold and luxurious designs."
                },
                topaz: {
                    title: "Topaz",
                    desc: "Radiant blue topaz, offering a sparkling brilliance that enhances any jewellery collection."
                },
                amethyst: {
                    title: "Amethyst",
                    desc: "Rich purple amethysts, prized for their calming beauty and versatility in modern and classic styles."
                }
            }
        },
        // English (en)
        semipreciousstones: {
            hero: {
                alt: "Semi-Precious Stones Background",
                title: "Exquisite Semi-Precious Stones",
                subtitle: {
                    highlight: "Vibrant colors and unique charm",
                    part2: "in every semi-precious stone, crafted for you."
                },
                buttons: {
                    categories: "Categories",
                    shopNow: "Shop Now"
                }
            },
            nav: {
                gold: "Gold Jewelleries",
                silver: "Silver Jewelleries",
                precious: "Precious Stones",
                semiPrecious: "Semi Precious Stones"
            },
            stones: {
                title: "Semi-Precious Stones",
                subtitle: "Explore the vibrant allure of our semi-precious stones, each chosen for its unique beauty and versatility.",
                moonstone: {
                    title: "Moon Stones",
                    desc: "Ethereal moon stones, known for their shimmering glow and calming energy, perfect for unique jewellery."
                },
                citrine: {
                    title: "Citrine",
                    desc: "Sunny yellow citrine, radiating warmth and brilliance, ideal for vibrant jewellery pieces."
                },
                garnet: {
                    title: "Garnet",
                    desc: "Rich red garnet, valued for its warm hues and versatility in classic and modern designs."
                },
                quartz: {
                    title: "Quartz",
                    desc: "Clear or smoky quartz, prized for its clarity and adaptability in various jewellery styles."
                },
                turquoise: {
                    title: "Turquoise",
                    desc: "Vivid blue-green turquoise, cherished for its unique color and cultural significance in jewellery."
                },
                peridot: {
                    title: "Peridot",
                    desc: "Lush green peridot, celebrated for its refreshing sparkle and suitability for everyday wear."
                }
            }
        },
        // English (en)
        blogs: {
            hero: {
                alt: "Blogs Background",
                title: "Our Blogs",
                subtitle: {
                    part1: "Explore our collection of",
                    highlight: "insights and stories",
                    part2: "about gems, craftsmanship, and the artistry behind Marino Gems & Jewellery."
                }
            },
            posts: {
                title: "Latest Blog Posts",
                subtitle: "Dive into our latest articles to learn more about the world of gems, jewellery trends, and the artistry behind our creations.",
                readMore: "Read More",
                items: {
                    sapphires: {
                        title: "The Timeless Allure of Sri Lankan Sapphires",
                        excerpt: "Discover the rich history and unique qualities of Sri Lanka’s world-renowned sapphires.",
                        description: "Sri Lanka, known as the 'Gem Island,' has been a source of exquisite sapphires for over 2,000 years. Renowned for their vibrant blue hues and exceptional clarity, these gems have adorned royalty and collectors worldwide. From the ancient mines of Ratnapura to modern markets, Sri Lankan sapphires continue to captivate with their timeless beauty. At Marino Gems & Jewellery, we ethically source these gems to create stunning pieces that reflect their rich heritage and unparalleled quality. Learn about the geological factors that make these sapphires unique and why they remain a cornerstone of the global gem trade.",
                        altTexts: {
                            1: "Close-up of a vibrant blue Sri Lankan sapphire",
                            2: "Traditional sapphire mining in Ratnapura",
                            3: "Polished sapphire set in a jewellery piece"
                        }
                    },
                    crafting: {
                        title: "Crafting Bespoke Jewellery: Our Process",
                        excerpt: "Learn how Marino transforms raw gemstones into exquisite jewellery pieces.",
                        description: "At Marino Gems & Jewellery, our bespoke jewellery process blends artistry and precision. It begins with selecting ethically sourced gemstones, followed by collaborative design consultations with our clients. Our skilled artisans then craft each piece by hand, ensuring every detail aligns with the client’s vision. From cutting and polishing to setting and finishing, our process emphasizes quality and individuality. Discover the steps we take to transform raw materials into timeless treasures, and see why our craftsmanship sets us apart in the world of fine jewellery.",
                        altTexts: {
                            1: "Artisan cutting a gemstone with precision",
                            2: "Designer sketching a bespoke jewellery piece",
                            3: "Finished jewellery piece with intricate details"
                        }
                    },
                    ethical: {
                        title: "Trends in Ethical Gem Sourcing",
                        excerpt: "Explore the importance of ethical sourcing in the gem industry today.",
                        description: "Ethical sourcing is at the heart of modern jewellery trends. At Marino Gems & Jewellery, we prioritize sustainable practices to ensure our gemstones are mined responsibly, supporting local communities and minimizing environmental impact. This blog explores the rise of ethical sourcing, the certifications we adhere to, and how consumers are driving demand for transparency in the gem industry. Learn about the challenges and innovations shaping sustainable jewellery and how we maintain our commitment to ethical excellence in every piece we create.",
                        altTexts: {
                            1: "Ethically sourced gemstones in a mining site",
                            2: "Certification process for sustainable gems",
                            3: "Community benefiting from ethical mining"
                        }
                    },
                    history: {
                        title: "The History of Gem Mining in Sri Lanka",
                        excerpt: "Uncover the ancient techniques and modern methods of gem mining.",
                        description: "Gem mining in Sri Lanka dates back over 2,000 years, with traditional pit mining still practiced in regions like Ratnapura. This blog delves into the history of these ancient techniques, the evolution of modern mining methods, and their impact on Sri Lanka’s economy and culture. From the tools used by ancient miners to today’s sustainable practices, we explore how Marino Gems & Jewellery sources gems while preserving this rich heritage. Discover the stories behind the gems that make Sri Lanka a global gemstone hub.",
                        altTexts: {
                            1: "Traditional pit mining in Sri Lanka",
                            2: "Ancient tools used in gem mining",
                            3: "Modern sustainable mining equipment"
                        }
                    },
                    care: {
                        title: "Tips for Caring for Your Gemstone Jewellery",
                        excerpt: "Learn how to keep your jewellery sparkling with our expert care tips.",
                        description: "Proper care is essential to maintain the brilliance of your gemstone jewellery. This blog offers practical tips from Marino Gems & Jewellery’s experts, including cleaning techniques, storage advice, and how to avoid damage to precious gems and metals. Whether it’s a sapphire ring or a ruby necklace, our guide covers best practices for daily wear and long-term preservation. Discover how to ensure your jewellery remains a cherished heirloom for generations with simple, effective care routines tailored to different gemstones.",
                        altTexts: {
                            1: "Cleaning a sapphire ring with a soft cloth",
                            2: "Proper storage of gemstone jewellery",
                            3: "Inspecting a necklace for maintenance"
                        }
                    },
                    future: {
                        title: "The Future of Jewellery: Emerging Trends",
                        excerpt: "Explore the trends shaping the future of jewellery design.",
                        description: "The jewellery industry is evolving with new trends in design, materials, and technology. This blog explores what’s next for fine jewellery, from lab-grown gems to innovative 3D-printed designs and sustainable materials. At Marino Gems & Jewellery, we stay ahead of the curve, blending tradition with modern innovation to create pieces that resonate with today’s consumers. Learn about the influence of personalization, eco-conscious designs, and bold new styles that are redefining the future of jewellery craftsmanship.",
                        altTexts: {
                            1: "Lab-grown gemstone under inspection",
                            2: "3D-printed jewellery design prototype",
                            3: "Sustainable materials in jewellery crafting"
                        }
                    }
                }
            },
            modal: {
                close: "Close"
            }
        },
    },
    de: {
        navbar: {
            home: 'Startseite',
            jewelleriesStones: 'Schmuck & Steine',
            gemHistory: 'Geschichte der Edelsteine',
            blogs: 'Blogs',
            aboutUs: 'Über Uns',
            contactUs: 'Kontakt',
        },
        footer: {
            description: 'Marino Gems ist ein führendes Schmuckunternehmen in Sri Lanka, spezialisiert auf exquisite Kreationen aus Gold, Silber und Edelsteinen.',
            linksTitle: 'Links',
            contactTitle: 'Kontakt',
            copyright: '© Copyright {{year}} von Marino Gems',
            developedBy: 'Entwickelt von',
        },
        contact: {
            title: "Kontaktieren Sie uns",
            feelFree: "Fühlen Sie sich frei, uns zu kontaktieren",
            weAreHere: "Wir sind für Sie da – bei jedem Schritt",
            description: "Kontaktieren Sie Marino Gems & Jewellery für fachkundige Beratung und Unterstützung bei Ihren Edelstein- und Schmuckbedürfnissen.",
            callCenter: "Call Center",
            email: "E-Mail",
            ourLocation: "Unser Standort",
            socialNetwork: "Soziale Netzwerke",
            getInTouch: "Kontakt aufnehmen",
            formIntro: "Wir freuen uns auf Ihre Nachricht – unser Team steht bereit, Ihre Fragen zu beantworten und Sie zu beraten.",
            nameLabel: "Name",
            emailLabel: "E-Mail",
            contactNumberLabel: "Telefonnummer",
            messageLabel: "Nachricht",
            sendButton: "Nachricht senden",
            sending: "Wird gesendet...",
            successMessage: "Ihre Nachricht wurde an WhatsApp gesendet!",
            errorMessage: "WhatsApp konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.",
            findUs: "Finden Sie uns"
        },
        gemhistory: {
            hero: {
                title: "Edelstein-Geschichte",
                alt: "Hintergrund Edelstein-Geschichte",
                subtitle: {
                    part1: "Bei Marino Gems & Jewelleries feiern wir die reiche Geschichte von",
                    highlight: "Edelsteinen und Handwerkskunst",
                    part2: ", die seit Jahrhunderten zeitlose Schätze geformt haben."
                }
            },
            history: {
                title: "Geschichte der Edelsteine in Sri Lanka",
                subtitle: "Sri Lanka, bekannt als die „Edelstein-Insel“, blickt auf eine über 2.000 Jahre alte Tradition des Edelsteinabbaus und -handels zurück.",
                imageAlt: "Geschichte der Edelsteine in Sri Lanka",
                text: "Sri Lanka, oft als „Edelstein-Insel“ bezeichnet, ist seit über 2.000 Jahren ein weltweites Zentrum für Edel- und Schmucksteine. Berühmt für Saphire, Rubine und andere Edelsteine, haben die reichen Vorkommen in Gebieten wie Ratnapura seit jeher einen lebendigen Handel gefördert. Von den Höfen der Könige bis zu modernen Märkten schmückten sri-lankische Edelsteine Könige und Sammler weltweit. Traditionelle Abbaumethoden werden bis heute neben modernen Techniken praktiziert. Marino Gems & Jewelleries führt dieses Erbe fort und verwendet ethisch abgebauten Edelsteine für exquisite Schmuckstücke."
            },
            industry: {
                title: "Über die Edelsteinindustrie",
                subtitle: "Die globale Edelsteinindustrie verbindet alte Handwerkskunst mit moderner Innovation und schafft zeitlosen Wert.",
                imageAlt: "Über die Edelsteinindustrie",
                text: "Die Edelsteinindustrie ist eine dynamische Mischung aus Tradition und Technologie – vom Abbau über das Schleifen und den Handel bis zum Schmuckdesign. Mit einem globalen Wert von über 80 Milliarden US-Dollar lebt sie von der Faszination edler und halbedler Steine wie Saphire, Diamanten und Smaragde. Von alten Handelsrouten bis zu modernen Märkten sichert sie Millionen von Arbeitsplätzen, mit wichtigen Zentren in Sri Lanka, Thailand und Indien. Marino Gems & Jewelleries trägt zu dieser lebendigen Branche bei, indem wir ethische Beschaffung und nachhaltige Praktiken priorisieren – für Qualität und Verantwortung in jedem Stück."
            },
            importance: {
                title: "Bedeutung der Edelsteine in",
                country: "Sri Lanka",
                subtitle: "Entdecken Sie, warum Edelsteine ein Eckpfeiler des Erbes, der Wirtschaft und des globalen Rufs Sri Lankas sind.",
                items: {
                    culturalSignificance: {
                        title: "Kulturelle Bedeutung",
                        description: "Edelsteine sind seit Jahrhunderten fester Bestandteil der sri-lankischen Kultur – sie zieren königliche Insignien und religiöse Artefakte und symbolisieren Macht und Spiritualität."
                    },
                    economicImpact: {
                        title: "Wirtschaftliche Bedeutung",
                        description: "Die Edelsteinbranche ist ein wesentlicher Wirtschaftsfaktor Sri Lankas und schafft Arbeitsplätze sowie Einkommen in Bergbauregionen wie Ratnapura."
                    },
                    globalReputation: {
                        title: "Globaler Ruf",
                        description: "Sri Lankas Saphire und Rubine sind weltberühmt, ziehen internationale Käufer an und etablieren das Land als führendes Edelsteinzentrum."
                    },
                    sustainablePractices: {
                        title: "Nachhaltige Praktiken",
                        description: "Marino Gems & Jewelleries fördert ethischen Abbau und nachhaltige Methoden, um die natürlichen Ressourcen und das Edelstein-Erbe Sri Lankas zu bewahren."
                    }
                }
            }
        },
        ourproducts: {
            hero: {
                alt: "Hintergrund Unsere Produkte",
                timeless: "Zeitlose Eleganz",
                title: "Unser Exquisiter Schmuck",
                description: "Entdecken Sie unsere Sammlung sorgfältig gefertigter Edelsteine und Schmuckstücke, die Individualität und zeitlose Schönheit feiern."
            },
            section: {
                title: "Schmuck und Steine",
                subtitle: "Entdecken Sie unser vielfältiges Angebot an Gold- und Silberschmuck sowie Edel- und Halbedelsteinen, gefertigt um Ihren Stil zu unterstreichen."
            },
            viewMore: "Mehr anzeigen",
            categories: {
                gold: {
                    title: "Goldschmuck",
                    desc: "Exquisiter Goldschmuck, präzise gefertigt, der zeitlose Eleganz mit modernem Design verbindet."
                },
                silver: {
                    title: "Silberschmuck",
                    desc: "Elegante Silberstücke, die Erschwinglichkeit mit beeindruckender Handwerkskunst für den Alltag kombinieren."
                },
                precious: {
                    title: "Edelsteine",
                    desc: "Seltene und lebendige Edelsteine, ethisch gewonnen, um atemberaubenden Schmuck zu kreieren."
                },
                semiPrecious: {
                    title: "Halbedelsteine",
                    desc: "Farbenfrohe und einzigartige Halbedelsteine, ideal für individuelle und maßgeschneiderte Designs."
                }
            }
        },
        aboutus: {
            hero: {
                alt: "Über uns Hintergrund",
                title: "Über uns",
                subtitle: {
                    part1: "Bei Marino Gems & Jewellery bringen wir die zeitlose Schönheit von",
                    highlight: "exquisiten Edelsteinen und Handwerkskunst",
                    part2: "zum Leben, um unvergessliche Schätze zu schaffen."
                }
            },
            whoWeAre: {
                title: "Wer wir sind",
                subtitle: "Vertrauenswürdige, ethische und außergewöhnliche Lösungen für Edelsteine und Schmuck – gestützt auf jahrzehntelange Expertise und Leidenschaft für Handwerkskunst.",
                imageAlt: "Marino Gems & Jewellery",
                text: {
                    part1: "Bei",
                    part2: " widmen wir uns der Herstellung exquisiter Edelsteine und Schmuckstücke, die zeitlose Schönheit und außergewöhnliche Qualität widerspiegeln. Unser Team hat bereits über",
                    pieces: "1000",
                    part3: "einzigartige Stücke beschafft und gefertigt und Kunden in",
                    regions: "Asien, Europa, Nordamerika und darüber hinaus",
                    part4: " betreut. Mit tiefem Engagement für ethische Beschaffung und meisterhafte Handwerkskunst schaffen wir maßgeschneiderte Designs, die Individualität und Eleganz feiern."
                }
            },
            brandName: "Marino Gems & Jewellery",
            chairman: {
                title: "Botschaft des Vorsitzenden",
                alt: "Botschaft des Vorsitzenden",
                message: "\"Bei Marino Gems & Jewellery ist unsere Vision, zeitlose Stücke zu schaffen, die Geschichten von Eleganz und Handwerkskunst erzählen. Seit über drei Jahrzehnten setzen wir auf Exzellenz, verbinden Tradition mit Innovation und kreieren Schmuck, der Schönheit und Bedeutung ausstrahlt. Unsere Leidenschaft treibt uns an, höchste Standards in ethischer Beschaffung und Qualität einzuhalten, sodass jedes Stück zu einem geschätzten Erbstück wird. Ich lade Sie ein, uns auf dieser Reise zu begleiten und außergewöhnliche Momente durch unsere Kunst zu schaffen.\"",
                signature: "– Vorsitzender, Marino Gems & Jewellery"
            },
            team: {
                title: "Unser Team",
                alt: "Unser Team",
                text: {
                    part1: "Unser Team bei",
                    part2: "besteht aus leidenschaftlichen Kunsthandwerkern, erfahrenen Gemmologen und engagierten Fachleuten, die jahrzehntelange Expertise in jedes Stück einbringen. Mit gemeinsamer Verpflichtung zur Exzellenz arbeiten wir zusammen, um",
                    highlight: "maßgeschneiderte Designs",
                    part3: "zu schaffen, die Eleganz und Präzision verkörpern und Kunden in",
                    regions: "Asien, Europa, Nordamerika und darüber hinaus",
                    part4: " betreuen. Wir sind stolz darauf, Kreativität und Innovation zu fördern und gleichzeitig höchste Standards ethischer Handwerkskunst einzuhalten."
                }
            },
            services: {
                title: "Unsere Leistungen",
                subtitle: "Marino Gems & Jewellery bietet ein breites Spektrum an Premium-Dienstleistungen und liefert außergewöhnliche Handwerkskunst sowie persönliche Erlebnisse für Kunden weltweit.",
                alt: "Unsere Leistungen",
                intro: "Unsere Dienstleistungen sind darauf ausgelegt, höchste Qualität und Zufriedenheit zu bieten und die Vision jedes Kunden durch folgende Leistungen zum Leben zu erwecken:",
                crafting: "Herstellung maßgeschneiderter Schmuckstücke in außergewöhnlicher Qualität",
                sourcing: "Beschaffung ethisch abgebauter Edelsteine weltweit",
                consultations: "Persönliche Designberatung",
                repair: "Reparatur- und Restaurierungsservices"
            },
            contact: {
                alt: "Kontakt Hintergrund",
                title: "Ihre zeitlosen Schätze gestalten",
                text: "Vielen Dank, dass Sie Marino Gems & Jewellery entdecken. Wir brennen dafür, Ihre Vision in exquisite, zeitlose Stücke zu verwandeln. Von maßgeschneiderten Designs bis hin zu fachkundiger Beratung – unser Team begleitet Sie bei jedem Schritt. Kontaktieren Sie uns heute, um Ihre Reise zur Kreation oder Restaurierung Ihres geliebten Schmucks zu beginnen.",
                button: "Kontaktieren Sie uns"
            }
        },
        home: {
            hero: {
                title: "Entdecken Sie exquisite Edelsteine & Schmuck",
                subtitle: {
                    highlight: "Erkunden Sie unsere Kollektion weltklasse Edelsteine",
                    part2: "mit Leidenschaft und Präzision gefertigt."
                },
                buttons: {
                    explore: "Kollektionen entdecken",
                    contact: "Kontaktieren Sie uns"
                }
            },
            kandy: {
                title: "Marino Gems and Jewellery",
                subtitle: "Erleben Sie die Kunstfertigkeit und das Erbe von Marino Gems & Jewellery, mit Exzellenz im Herzen von Kandy gefertigt."
            },
            services: {
                items: {
                    ethicalSourcing: {
                        title: "Ethische Edelsteinbeschaffung",
                        desc: "Wir beziehen unsere Edelsteine verantwortungsvoll aus vertrauenswürdigen Minen und fördern Nachhaltigkeit sowie lokale Gemeinschaften in Sri Lanka."
                    },
                    bespokeDesign: {
                        title: "Maßgeschneiderter Schmuckdesign",
                        desc: "Unsere Kunsthandwerker arbeiten mit Ihnen zusammen, um individuellen Schmuck zu schaffen, der Ihre Vision mit unserer Expertise vereint."
                    },
                    expertCraftsmanship: {
                        title: "Experten-Handwerkskunst",
                        desc: "Jedes Stück wird präzise in unserer Werkstatt in Kandy handgefertigt, mit über Generationen verfeinerten Techniken."
                    },
                    globalExpertise: {
                        title: "Globale Edelstein-Expertise",
                        desc: "Mit tiefem Wissen über Gemmologie bieten wir weltklasse Edelsteine, darunter sri-lankische Saphire, weltweit an."
                    },
                    trustedLegacy: {
                        title: "Vertrauensvolles Erbe",
                        desc: "Marino Gems & Jewellery hat sich in Kandy einen Ruf für Exzellenz erworben, vertraut für Qualität und Authentizität."
                    }
                }
            },
            achievements: {
                title: "Unsere Erfolge",
                items: {
                    goldProducts: { title: "Goldprodukte" },
                    silverProducts: { title: "Silberprodukte" },
                    gemStones: { title: "Edelsteine" },
                    customers: { title: "Kunden" }
                }
            },
            products: {
                title: "Unsere Produkte",
                subtitle: "Entdecken Sie unser exquisites Sortiment an Schmuck und Edelsteinen.",
                viewMore: "Mehr anzeigen",
                view: "Ansehen",
                items: {
                    gold: {
                        title: "Goldschmuck",
                        desc: "Exquisiter Goldschmuck, elegant und präzise gefertigt."
                    },
                    silver: {
                        title: "Silberschmuck",
                        desc: "Atemberaubende Silberstücke, die Tradition und Moderne verbinden."
                    },
                    precious: {
                        title: "Edelsteine",
                        desc: "Seltene Edelsteine, darunter Saphire, für zeitlose Schönheit."
                    },
                    semiPrecious: {
                        title: "Halbedelsteine",
                        desc: "Lebendige Halbedelsteine für einzigartigen, erschwinglichen Luxus."
                    }
                }
            },
            gallery: {
                title: "Unsere Galerie",
                subtitle: "Ein Blick auf unsere Erfolgsgeschichten, Veranstaltungen und die Reisen, die wir weltweit möglich gemacht haben",
                images: {
                    gallery1: "Schmuck-Präsentationsveranstaltung",
                    gallery2: "Handgefertigte Goldkette Ausstellung",
                    gallery3: "Handwerkssession in der Kandy-Werkstatt",
                    gallery4: "Schliffprozess eines sri-lankischen Saphirs",
                    gallery5: "Kundenberatung zu Schmuck",
                    gallery6: "Eröffnungsveranstaltung des Marino Gems Geschäfts",
                    gallery7: "Launch der Silberschmuck-Kollektion",
                    gallery8: "Edelsteinbeschaffung in Sri Lanka",
                    gallery9: "Session für maßgeschneidertes Schmuckdesign",
                    gallery10: "Marino Gems Team auf einer Messe",
                    gallery11: "Kunde probiert Saphirring an",
                    gallery12: "Auszeichnungszeremonie für Handwerkskunst"
                }
            },
            kandyImages: {
                images: {
                    kandy1: "Marino Gems Geschäftsfassade in Kandy",
                    kandy2: "Innenansicht des Showrooms",
                    kandy3: "Edelsteinschliff-Werkstatt",
                    kandy4: "Schmuckherstellung in Arbeit",
                    kandy5: "Kundenberatungsbereich"
                }
            },
            testimonials: {
                title: "Was unsere Kunden sagen"
            }
        },
        goldjewelleries: {
            hero: {
                alt: "Gold-Schmuck Hintergrund",
                title: "Exquisiter Goldschmuck",
                subtitle: {
                    highlight: "Zeitlose Handwerkskunst und Eleganz",
                    part2: "in jedem Goldstück, für Sie entworfen."
                },
                buttons: {
                    categories: "Kategorien",
                    shopNow: "Jetzt shoppen"
                }
            },
            nav: {
                gold: "Goldschmuck",
                silver: "Silberschmuck",
                precious: "Edelsteine",
                semiPrecious: "Halbedelsteine"
            },
            goldItems: {
                title: "Goldartikel",
                subtitle: "Entdecken Sie unsere atemberaubende Kollektion an Goldschmuck, präzise und elegant für jeden Anlass gefertigt."
            },
            categories: {
                rings: {
                    label: "Ringe",
                    desc: "Elegante Goldringe mit filigranen Designs für zeitlose Schönheit.",
                    images: { 1: "Goldring 1", 2: "Goldring 2", 3: "Goldring 3", 4: "Goldring 4" }
                },
                pendants: {
                    label: "Anhänger",
                    desc: "Beeindruckende Goldanhänger, die jede Kette mit Raffinesse ergänzen.",
                    images: { 1: "Goldanhänger 1", 2: "Goldanhänger 2", 3: "Goldanhänger 3", 4: "Goldanhänger 4" }
                },
                necklaces: {
                    label: "Halsketten",
                    desc: "Exquisite Goldhalsketten, die Ihren Stil für jeden Anlass aufwerten.",
                    images: { 1: "Goldhalskette 1", 2: "Goldhalskette 2", 3: "Goldhalskette 3", 4: "Goldhalskette 4" }
                },
                earrings: {
                    label: "Ohrringe",
                    desc: "Schicke Goldohrringe, die moderne Trends mit klassischer Eleganz verbinden.",
                    images: { 1: "Goldohrring 1", 2: "Goldohrring 2", 3: "Goldohrring 3", 4: "Goldohrring 4" }
                },
                bracelets: {
                    label: "Armbänder",
                    desc: "Anmutige Goldarmbänder, die Ihr Handgelenk mit Luxus schmücken.",
                    images: { 1: "Goldarmband 1", 2: "Goldarmband 2", 3: "Goldarmband 3", 4: "Goldarmband 4" }
                },
                chains: {
                    label: "Ketten",
                    desc: "Vielseitige Goldketten, perfekt für Anhänger oder solo getragen.",
                    images: { 1: "Goldkette 1", 2: "Goldkette 2", 3: "Goldkette 3", 4: "Goldkette 4" }
                },
                tiePins: {
                    label: "Krawattennadeln",
                    desc: "Elegante Gold-Krawattennadeln für formelle Kleidung.",
                    images: { 1: "Gold-Krawattennadel 1", 2: "Gold-Krawattennadel 2", 3: "Gold-Krawattennadel 3", 4: "Gold-Krawattennadel 4" }
                },
                other: {
                    label: "Weitere Artikel",
                    desc: "Ausgewählte Kollektion von Goldartikeln für einen gepflegten Look.",
                    images: { 1: "Goldartikel 1", 2: "Goldartikel 2", 3: "Goldartikel 3", 4: "Goldartikel 4" }
                }
            },
            view: "Ansehen"
        },
        silverjewelleries: {
            hero: {
                alt: "Silberschmuck Hintergrund",
                title: "Exquisiter Silberschmuck",
                subtitle: {
                    highlight: "Moderne Eleganz und Handwerkskunst",
                    part2: "in jedem Silberstück, für Sie entworfen."
                },
                buttons: {
                    categories: "Kategorien",
                    shopNow: "Jetzt shoppen"
                }
            },
            nav: {
                gold: "Goldschmuck",
                silver: "Silberschmuck",
                precious: "Edelsteine",
                semiPrecious: "Halbedelsteine"
            },
            silverItems: {
                title: "Silberartikel",
                subtitle: "Entdecken Sie unsere exquisite Kollektion an Silberschmuck, präzise und stilvoll für jeden Anlass gefertigt."
            },
            categories: {
                rings: {
                    label: "Ringe",
                    desc: "Schlanke Silberringe mit modernem Design für tägliche Eleganz.",
                    images: {
                        1: "Silberring 1",
                        2: "Silberring 2",
                        3: "Silberring 3",
                        4: "Silberring 4"
                    }
                },
                pendants: {
                    label: "Anhänger",
                    desc: "Schicke Silberanhänger, die jeder Kette Raffinesse verleihen.",
                    images: {
                        1: "Silberanhänger 1",
                        2: "Silberanhänger 2",
                        3: "Silberanhänger 3",
                        4: "Silberanhänger 4"
                    }
                },
                necklaces: {
                    label: "Halsketten",
                    desc: "Stilvolle Silberhalsketten für einen raffinierten und vielseitigen Look.",
                    images: {
                        1: "Silberhalskette 1",
                        2: "Silberhalskette 2"
                    }
                },
                earrings: {
                    label: "Ohrringe",
                    desc: "Elegante Silberohrringe, die Trend mit zeitlosem Charme verbinden.",
                    images: {
                        1: "Silberohrring 1",
                        2: "Silberohrring 2",
                        3: "Silberohrring 3"
                    }
                },
                bracelets: {
                    label: "Armbänder",
                    desc: "Seriöse Silberarmbänder für einen Hauch von Luxus.",
                    images: {
                        1: "Silberarmband 1",
                        2: "Silberarmband 2",
                        3: "Silberarmband 3"
                    }
                },
                chains: {
                    label: "Ketten",
                    desc: "Vielseitige Silberketten, ideal für Anhänger oder solo getragen.",
                    images: {
                        1: "Silberkette 1",
                        2: "Silberkette 2",
                        3: "Silberkette 3",
                        4: "Silberkette 4"
                    }
                },
                tiePins: {
                    label: "Krawattennadeln",
                    desc: "Polierte Silber-Krawattennadeln zur Aufwertung formeller Kleidung.",
                    images: {
                        1: "Silber-Krawattennadel 1"
                    }
                },
                bangles: {
                    label: "Armreifen",
                    desc: "Klassische Silber-Armreifen für eine zeitlose Accessoire-Wahl.",
                    images: {
                        1: "Silber-Armreif 1"
                    }
                }
            },
            view: "Ansehen"
        },
        preciousstones: {
            hero: {
                alt: "Edelsteine Hintergrund",
                title: "Exquisite Edelsteine",
                subtitle: {
                    highlight: "Zeitlose Schönheit und Brillanz",
                    part2: "in jedem Edelstein, für Sie gefertigt."
                },
                buttons: {
                    categories: "Kategorien",
                    shopNow: "Jetzt shoppen"
                }
            },
            nav: {
                gold: "Goldschmuck",
                silver: "Silberschmuck",
                precious: "Edelsteine",
                semiPrecious: "Halbedelsteine"
            },
            stones: {
                title: "Edelsteine",
                subtitle: "Entdecken Sie die Brillanz unserer Edelsteine, jeder ausgewählt für außergewöhnliche Qualität und Schönheit.",
                sapphire: {
                    title: "Saphire",
                    desc: "Tiefblaue Saphire, bekannt für ihre atemberaubende Klarheit und Haltbarkeit, perfekt für elegante Schmuckstücke."
                },
                ruby: {
                    title: "Rubin",
                    desc: "Lebhaft rote Rubine, Symbol für Leidenschaft und Stärke, ideal für kühne und luxuriöse Designs."
                },
                topaz: {
                    title: "Topas",
                    desc: "Strahlender blauer Topas, der mit funkelnder Brillanz jede Schmuckkollektion bereichert."
                },
                amethyst: {
                    title: "Amethyst",
                    desc: "Reich violette Amethyste, geschätzt für ihre beruhigende Schönheit und Vielseitigkeit in modernen und klassischen Stilen."
                }
            }
        },
        semipreciousstones: {
            hero: {
                alt: "Halbedelsteine Hintergrund",
                title: "Exquisite Halbedelsteine",
                subtitle: {
                    highlight: "Lebendige Farben und einzigartiger Charme",
                    part2: "in jedem Halbedelstein, für Sie gefertigt."
                },
                buttons: {
                    categories: "Kategorien",
                    shopNow: "Jetzt shoppen"
                }
            },
            nav: {
                gold: "Goldschmuck",
                silver: "Silberschmuck",
                precious: "Edelsteine",
                semiPrecious: "Halbedelsteine"
            },
            stones: {
                title: "Halbedelsteine",
                subtitle: "Entdecken Sie die lebendige Anziehungskraft unserer Halbedelsteine, jeder ausgewählt für seine einzigartige Schönheit und Vielseitigkeit.",
                moonstone: {
                    title: "Mondsteine",
                    desc: "Ätherische Mondsteine, bekannt für ihren schimmernden Glanz und ihre beruhigende Energie, perfekt für einzigartigen Schmuck."
                },
                citrine: {
                    title: "Citrin",
                    desc: "Sonnen-gelber Citrin, der Wärme und Brillanz ausstrahlt, ideal für lebendige Schmuckstücke."
                },
                garnet: {
                    title: "Granat",
                    desc: "Reich roter Granat, geschätzt für seine warmen Töne und Vielseitigkeit in klassischen und modernen Designs."
                },
                quartz: {
                    title: "Quarz",
                    desc: "Klarer oder rauchiger Quarz, geschätzt für seine Klarheit und Anpassungsfähigkeit in verschiedenen Schmuckstilen."
                },
                turquoise: {
                    title: "Türkis",
                    desc: "Lebhaft blau-grüner Türkis, geschätzt für seine einzigartige Farbe und kulturelle Bedeutung im Schmuck."
                },
                peridot: {
                    title: "Peridot",
                    desc: "Üppig grüner Peridot, gefeiert für seinen erfrischenden Glanz und seine Eignung für den Alltag."
                }
            }
        },
        // ────────────────────────────────────────────────
        // German (de)
        blogs: {
            hero: {
                alt: "Blogs Hintergrund",
                title: "Unsere Blogs",
                subtitle: {
                    part1: "Entdecken Sie unsere Sammlung von",
                    highlight: "Einblicken und Geschichten",
                    part2: "über Edelsteine, Handwerkskunst und die Kunst hinter Marino Gems & Jewellery."
                }
            },
            posts: {
                title: "Neueste Blogbeiträge",
                subtitle: "Tauchen Sie ein in unsere neuesten Artikel und erfahren Sie mehr über die Welt der Edelsteine, Schmucktrends und die Kunstfertigkeit unserer Kreationen.",
                readMore: "Mehr lesen",
                items: {
                    sapphires: {
                        title: "Die zeitlose Faszination sri-lankischer Saphire",
                        excerpt: "Entdecken Sie die reiche Geschichte und einzigartigen Eigenschaften der weltberühmten Saphire Sri Lankas.",
                        description: "Sri Lanka, bekannt als „Edelstein-Insel“, ist seit über 2.000 Jahren Quelle exquisiter Saphire. Berühmt für ihre lebhaften Blautöne und außergewöhnliche Klarheit, schmückten diese Edelsteine Könige und Sammler weltweit. Von den alten Minen Ratnapuras bis zu modernen Märkten faszinieren sri-lankische Saphire mit zeitloser Schönheit. Bei Marino Gems & Jewellery beziehen wir diese Edelsteine ethisch und schaffen atemberaubende Stücke, die ihr reiches Erbe und ihre unvergleichliche Qualität widerspiegeln. Erfahren Sie mehr über die geologischen Faktoren, die diese Saphire einzigartig machen und warum sie ein Eckpfeiler des globalen Edelsteinhandels bleiben.",
                        altTexts: {
                            1: "Nahaufnahme eines lebhaften blauen sri-lankischen Saphirs",
                            2: "Traditioneller Saphirabbau in Ratnapura",
                            3: "Polierter Saphir in einem Schmuckstück gefasst"
                        }
                    },
                    crafting: {
                        title: "Maßgeschneiderter Schmuck: Unser Herstellungsprozess",
                        excerpt: "Erfahren Sie, wie Marino rohe Edelsteine in exquisite Schmuckstücke verwandelt.",
                        description: "Bei Marino Gems & Jewellery verbindet unser Prozess für maßgeschneiderten Schmuck Kunstfertigkeit und Präzision. Er beginnt mit der Auswahl ethisch bezogener Edelsteine, gefolgt von gemeinsamen Designberatungen mit unseren Kunden. Unsere geschickten Kunsthandwerker fertigen jedes Stück von Hand, sodass jedes Detail der Vision des Kunden entspricht. Vom Schneiden und Polieren bis zum Fassen und Finishen steht Qualität und Individualität im Mittelpunkt. Entdecken Sie die Schritte, mit denen wir Rohmaterialien in zeitlose Schätze verwandeln, und warum unsere Handwerkskunst in der Welt des feinen Schmucks heraussticht.",
                        altTexts: {
                            1: "Kunsthandwerker schneidet einen Edelstein präzise",
                            2: "Designer skizziert ein maßgeschneidertes Schmuckstück",
                            3: "Fertiggestelltes Schmuckstück mit filigranen Details"
                        }
                    },
                    ethical: {
                        title: "Trends bei ethischer Edelsteinbeschaffung",
                        excerpt: "Erfahren Sie, warum ethische Beschaffung heute in der Edelsteinbranche so wichtig ist.",
                        description: "Ethische Beschaffung steht im Mittelpunkt moderner Schmucktrends. Bei Marino Gems & Jewellery legen wir großen Wert auf nachhaltige Praktiken, um sicherzustellen, dass unsere Edelsteine verantwortungsvoll abgebaut werden, lokale Gemeinschaften unterstützt und die Umwelt geschont wird. Dieser Beitrag beleuchtet den Aufstieg ethischer Beschaffung, die Zertifizierungen, an die wir uns halten, und wie Verbraucher Transparenz in der Branche fordern. Erfahren Sie mehr über die Herausforderungen und Innovationen, die nachhaltigen Schmuck prägen, und wie wir unser Engagement für ethische Exzellenz in jedem Stück leben.",
                        altTexts: {
                            1: "Ethisch gewonnene Edelsteine in einer Mine",
                            2: "Zertifizierungsprozess für nachhaltige Edelsteine",
                            3: "Gemeinde profitiert von ethischem Bergbau"
                        }
                    },
                    history: {
                        title: "Die Geschichte des Edelsteinabbaus auf Sri Lanka",
                        excerpt: "Entdecken Sie alte Techniken und moderne Methoden des Edelsteinabbaus.",
                        description: "Der Edelsteinabbau auf Sri Lanka reicht über 2.000 Jahre zurück – traditioneller Schachtabbau wird in Regionen wie Ratnapura bis heute praktiziert. Dieser Beitrag taucht in die Geschichte dieser alten Techniken ein, zeigt die Entwicklung moderner Abbaumethoden und deren Einfluss auf Wirtschaft und Kultur Sri Lankas. Von den Werkzeugen antiker Bergleute bis zu heutigen nachhaltigen Praktiken beleuchten wir, wie Marino Gems & Jewellery Edelsteine bezieht und dieses reiche Erbe bewahrt. Erfahren Sie die Geschichten hinter den Steinen, die Sri Lanka zum weltweiten Edelsteinzentrum gemacht haben.",
                        altTexts: {
                            1: "Traditioneller Schachtabbau auf Sri Lanka",
                            2: "Antike Werkzeuge beim Edelsteinabbau",
                            3: "Moderne nachhaltige Abbautechnik"
                        }
                    },
                    care: {
                        title: "Pflegetipps für Ihren Edelsteinschmuck",
                        excerpt: "Erfahren Sie, wie Sie Ihren Schmuck mit unseren Experten-Tipps strahlend halten.",
                        description: "Richtige Pflege ist entscheidend, um die Brillanz Ihres Edelsteinschmucks zu bewahren. Dieser Beitrag gibt praktische Tipps unserer Experten bei Marino Gems & Jewellery: Reinigungsmethoden, richtige Aufbewahrung und wie man Schäden an Edelsteinen und Metallen vermeidet. Ob Saphirring oder Rubin-Halskette – unser Leitfaden zeigt die besten Praktiken für den Alltag und die langfristige Erhaltung. Erfahren Sie, wie Sie Ihren Schmuck mit einfachen Routinen über Generationen hinweg als geschätztes Erbstück bewahren.",
                        altTexts: {
                            1: "Reinigung eines Saphirrings mit weichem Tuch",
                            2: "Richtige Aufbewahrung von Edelsteinschmuck",
                            3: "Überprüfung einer Halskette auf Pflegebedarf"
                        }
                    },
                    future: {
                        title: "Die Zukunft des Schmucks: Neue Trends",
                        excerpt: "Erkunden Sie die Trends, die das Design der Zukunft prägen.",
                        description: "Die Schmuckbranche entwickelt sich weiter – neue Trends in Design, Materialien und Technologie bestimmen die Zukunft. Dieser Beitrag zeigt, was als Nächstes kommt: Labor-gezüchtete Edelsteine, innovative 3D-gedruckte Designs und nachhaltige Materialien. Bei Marino Gems & Jewellery verbinden wir Tradition mit moderner Innovation, um Stücke zu schaffen, die heutige Kunden ansprechen. Erfahren Sie mehr über Personalisierung, umweltbewusste Designs und mutige neue Stile, die die Zukunft der Schmuckkunst neu definieren.",
                        altTexts: {
                            1: "Labor-gezüchteter Edelstein unter Inspektion",
                            2: "3D-gedruckter Schmuckdesign-Prototyp",
                            3: "Nachhaltige Materialien in der Schmuckherstellung"
                        }
                    }
                }
            },
            modal: {
                close: "Schließen"
            }
        },
    },
    ru: {
        navbar: {
            home: 'Главная',
            jewelleriesStones: 'Ювелирные изделия и камни',
            gemHistory: 'История драгоценных камней',
            blogs: 'Блоги',
            aboutUs: 'О нас',
            contactUs: 'Связаться с нами',
        },
        footer: {
            description: 'Marino Gems — ведущая ювелирная компания Шри-Ланки, специализирующаяся на изысканных изделиях из золота, серебра и драгоценных камней.',
            linksTitle: 'Ссылки',
            contactTitle: 'Контакты',
            copyright: '© Copyright {{year}} Marino Gems',
            developedBy: 'Разработано',
        },
        contact: {
            title: "Свяжитесь с нами",
            feelFree: "Не стесняйтесь связаться с нами",
            weAreHere: "Мы здесь, чтобы помочь вам на каждом этапе",
            description: "Свяжитесь с Marino Gems & Jewellery для экспертной консультации и поддержки по вашим потребностям в драгоценных камнях и ювелирных изделиях.",
            callCenter: "Колл-центр",
            email: "Электронная почта",
            ourLocation: "Наше местоположение",
            socialNetwork: "Социальные сети",
            getInTouch: "Связаться",
            formIntro: "Мы будем рады услышать вас — наша команда готова ответить на ваши вопросы и помочь вам.",
            nameLabel: "Имя",
            emailLabel: "Электронная почта",
            contactNumberLabel: "Номер телефона",
            messageLabel: "Сообщение",
            sendButton: "Отправить сообщение",
            sending: "Отправка...",
            successMessage: "Ваше сообщение отправлено в WhatsApp!",
            errorMessage: "Не удалось открыть WhatsApp. Пожалуйста, попробуйте снова.",
            findUs: "Найдите нас"
        },
        gemhistory: {
            hero: {
                title: "История драгоценных камней",
                alt: "Фон истории драгоценных камней",
                subtitle: {
                    part1: "В Marino Gems & Jewelleries мы прославляем богатую историю",
                    highlight: "драгоценных камней и мастерства",
                    part2: ", которые на протяжении веков создавали вечные сокровища."
                }
            },
            history: {
                title: "История драгоценных камней на Шри-Ланке",
                subtitle: "Шри-Ланка, известная как «Остров драгоценных камней», имеет более чем 2000-летнюю историю добычи и торговли камнями.",
                imageAlt: "История драгоценных камней на Шри-Ланке",
                text: "Шри-Ланка, часто называемая «Островом драгоценных камней», уже более 2000 лет является мировым центром добычи и торговли драгоценными и полудрагоценными камнями. Знаменитые сапфиры, рубины и другие камни, добываемые в районах вроде Ратнапуры, издавна поддерживали оживлённую торговлю. От королевских дворов до современных рынков шри-ланкийские камни украшали монархов и коллекционеров по всему миру. Традиционные методы добычи до сих пор сосуществуют с современными технологиями. Marino Gems & Jewelleries продолжает это наследие, используя этично добытые камни для создания изысканных ювелирных изделий."
            },
            industry: {
                title: "О геммологической индустрии",
                subtitle: "Мировая индустрия драгоценных камней сочетает древнее мастерство с современными инновациями, создавая вечную ценность.",
                imageAlt: "О геммологической индустрии",
                text: "Индустрия драгоценных камней — это динамичное сочетание традиций и технологий: от добычи и огранки до торговли и ювелирного дизайна. Оцениваемая более чем в 80 миллиардов долларов, она живёт за счёт притягательности сапфиров, алмазов, изумрудов и других камней. От древних торговых путей до современных рынков отрасль обеспечивает миллионы рабочих мест, с ключевыми центрами на Шри-Ланке, в Таиланде и Индии. Marino Gems & Jewelleries вносит свой вклад в эту яркую отрасль, уделяя приоритет этичной добыче и устойчивым практикам — каждое изделие отражает качество и ответственность."
            },
            importance: {
                title: "Значение драгоценных камней в",
                country: "Шри-Ланке",
                subtitle: "Узнайте, почему драгоценные камни — это краеугольный камень наследия, экономики и мировой репутации Шри-Ланки.",
                items: {
                    culturalSignificance: {
                        title: "Культурное значение",
                        description: "Драгоценные камни веками были неотъемлемой частью культуры Шри-Ланки, украшая королевские регалии и религиозные артефакты, символизируя власть и духовность."
                    },
                    economicImpact: {
                        title: "Экономическое значение",
                        description: "Индустрия драгоценных камней — важный фактор экономики Шри-Ланки, создающий рабочие места и поддерживающий сообщества в горнодобывающих регионах, таких как Ратнапура."
                    },
                    globalReputation: {
                        title: "Мировая репутация",
                        description: "Сапфиры и рубины Шри-Ланки всемирно известны, привлекают международных покупателей и закрепляют за страной статус ведущего центра драгоценных камней."
                    },
                    sustainablePractices: {
                        title: "Устойчивые практики",
                        description: "Marino Gems & Jewelleries продвигает этичную добычу и устойчивые методы, сохраняя природные ресурсы и геммологическое наследие Шри-Ланки."
                    }
                }
            }
        },
        ourproducts: {
            hero: {
                alt: "Фон наших продуктов",
                timeless: "Вневременная элегантность",
                title: "Наши изысканные ювелирные изделия",
                description: "Откройте для себя нашу коллекцию тщательно изготовленных драгоценных камней и ювелирных изделий, созданных для того, чтобы подчеркнуть индивидуальность и вечную красоту."
            },
            section: {
                title: "Ювелирные изделия и камни",
                subtitle: "Исследуйте наш разнообразный ассортимент золотых и серебряных украшений, а также драгоценных и полудрагоценных камней, созданных чтобы подчеркнуть ваш стиль."
            },
            viewMore: "Подробнее",
            categories: {
                gold: {
                    title: "Золотые украшения",
                    desc: "Изысканные золотые украшения, изготовленные с высокой точностью, сочетающие вневременную элегантность с современным дизайном."
                },
                silver: {
                    title: "Серебряные украшения",
                    desc: "Элегантные серебряные изделия, сочетающие доступность с потрясающим мастерством для повседневного ношения."
                },
                precious: {
                    title: "Драгоценные камни",
                    desc: "Редкие и яркие драгоценные камни, добытые этично, для создания захватывающих ювелирных изделий."
                },
                semiPrecious: {
                    title: "Полудрагоценные камни",
                    desc: "Яркие и уникальные полудрагоценные камни, идеальные для индивидуальных и персонализированных дизайнов."
                }
            }
        },
        aboutus: {
            hero: {
                alt: "Фон О нас",
                title: "О нас",
                subtitle: {
                    part1: "В Marino Gems & Jewellery мы воплощаем вечную красоту",
                    highlight: "изысканных драгоценных камней и мастерства",
                    part2: ", создавая незабываемые сокровища."
                }
            },
            whoWeAre: {
                title: "Кто мы",
                subtitle: "Надёжные, этичные и исключительные решения в области драгоценных камней и ювелирных изделий, подкреплённые десятилетиями опыта и страстью к ремеслу.",
                imageAlt: "Marino Gems & Jewellery",
                text: {
                    part1: "В",
                    part2: " мы посвящаем себя созданию изысканных драгоценных камней и ювелирных изделий, отражающих вечную красоту и исключительное качество. Наша команда успешно добыла и изготовила более",
                    pieces: "1000",
                    part3: "уникальных изделий и обслуживает клиентов по всему",
                    regions: "Азии, Европе, Северной Америке и далее",
                    part4: ". С глубокой приверженностью этичной добыче и мастерству мы создаём изделия на заказ, которые прославляют индивидуальность и элегантность."
                }
            },
            brandName: "Marino Gems & Jewellery",
            chairman: {
                title: "Послание председателя",
                alt: "Послание председателя",
                message: "\"В Marino Gems & Jewellery наша цель — создавать вечные изделия, которые рассказывают истории элегантности и мастерства. Более трёх десятилетий мы стремимся к совершенству, соединяя традиции с инновациями, чтобы создавать ювелирные изделия, наполненные красотой и смыслом. Наша страсть побуждает нас поддерживать высочайшие стандарты этичной добычи и качества, чтобы каждое изделие становилось семейной реликвией. Приглашаю вас присоединиться к нашему путешествию по созданию незабываемых моментов через наше искусство.\"",
                signature: "– Председатель, Marino Gems & Jewellery"
            },
            team: {
                title: "Наша команда",
                alt: "Наша команда",
                text: {
                    part1: "Наша команда в",
                    part2: "состоит из страстных мастеров, квалифицированных геммологов и преданных профессионалов, которые вкладывают десятилетия опыта в каждое изделие. Благодаря общей приверженности совершенству, наша команда создаёт",
                    highlight: "уникальные дизайны на заказ",
                    part3: ", воплощающие элегантность и точность, и обслуживает клиентов по всему",
                    regions: "Азии, Европе, Северной Америке и далее",
                    part4: ". Мы гордимся тем, что развиваем творчество и инновации, сохраняя при этом высочайшие стандарты этичного мастерства."
                }
            },
            services: {
                title: "Наши услуги",
                subtitle: "Marino Gems & Jewellery предлагает широкий спектр премиальных услуг, обеспечивая исключительное мастерство и персонализированный опыт для клиентов по всему миру.",
                alt: "Наши услуги",
                intro: "Наши услуги разработаны для обеспечения непревзойдённого качества и удовлетворённости, воплощая видение каждого клиента через следующие направления:",
                crafting: "Создание уникальных ювелирных изделий исключительного качества",
                sourcing: "Закупка этично добытых драгоценных камней по всему миру",
                consultations: "Персональные консультации по дизайну",
                repair: "Услуги по ремонту и реставрации"
            },
            contact: {
                alt: "Фон раздела контактов",
                title: "Создание ваших вечных сокровищ",
                text: "Спасибо, что открыли для себя Marino Gems & Jewellery. Мы с энтузиазмом превращаем ваше видение в изысканные, вечные изделия. От уникальных дизайнов до экспертных консультаций — наша команда сопровождает вас на каждом этапе. Свяжитесь с нами сегодня, чтобы начать путь к созданию или восстановлению вашего любимого ювелирного изделия.",
                button: "Связаться с нами"
            }
        },
        home: {
            hero: {
                title: "Откройте для себя изысканные драгоценные камни и ювелирные изделия",
                subtitle: {
                    highlight: "Исследуйте нашу коллекцию драгоценных камней мирового класса",
                    part2: "созданных со страстью и точностью."
                },
                buttons: {
                    explore: "Посмотреть коллекции",
                    contact: "Связаться с нами"
                }
            },
            kandy: {
                title: "Marino Gems and Jewellery",
                subtitle: "Погрузитесь в искусство и наследие Marino Gems & Jewellery, созданное с совершенством в сердце Канди."
            },
            services: {
                items: {
                    ethicalSourcing: {
                        title: "Этичная добыча драгоценных камней",
                        desc: "Мы ответственно закупаем камни из проверенных шахт, поддерживая устойчивое развитие и местные сообщества на Шри-Ланке."
                    },
                    bespokeDesign: {
                        title: "Индивидуальный дизайн ювелирных изделий",
                        desc: "Наши мастера совместно с вами создают уникальные украшения, соединяя ваше видение с нашим опытом."
                    },
                    expertCraftsmanship: {
                        title: "Экспертное мастерство",
                        desc: "Каждое изделие изготавливается вручную в нашей мастерской в Канди с использованием проверенных поколениями техник."
                    },
                    globalExpertise: {
                        title: "Глобальная экспертиза в геммологии",
                        desc: "Благодаря глубоким знаниям геммологии мы предлагаем камни мирового класса, включая сри-ланкийские сапфиры, клиентам по всему миру."
                    },
                    trustedLegacy: {
                        title: "Надёжное наследие",
                        desc: "Marino Gems & Jewellery заслужил репутацию превосходства в Канди, клиенты доверяют нам за качество и подлинность."
                    }
                }
            },
            achievements: {
                title: "Наши достижения",
                items: {
                    goldProducts: { title: "Золотые изделия" },
                    silverProducts: { title: "Серебряные изделия" },
                    gemStones: { title: "Драгоценные камни" },
                    customers: { title: "Клиенты" }
                }
            },
            products: {
                title: "Наши продукты",
                subtitle: "Откройте для себя наш изысканный ассортимент ювелирных изделий и драгоценных камней.",
                viewMore: "Подробнее",
                view: "Посмотреть",
                items: {
                    gold: {
                        title: "Золотые ювелирные изделия",
                        desc: "Изысканные золотые украшения, созданные с элегантностью и точностью."
                    },
                    silver: {
                        title: "Серебряные ювелирные изделия",
                        desc: "Потрясающие серебряные изделия, сочетающие традиции и современность."
                    },
                    precious: {
                        title: "Драгоценные камни",
                        desc: "Редкие камни, включая сапфиры, для вечной красоты."
                    },
                    semiPrecious: {
                        title: "Полудрагоценные камни",
                        desc: "Яркие полудрагоценные камни для уникальной и доступной роскоши."
                    }
                }
            },
            gallery: {
                title: "Наша галерея",
                subtitle: "Взгляд на наши истории успеха, события и путешествия, которые мы сделали возможными по всему миру",
                images: {
                    gallery1: "Презентация ювелирных изделий",
                    gallery2: "Выставка ручной работы золотого ожерелья",
                    gallery3: "Сессия изготовления в мастерской Канди",
                    gallery4: "Процесс огранки сри-ланкийского сапфира",
                    gallery5: "Консультация клиента по ювелирным изделиям",
                    gallery6: "Открытие магазина Marino Gems",
                    gallery7: "Запуск коллекции серебряных украшений",
                    gallery8: "Закупка драгоценных камней на Шри-Ланке",
                    gallery9: "Сессия индивидуального дизайна ювелирных изделий",
                    gallery10: "Команда Marino Gems на выставке",
                    gallery11: "Клиент примеряет кольцо с сапфиром",
                    gallery12: "Церемония награждения за мастерство"
                }
            },
            kandyImages: {
                images: {
                    kandy1: "Фасад магазина Marino Gems в Канди",
                    kandy2: "Интерьер шоурума",
                    kandy3: "Мастерская огранки камней",
                    kandy4: "Процесс изготовления ювелирных изделий",
                    kandy5: "Зона консультаций с клиентами"
                }
            },
            testimonials: {
                title: "Что говорят наши клиенты"
            }
        },
        goldjewelleries: {
            hero: {
                alt: "Фон золотых ювелирных изделий",
                title: "Изысканные золотые украшения",
                subtitle: {
                    highlight: "Вневременное мастерство и элегантность",
                    part2: "в каждом золотом изделии, созданном для вас."
                },
                buttons: {
                    categories: "Категории",
                    shopNow: "Купить сейчас"
                }
            },
            nav: {
                gold: "Золотые украшения",
                silver: "Серебряные украшения",
                precious: "Драгоценные камни",
                semiPrecious: "Полудрагоценные камни"
            },
            goldItems: {
                title: "Золотые изделия",
                subtitle: "Откройте нашу потрясающую коллекцию золотых украшений, созданных с точностью и элегантностью для любого случая."
            },
            categories: {
                rings: {
                    label: "Кольца",
                    desc: "Элегантные золотые кольца с изысканными дизайнами для вечной красоты.",
                    images: { 1: "Золотое кольцо 1", 2: "Золотое кольцо 2", 3: "Золотое кольцо 3", 4: "Золотое кольцо 4" }
                },
                pendants: {
                    label: "Подвески",
                    desc: "Потрясающие золотые подвески, идеально дополняющие любую цепочку.",
                    images: { 1: "Золотая подвеска 1", 2: "Золотая подвеска 2", 3: "Золотая подвеска 3", 4: "Золотая подвеска 4" }
                },
                necklaces: {
                    label: "Ожерелья",
                    desc: "Изысканные золотые ожерелья, подчеркивающие ваш стиль в любой ситуации.",
                    images: { 1: "Золотое ожерелье 1", 2: "Золотое ожерелье 2", 3: "Золотое ожерелье 3", 4: "Золотое ожерелье 4" }
                },
                earrings: {
                    label: "Серьги",
                    desc: "Шикарные золотые серьги, сочетающие современные тренды и классическую элегантность.",
                    images: { 1: "Золотые серьги 1", 2: "Золотые серьги 2", 3: "Золотые серьги 3", 4: "Золотые серьги 4" }
                },
                bracelets: {
                    label: "Браслеты",
                    desc: "Грациозные золотые браслеты, созданные для роскошного украшения запястья.",
                    images: { 1: "Золотой браслет 1", 2: "Золотой браслет 2", 3: "Золотой браслет 3", 4: "Золотой браслет 4" }
                },
                chains: {
                    label: "Цепочки",
                    desc: "Универсальные золотые цепочки, идеальные для подвесок или самостоятельного ношения.",
                    images: { 1: "Золотая цепочка 1", 2: "Золотая цепочка 2", 3: "Золотая цепочка 3", 4: "Золотая цепочка 4" }
                },
                tiePins: {
                    label: "Запонки для галстука",
                    desc: "Изысканные золотые запонки для галстука, добавляющие изюминку формальному стилю.",
                    images: { 1: "Золотая запонка 1", 2: "Золотая запонка 2", 3: "Золотая запонка 3", 4: "Золотая запонка 4" }
                },
                other: {
                    label: "Другие изделия",
                    desc: "Подборка золотых изделий для элегантного образа.",
                    images: { 1: "Золотое изделие 1", 2: "Золотое изделие 2", 3: "Золотое изделие 3", 4: "Золотое изделие 4" }
                }
            },
            view: "Посмотреть"
        },
        silverjewelleries: {
            hero: {
                alt: "Фон серебряных ювелирных изделий",
                title: "Изысканные серебряные украшения",
                subtitle: {
                    highlight: "Современная элегантность и мастерство",
                    part2: "в каждом серебряном изделии, созданном для вас."
                },
                buttons: {
                    categories: "Категории",
                    shopNow: "Купить сейчас"
                }
            },
            nav: {
                gold: "Золотые украшения",
                silver: "Серебряные украшения",
                precious: "Драгоценные камни",
                semiPrecious: "Полудрагоценные камни"
            },
            silverItems: {
                title: "Серебряные изделия",
                subtitle: "Исследуйте нашу изысканную коллекцию серебряных украшений, созданных с точностью и стилем для любого случая."
            },
            categories: {
                rings: {
                    label: "Кольца",
                    desc: "Элегантные серебряные кольца с современным дизайном для повседневной элегантности.",
                    images: {
                        1: "Серебряное кольцо 1",
                        2: "Серебряное кольцо 2",
                        3: "Серебряное кольцо 3",
                        4: "Серебряное кольцо 4"
                    }
                },
                pendants: {
                    label: "Подвески",
                    desc: "Шикарные серебряные подвески, добавляющие изысканности любой цепочке.",
                    images: {
                        1: "Серебряная подвеска 1",
                        2: "Серебряная подвеска 2",
                        3: "Серебряная подвеска 3",
                        4: "Серебряная подвеска 4"
                    }
                },
                necklaces: {
                    label: "Ожерелья",
                    desc: "Стильные серебряные ожерелья для утончённого и универсального образа.",
                    images: {
                        1: "Серебряное ожерелье 1",
                        2: "Серебряное ожерелье 2"
                    }
                },
                earrings: {
                    label: "Серьги",
                    desc: "Элегантные серебряные серьги, сочетающие тренды и вечный шарм.",
                    images: {
                        1: "Серебряные серьги 1",
                        2: "Серебряные серьги 2",
                        3: "Серебряные серьги 3"
                    }
                },
                bracelets: {
                    label: "Браслеты",
                    desc: "Изысканные серебряные браслеты для нотки роскоши.",
                    images: {
                        1: "Серебряный браслет 1",
                        2: "Серебряный браслет 2",
                        3: "Серебряный браслет 3"
                    }
                },
                chains: {
                    label: "Цепочки",
                    desc: "Универсальные серебряные цепочки, идеальные для подвесок или самостоятельного ношения.",
                    images: {
                        1: "Серебряная цепочка 1",
                        2: "Серебряная цепочка 2",
                        3: "Серебряная цепочка 3",
                        4: "Серебряная цепочка 4"
                    }
                },
                tiePins: {
                    label: "Запонки для галстука",
                    desc: "Полированные серебряные запонки для галстука, чтобы подчеркнуть формальный стиль.",
                    images: {
                        1: "Серебряная запонка 1"
                    }
                },
                bangles: {
                    label: "Браслеты-манжеты",
                    desc: "Классические серебряные браслеты-манжеты для вневременного аксессуара.",
                    images: {
                        1: "Серебряный браслет-манжет 1"
                    }
                }
            },
            view: "Посмотреть"
        },
        preciousstones: {
            hero: {
                alt: "Фон драгоценных камней",
                title: "Изысканные драгоценные камни",
                subtitle: {
                    highlight: "Вечная красота и блеск",
                    part2: "в каждом драгоценном камне, созданном для вас."
                },
                buttons: {
                    categories: "Категории",
                    shopNow: "Купить сейчас"
                }
            },
            nav: {
                gold: "Золотые украшения",
                silver: "Серебряные украшения",
                precious: "Драгоценные камни",
                semiPrecious: "Полудрагоценные камни"
            },
            stones: {
                title: "Драгоценные камни",
                subtitle: "Откройте блеск наших драгоценных камней, каждый отобран за исключительное качество и красоту.",
                sapphire: {
                    title: "Сапфиры",
                    desc: "Глубоко-синие сапфиры, известные своей потрясающей чистотой и прочностью, идеальны для элегантных ювелирных изделий."
                },
                ruby: {
                    title: "Рубины",
                    desc: "Ярко-красные рубины, символ страсти и силы, идеальны для смелых и роскошных дизайнов."
                },
                topaz: {
                    title: "Топаз",
                    desc: "Сияющий голубой топаз, добавляющий искрящийся блеск любой ювелирной коллекции."
                },
                amethyst: {
                    title: "Аметист",
                    desc: "Насыщенные фиолетовые аметисты, ценимые за успокаивающую красоту и универсальность в современных и классических стилях."
                }
            }
        },
        semipreciousstones: {
            hero: {
                alt: "Фон полудрагоценных камней",
                title: "Изысканные полудрагоценные камни",
                subtitle: {
                    highlight: "Яркие цвета и уникальное очарование",
                    part2: "в каждом полудрагоценном камне, созданном для вас."
                },
                buttons: {
                    categories: "Категории",
                    shopNow: "Купить сейчас"
                }
            },
            nav: {
                gold: "Золотые украшения",
                silver: "Серебряные украшения",
                precious: "Драгоценные камни",
                semiPrecious: "Полудрагоценные камни"
            },
            stones: {
                title: "Полудрагоценные камни",
                subtitle: "Откройте яркое очарование наших полудрагоценных камней, каждый выбран за свою уникальную красоту и универсальность.",
                moonstone: {
                    title: "Лунные камни",
                    desc: "Эфирные лунные камни, известные своим мерцающим сиянием и успокаивающей энергией, идеальны для уникальных украшений."
                },
                citrine: {
                    title: "Цитрин",
                    desc: "Солнечно-жёлтый цитрин, излучающий тепло и блеск, идеален для ярких ювелирных изделий."
                },
                garnet: {
                    title: "Гранат",
                    desc: "Насыщенный красный гранат, ценится за тёплые оттенки и универсальность в классических и современных дизайнах."
                },
                quartz: {
                    title: "Кварц",
                    desc: "Прозрачный или дымчатый кварц, ценится за чистоту и адаптивность в различных стилях украшений."
                },
                turquoise: {
                    title: "Бирюза",
                    desc: "Ярко-голубо-зелёная бирюза, почитаемая за уникальный цвет и культурное значение в ювелирном деле."
                },
                peridot: {
                    title: "Перидот",
                    desc: "Сочный зелёный перидот, прославленный за освежающий блеск и пригодность для повседневного ношения."
                }
            }
        },
        // ────────────────────────────────────────────────
        // Russian (ru)
        blogs: {
            hero: {
                alt: "Фон блогов",
                title: "Наши блоги",
                subtitle: {
                    part1: "Ознакомьтесь с нашей коллекцией",
                    highlight: "идей и историй",
                    part2: "о драгоценных камнях, мастерстве и искусстве Marino Gems & Jewellery."
                }
            },
            posts: {
                title: "Последние записи в блоге",
                subtitle: "Погрузитесь в наши свежие статьи и узнайте больше о мире драгоценных камней, трендах ювелирного дела и мастерстве наших изделий.",
                readMore: "Читать далее",
                items: {
                    sapphires: {
                        title: "Вневременное очарование шри-ланкийских сапфиров",
                        excerpt: "Узнайте об истории и уникальных качествах всемирно известных сапфиров Шри-Ланки.",
                        description: "Шри-Ланка, известная как «Остров драгоценных камней», уже более 2000 лет поставляет изысканные сапфиры. Знаменитые ярко-синими оттенками и исключительной чистотой, эти камни украшали королевские дворы и коллекции по всему миру. От древних шахт Ратнапуры до современных рынков шри-ланкийские сапфиры продолжают завораживать своей вечной красотой. В Marino Gems & Jewellery мы этично закупаем эти камни, создавая потрясающие изделия, отражающие богатое наследие и непревзойдённое качество. Узнайте о геологических факторах, делающих эти сапфиры уникальными, и почему они остаются краеугольным камнем мировой торговли драгоценными камнями.",
                        altTexts: {
                            1: "Крупный план ярко-синего шри-ланкийского сапфира",
                            2: "Традиционная добыча сапфиров в Ратнапуре",
                            3: "Огранённый сапфир в ювелирном изделии"
                        }
                    },
                    crafting: {
                        title: "Создание ювелирных изделий на заказ: наш процесс",
                        excerpt: "Узнайте, как Marino превращает необработанные камни в изысканные украшения.",
                        description: "В Marino Gems & Jewellery процесс создания ювелирных изделий на заказ сочетает искусство и точность. Всё начинается с выбора этично добытых камней, затем следует совместное обсуждение дизайна с клиентом. Наши мастера изготавливают каждое изделие вручную, гарантируя соответствие каждой детали пожеланиям заказчика. От огранки и полировки до закрепки и финальной отделки — мы уделяем внимание качеству и индивидуальности. Познакомьтесь с этапами превращения сырья в вечные сокровища и узнайте, почему наше мастерство выделяется в мире высокого ювелирного искусства.",
                        altTexts: {
                            1: "Мастер точно обрабатывает драгоценный камень",
                            2: "Дизайнер создаёт эскиз изделия на заказ",
                            3: "Готовое изделие с тончайшими деталями"
                        }
                    },
                    ethical: {
                        title: "Тренды этичной добычи драгоценных камней",
                        excerpt: "Узнайте, почему этичная добыча так важна в современной индустрии.",
                        description: "Этичная добыча лежит в основе современных ювелирных трендов. В Marino Gems & Jewellery мы делаем акцент на устойчивые практики, чтобы камни добывались ответственно, поддерживая местные сообщества и минимизируя вред окружающей среде. В этом материале рассматривается рост этичной добычи, сертификаты, которым мы следуем, и как потребители требуют прозрачности в отрасли. Узнайте о вызовах и инновациях в области устойчивого ювелирного дела и о том, как мы сохраняем приверженность этическому совершенству в каждом изделии.",
                        altTexts: {
                            1: "Этично добытые камни на месте добычи",
                            2: "Процесс сертификации устойчивых камней",
                            3: "Сообщество, получающее пользу от этичной добычи"
                        }
                    },
                    history: {
                        title: "История добычи драгоценных камней на Шри-Ланке",
                        excerpt: "Раскройте древние техники и современные методы добычи.",
                        description: "Добыча драгоценных камней на Шри-Ланке насчитывает более 2000 лет — традиционная шахтная добыча до сих пор практикуется в районах вроде Ратнапуры. Этот материал погружает в историю древних методов, показывает эволюцию современных технологий и их влияние на экономику и культуру Шри-Ланки. От инструментов древних шахтёров до сегодняшних устойчивых практик мы рассказываем, как Marino Gems & Jewellery добывает камни, сохраняя это богатое наследие. Узнайте истории камней, которые сделали Шри-Ланку мировым центром драгоценных камней.",
                        altTexts: {
                            1: "Традиционная шахтная добыча на Шри-Ланке",
                            2: "Древние инструменты для добычи камней",
                            3: "Современное оборудование для устойчивой добычи"
                        }
                    },
                    care: {
                        title: "Советы по уходу за ювелирными изделиями с камнями",
                        excerpt: "Узнайте, как сохранить блеск ваших украшений с нашими экспертными рекомендациями.",
                        description: "Правильный уход необходим, чтобы ваши украшения с камнями оставались яркими. В этом материале эксперты Marino Gems & Jewellery делятся практическими советами: методы чистки, правила хранения и способы избежать повреждений камней и металлов. Будь то кольцо с сапфиром или ожерелье с рубином — наш гид содержит лучшие практики для ежедневного ношения и долгосрочного сохранения. Узнайте, как простые ритуалы ухода помогут вашим украшениям оставаться семейной реликвией на поколения.",
                        altTexts: {
                            1: "Чистка кольца с сапфиром мягкой тканью",
                            2: "Правильное хранение ювелирных изделий с камнями",
                            3: "Осмотр ожерелья на предмет ухода"
                        }
                    },
                    future: {
                        title: "Будущее ювелирного дела: новые тренды",
                        excerpt: "Изучите тенденции, формирующие будущее дизайна украшений.",
                        description: "Ювелирная индустрия меняется: новые тренды в дизайне, материалах и технологиях определяют её будущее. В этом материале мы рассказываем, что ждёт нас впереди: лабораторные камни, инновационные 3D-печатные дизайны и экологичные материалы. В Marino Gems & Jewellery мы сочетаем традиции с современными инновациями, создавая изделия, которые находят отклик у сегодняшних покупателей. Узнайте о влиянии персонализации, экологичного дизайна и смелых новых стилей, которые переосмысливают будущее ювелирного искусства.",
                        altTexts: {
                            1: "Лабораторный камень под микроскопом",
                            2: "Прототип 3D-печатного ювелирного дизайна",
                            3: "Экологичные материалы в производстве украшений"
                        }
                    }
                }
            },
            modal: {
                close: "Закрыть"
            }
        },
    },
    fr: {
        navbar: {
            home: 'Accueil',
            jewelleriesStones: 'Bijoux et Pierres',
            gemHistory: 'Histoire des Gemmes',
            blogs: 'Blogs',
            aboutUs: 'À Propos',
            contactUs: 'Contactez-nous',
        },
        footer: {
            description: 'Marino Gems est une prestigieuse maison de joaillerie au Sri Lanka, spécialisée dans les créations raffinées en or, argent et pierres précieuses.',
            linksTitle: 'Liens',
            contactTitle: 'Contact',
            copyright: '© Copyright {{year}} - Marino Gems',
            developedBy: 'Développé par',
        },
        contact: {
            title: "Contactez-nous",
            feelFree: "N’hésitez pas à nous contacter",
            weAreHere: "Nous sommes là pour vous accompagner à chaque étape",
            description: "Contactez Marino Gems & Jewellery pour des conseils experts et un accompagnement sur vos besoins en pierres précieuses et bijoux.",
            callCenter: "Centre d’appels",
            email: "E-mail",
            ourLocation: "Notre emplacement",
            socialNetwork: "Réseaux sociaux",
            getInTouch: "Prendre contact",
            formIntro: "Nous serions ravis d’avoir de vos nouvelles — notre équipe est prête à répondre à vos questions et à vous guider.",
            nameLabel: "Nom",
            emailLabel: "E-mail",
            contactNumberLabel: "Numéro de téléphone",
            messageLabel: "Message",
            sendButton: "Envoyer le message",
            sending: "Envoi en cours...",
            successMessage: "Votre message a été envoyé sur WhatsApp !",
            errorMessage: "Impossible d’ouvrir WhatsApp. Veuillez réessayer.",
            findUs: "Nous trouver"
        },
        gemhistory: {
            hero: {
                title: "Histoire des Gemmes",
                alt: "Arrière-plan Histoire des Gemmes",
                subtitle: {
                    part1: "Chez Marino Gems & Jewelleries, nous célébrons la riche histoire des",
                    highlight: "gemmes et de l'artisanat",
                    part2: "qui ont façonné des trésors intemporels depuis des siècles."
                }
            },
            history: {
                title: "Histoire des Gemmes au Sri Lanka",
                subtitle: "Le Sri Lanka, surnommé l’« Île aux Gemmes », possède un héritage de plus de 2 000 ans dans l’extraction et le commerce des pierres précieuses.",
                imageAlt: "Histoire des Gemmes au Sri Lanka",
                text: "Le Sri Lanka, souvent appelé « l’Île aux Gemmes », est depuis plus de 2 000 ans un centre mondial pour les pierres précieuses et semi-précieuses. Réputé pour ses saphirs, rubis et autres gemmes, les riches gisements de régions comme Ratnapura ont alimenté un commerce florissant depuis l’Antiquité. Des cours royales aux marchés modernes, les gemmes sri-lankaises ont paré rois et collectionneurs du monde entier. Les techniques traditionnelles d’extraction coexistent encore avec les méthodes modernes. Marino Gems & Jewelleries perpétue cet héritage en utilisant des gemmes extraites de manière éthique pour créer des bijoux d’exception."
            },
            industry: {
                title: "À propos de l’industrie des gemmes",
                subtitle: "L’industrie mondiale des gemmes allie artisanat ancestral et innovation moderne pour créer une valeur intemporelle.",
                imageAlt: "À propos de l’industrie des gemmes",
                text: "L’industrie des gemmes est un mélange dynamique de tradition et de technologie : extraction, taille, commerce et création de bijoux. Évaluée à plus de 80 milliards de dollars à l’échelle mondiale, elle repose sur le charme des pierres précieuses et semi-précieuses telles que saphirs, diamants et émeraudes. Des anciennes routes commerciales aux marchés actuels, elle soutient des millions d’emplois, avec des centres majeurs au Sri Lanka, en Thaïlande et en Inde. Marino Gems & Jewelleries contribue à cette industrie dynamique en privilégiant l’approvisionnement éthique et les pratiques durables – chaque pièce incarne qualité et responsabilité."
            },
            importance: {
                title: "Importance des gemmes au",
                country: "Sri Lanka",
                subtitle: "Découvrez pourquoi les gemmes sont un pilier du patrimoine, de l’économie et de la réputation mondiale du Sri Lanka.",
                items: {
                    culturalSignificance: {
                        title: "Signification culturelle",
                        description: "Les gemmes font partie intégrante de la culture sri-lankaise depuis des siècles, ornant insignes royaux et objets religieux, symboles de pouvoir et de spiritualité."
                    },
                    economicImpact: {
                        title: "Impact économique",
                        description: "L’industrie des gemmes est un contributeur majeur à l’économie du Sri Lanka, générant emplois et soutenant les communautés des zones minières comme Ratnapura."
                    },
                    globalReputation: {
                        title: "Réputation mondiale",
                        description: "Les saphirs et rubis du Sri Lanka sont mondialement réputés, attirant acheteurs internationaux et positionnant le pays comme hub majeur des gemmes."
                    },
                    sustainablePractices: {
                        title: "Pratiques durables",
                        description: "Marino Gems & Jewelleries promeut l’extraction éthique et les pratiques durables, préservant les ressources naturelles et l’héritage gemmologique du Sri Lanka."
                    }
                }
            }
        },
        ourproducts: {
            hero: {
                alt: "Arrière-plan de nos produits",
                timeless: "Élégance intemporelle",
                title: "Nos Bijoux Exquis",
                description: "Découvrez notre collection de pierres précieuses et de bijoux minutieusement travaillés, conçus pour célébrer l’individualité et la beauté intemporelle."
            },
            section: {
                title: "Bijoux et Pierres",
                subtitle: "Explorez notre gamme variée de bijoux en or et en argent, ainsi que de pierres précieuses et semi-précieuses, créés pour sublimer votre style."
            },
            viewMore: "Voir plus",
            categories: {
                gold: {
                    title: "Bijoux en Or",
                    desc: "Bijoux en or exquis, travaillés avec précision, mêlant élégance intemporelle et design moderne."
                },
                silver: {
                    title: "Bijoux en Argent",
                    desc: "Pièces élégantes en argent alliant abordabilité et savoir-faire exceptionnel pour un port quotidien."
                },
                precious: {
                    title: "Pierres Précieuses",
                    desc: "Pierres précieuses rares et vibrantes, sourcées de manière éthique pour créer des bijoux époustouflants."
                },
                semiPrecious: {
                    title: "Pierres Semi-Précieuses",
                    desc: "Pierres semi-précieuses colorées et uniques, parfaites pour des créations sur mesure et personnalisées."
                }
            }
        },
        aboutus: {
            hero: {
                alt: "Arrière-plan À propos de nous",
                title: "À propos de nous",
                subtitle: {
                    part1: "Chez Marino Gems & Jewellery, nous faisons vivre la beauté intemporelle des",
                    highlight: "gemmes exquises et du savoir-faire",
                    part2: "pour créer des trésors inoubliables."
                }
            },
            whoWeAre: {
                title: "Qui nous sommes",
                subtitle: "Solutions fiables, éthiques et exceptionnelles pour les gemmes et la joaillerie, soutenues par des décennies d’expertise et une passion pour l’artisanat.",
                imageAlt: "Marino Gems & Jewellery",
                text: {
                    part1: "Chez",
                    part2: ", nous nous consacrons à la création de gemmes et de bijoux exquis qui reflètent une beauté intemporelle et une qualité exceptionnelle. Notre équipe a sourcé et réalisé plus de",
                    pieces: "1000",
                    part3: "pièces uniques, au service de clients à travers",
                    regions: "l’Asie, l’Europe, l’Amérique du Nord et au-delà",
                    part4: ". Avec un engagement profond pour l’approvisionnement éthique et un savoir-faire maîtrisé, nous créons des designs sur mesure qui célèbrent l’individualité et l’élégance."
                }
            },
            brandName: "Marino Gems & Jewellery",
            chairman: {
                title: "Message du président",
                alt: "Message du président",
                message: "\"Chez Marino Gems & Jewellery, notre vision est de créer des pièces intemporelles qui racontent des histoires d’élégance et de savoir-faire. Depuis plus de trois décennies, nous sommes engagés dans l’excellence, mêlant tradition et innovation pour concevoir des bijoux empreints de beauté et de sens. Notre passion nous pousse à respecter les plus hauts standards d’approvisionnement éthique et de qualité, afin que chaque pièce devienne un héritage précieux. Je vous invite à nous rejoindre dans cette aventure de création de moments extraordinaires à travers notre art.\"",
                signature: "– Président, Marino Gems & Jewellery"
            },
            team: {
                title: "Notre équipe",
                alt: "Notre équipe",
                text: {
                    part1: "Notre équipe chez",
                    part2: "est composée d’artisans passionnés, de gemmologues qualifiés et de professionnels dévoués qui apportent des décennies d’expertise à chaque création. Grâce à un engagement commun envers l’excellence, notre équipe collabore pour réaliser des",
                    highlight: "designs sur mesure",
                    part3: "qui incarnent élégance et précision, au service de clients à travers",
                    regions: "l’Asie, l’Europe, l’Amérique du Nord et au-delà",
                    part4: ". Nous sommes fiers de cultiver la créativité et l’innovation tout en maintenant les plus hauts standards d’artisanat éthique."
                }
            },
            services: {
                title: "Nos services",
                subtitle: "Marino Gems & Jewellery propose une gamme de services premium, offrant un savoir-faire exceptionnel et des expériences personnalisées aux clients du monde entier.",
                alt: "Nos services",
                intro: "Nos services sont conçus pour offrir une qualité et une satisfaction inégalées, donnant vie à la vision de chaque client à travers :",
                crafting: "Création de bijoux sur mesure d’une qualité exceptionnelle",
                sourcing: "Approvisionnement éthique de gemmes à l’échelle mondiale",
                consultations: "Consultations personnalisées en design",
                repair: "Services de réparation et de restauration"
            },
            contact: {
                alt: "Arrière-plan Contact",
                title: "Créer vos trésors intemporels",
                text: "Merci d’explorer Marino Gems & Jewellery. Nous sommes passionnés par la transformation de votre vision en pièces exquises et intemporelles. Des designs sur mesure aux consultations expertes, notre équipe est là pour vous guider à chaque étape. Contactez-nous dès aujourd’hui pour commencer votre voyage vers la création ou la restauration de votre bijou précieux.",
                button: "Contactez-nous"
            }
        },
        home: {
            hero: {
                title: "Découvrez des gemmes & bijoux exquis",
                subtitle: {
                    highlight: "Explorez notre collection de gemmes de classe mondiale",
                    part2: "réalisées avec passion et précision."
                },
                buttons: {
                    explore: "Découvrir les collections",
                    contact: "Contactez-nous"
                }
            },
            kandy: {
                title: "Marino Gems and Jewellery",
                subtitle: "Vivez l’artisanat et l’héritage de Marino Gems & Jewellery, réalisé avec excellence au cœur de Kandy."
            },
            services: {
                items: {
                    ethicalSourcing: {
                        title: "Approvisionnement éthique des gemmes",
                        desc: "Nous sourçons nos gemmes de manière responsable auprès de mines de confiance, en favorisant la durabilité et le soutien aux communautés locales au Sri Lanka."
                    },
                    bespokeDesign: {
                        title: "Design de bijoux sur mesure",
                        desc: "Nos artisans collaborent avec vous pour créer des bijoux personnalisés, mêlant votre vision à notre expertise."
                    },
                    expertCraftsmanship: {
                        title: "Savoir-faire d’exception",
                        desc: "Chaque pièce est façonnée à la main dans notre atelier de Kandy avec des techniques perfectionnées sur des générations."
                    },
                    globalExpertise: {
                        title: "Expertise mondiale en gemmologie",
                        desc: "Grâce à une connaissance approfondie en gemmologie, nous proposons des gemmes de classe mondiale, dont des saphirs sri-lankais, à des clients du monde entier."
                    },
                    trustedLegacy: {
                        title: "Héritage de confiance",
                        desc: "Marino Gems & Jewellery s’est forgé une réputation d’excellence à Kandy, reconnu pour sa qualité et son authenticité."
                    }
                }
            },
            achievements: {
                title: "Nos réalisations",
                items: {
                    goldProducts: { title: "Produits en or" },
                    silverProducts: { title: "Produits en argent" },
                    gemStones: { title: "Pierres précieuses" },
                    customers: { title: "Clients" }
                }
            },
            products: {
                title: "Nos produits",
                subtitle: "Découvrez notre gamme exquise de bijoux et de pierres précieuses.",
                viewMore: "Voir plus",
                view: "Voir",
                items: {
                    gold: {
                        title: "Bijoux en or",
                        desc: "Bijoux en or exquis, travaillés avec élégance et précision."
                    },
                    silver: {
                        title: "Bijoux en argent",
                        desc: "Pièces en argent époustouflantes mêlant tradition et modernité."
                    },
                    precious: {
                        title: "Pierres précieuses",
                        desc: "Pierres rares, dont des saphirs, pour une beauté intemporelle."
                    },
                    semiPrecious: {
                        title: "Pierres semi-précieuses",
                        desc: "Pierres semi-précieuses vibrantes pour un luxe unique et accessible."
                    }
                }
            },
            gallery: {
                title: "Notre galerie",
                subtitle: "Un aperçu de nos réussites, événements et des voyages que nous avons rendus possibles dans le monde entier",
                images: {
                    gallery1: "Événement de présentation de bijoux",
                    gallery2: "Exposition de collier en or fait main",
                    gallery3: "Session de fabrication dans l’atelier de Kandy",
                    gallery4: "Processus de taille d’un saphir sri-lankais",
                    gallery5: "Consultation client pour bijoux",
                    gallery6: "Événement d’ouverture du magasin Marino Gems",
                    gallery7: "Lancement de la collection de bijoux en argent",
                    gallery8: "Approvisionnement en pierres précieuses au Sri Lanka",
                    gallery9: "Session de design de bijoux sur mesure",
                    gallery10: "Équipe Marino Gems sur un salon professionnel",
                    gallery11: "Client essayant une bague en saphir",
                    gallery12: "Cérémonie de remise de prix pour l’artisanat"
                }
            },
            kandyImages: {
                images: {
                    kandy1: "Façade du magasin Marino Gems à Kandy",
                    kandy2: "Intérieur du showroom",
                    kandy3: "Atelier de taille de pierres",
                    kandy4: "Fabrication de bijoux en cours",
                    kandy5: "Zone de consultation clients"
                }
            },
            testimonials: {
                title: "Ce que disent nos clients"
            }
        },
        goldjewelleries: {
            hero: {
                alt: "Arrière-plan bijoux en or",
                title: "Bijoux en or exquis",
                subtitle: {
                    highlight: "Artisanat intemporel et élégance",
                    part2: "dans chaque pièce en or, conçue pour vous."
                },
                buttons: {
                    categories: "Catégories",
                    shopNow: "Acheter maintenant"
                }
            },
            nav: {
                gold: "Bijoux en or",
                silver: "Bijoux en argent",
                precious: "Pierres précieuses",
                semiPrecious: "Pierres semi-précieuses"
            },
            goldItems: {
                title: "Articles en or",
                subtitle: "Découvrez notre superbe collection de bijoux en or, réalisés avec précision et élégance pour toutes les occasions."
            },
            categories: {
                rings: {
                    label: "Bagues",
                    desc: "Bagues en or élégantes aux designs sophistiqués pour une beauté intemporelle.",
                    images: { 1: "Bague en or 1", 2: "Bague en or 2", 3: "Bague en or 3", 4: "Bague en or 4" }
                },
                pendants: {
                    label: "Pendentifs",
                    desc: "Superbes pendentifs en or pour sublimer n’importe quelle chaîne avec raffinement.",
                    images: { 1: "Pendentif en or 1", 2: "Pendentif en or 2", 3: "Pendentif en or 3", 4: "Pendentif en or 4" }
                },
                necklaces: {
                    label: "Colliers",
                    desc: "Colliers en or exquis qui rehaussent votre style pour toute occasion.",
                    images: { 1: "Collier en or 1", 2: "Collier en or 2", 3: "Collier en or 3", 4: "Collier en or 4" }
                },
                earrings: {
                    label: "Boucles d’oreilles",
                    desc: "Boucles d’oreilles en or chic mêlant tendances modernes et élégance classique.",
                    images: { 1: "Boucle d’oreille en or 1", 2: "Boucle d’oreille en or 2", 3: "Boucle d’oreille en or 3", 4: "Boucle d’oreille en or 4" }
                },
                bracelets: {
                    label: "Bracelets",
                    desc: "Bracelets en or gracieux conçus pour orner votre poignet avec luxe.",
                    images: { 1: "Bracelet en or 1", 2: "Bracelet en or 2", 3: "Bracelet en or 3", 4: "Bracelet en or 4" }
                },
                chains: {
                    label: "Chaînes",
                    desc: "Chaînes en or polyvalentes, parfaites pour pendentifs ou portées seules.",
                    images: { 1: "Chaîne en or 1", 2: "Chaîne en or 2", 3: "Chaîne en or 3", 4: "Chaîne en or 4" }
                },
                tiePins: {
                    label: "Épingles à cravate",
                    desc: "Épingles à cravate en or sophistiquées pour rehausser une tenue formelle.",
                    images: { 1: "Épingle à cravate en or 1", 2: "Épingle à cravate en or 2", 3: "Épingle à cravate en or 3", 4: "Épingle à cravate en or 4" }
                },
                other: {
                    label: "Autres articles",
                    desc: "Collection sélectionnée d’articles en or pour un look soigné.",
                    images: { 1: "Article en or 1", 2: "Article en or 2", 3: "Article en or 3", 4: "Article en or 4" }
                }
            },
            view: "Voir"
        },
        silverjewelleries: {
            hero: {
                alt: "Arrière-plan bijoux en argent",
                title: "Bijoux en argent exquis",
                subtitle: {
                    highlight: "Élégance moderne et savoir-faire",
                    part2: "dans chaque pièce en argent, conçue pour vous."
                },
                buttons: {
                    categories: "Catégories",
                    shopNow: "Acheter maintenant"
                }
            },
            nav: {
                gold: "Bijoux en or",
                silver: "Bijoux en argent",
                precious: "Pierres précieuses",
                semiPrecious: "Pierres semi-précieuses"
            },
            silverItems: {
                title: "Articles en argent",
                subtitle: "Découvrez notre collection exquise de bijoux en argent, réalisés avec précision et style pour toutes les occasions."
            },
            categories: {
                rings: {
                    label: "Bagues",
                    desc: "Bagues en argent élégantes aux designs modernes pour une élégance quotidienne.",
                    images: { 1: "Bague en argent 1", 2: "Bague en argent 2", 3: "Bague en argent 3", 4: "Bague en argent 4" }
                },
                pendants: {
                    label: "Pendentifs",
                    desc: "Pendentifs en argent chic qui ajoutent une touche de sophistication.",
                    images: { 1: "Pendentif en argent 1", 2: "Pendentif en argent 2", 3: "Pendentif en argent 3", 4: "Pendentif en argent 4" }
                },
                necklaces: {
                    label: "Colliers",
                    desc: "Colliers en argent élégants pour un look raffiné et polyvalent.",
                    images: { 1: "Collier en argent 1", 2: "Collier en argent 2" }
                },
                earrings: {
                    label: "Boucles d’oreilles",
                    desc: "Boucles d’oreilles en argent élégantes mêlant tendance et charme intemporel.",
                    images: { 1: "Boucle d’oreille en argent 1", 2: "Boucle d’oreille en argent 2", 3: "Boucle d’oreille en argent 3" }
                },
                bracelets: {
                    label: "Bracelets",
                    desc: "Bracelets en argent sophistiqués pour une touche de luxe.",
                    images: { 1: "Bracelet en argent 1", 2: "Bracelet en argent 2", 3: "Bracelet en argent 3" }
                },
                chains: {
                    label: "Chaînes",
                    desc: "Chaînes en argent polyvalentes, idéales pour pendentifs ou portées seules.",
                    images: { 1: "Chaîne en argent 1", 2: "Chaîne en argent 2", 3: "Chaîne en argent 3", 4: "Chaîne en argent 4" }
                },
                tiePins: {
                    label: "Épingles à cravate",
                    desc: "Épingles à cravate en argent polies pour rehausser une tenue formelle.",
                    images: { 1: "Épingle à cravate en argent 1" }
                },
                bangles: {
                    label: "Bracelets joncs",
                    desc: "Bracelets joncs en argent classiques pour un choix d’accessoire intemporel.",
                    images: { 1: "Bracelet jonc en argent 1" }
                }
            },
            view: "Voir"
        },
        preciousstones: {
            hero: {
                alt: "Arrière-plan pierres précieuses",
                title: "Pierres précieuses exquises",
                subtitle: {
                    highlight: "Beauté intemporelle et éclat",
                    part2: "dans chaque pierre précieuse, façonnée pour vous."
                },
                buttons: {
                    categories: "Catégories",
                    shopNow: "Acheter maintenant"
                }
            },
            nav: {
                gold: "Bijoux en or",
                silver: "Bijoux en argent",
                precious: "Pierres précieuses",
                semiPrecious: "Pierres semi-précieuses"
            },
            stones: {
                title: "Pierres précieuses",
                subtitle: "Découvrez l’éclat de nos pierres précieuses, chacune sélectionnée pour sa qualité exceptionnelle et sa beauté.",
                sapphire: {
                    title: "Saphirs",
                    desc: "Saphirs bleu profond, réputés pour leur clarté saisissante et leur durabilité, parfaits pour des bijoux élégants."
                },
                ruby: {
                    title: "Rubis",
                    desc: "Rubis rouge vif, symboles de passion et de force, idéaux pour des designs audacieux et luxueux."
                },
                topaz: {
                    title: "Topaze",
                    desc: "Topaze bleue rayonnante, offrant une brillance étincelante qui sublime toute collection de bijoux."
                },
                amethyst: {
                    title: "Améthyste",
                    desc: "Améthystes violet riche, appréciées pour leur beauté apaisante et leur polyvalence dans les styles modernes et classiques."
                }
            }
        },
        semipreciousstones: {
            hero: {
                alt: "Arrière-plan pierres semi-précieuses",
                title: "Pierres semi-précieuses exquises",
                subtitle: {
                    highlight: "Couleurs vibrantes et charme unique",
                    part2: "dans chaque pierre semi-précieuse, façonnée pour vous."
                },
                buttons: {
                    categories: "Catégories",
                    shopNow: "Acheter maintenant"
                }
            },
            nav: {
                gold: "Bijoux en or",
                silver: "Bijoux en argent",
                precious: "Pierres précieuses",
                semiPrecious: "Pierres semi-précieuses"
            },
            stones: {
                title: "Pierres semi-précieuses",
                subtitle: "Découvrez l’attrait vibrant de nos pierres semi-précieuses, chacune choisie pour sa beauté unique et sa polyvalence.",
                moonstone: {
                    title: "Pierres de lune",
                    desc: "Pierres de lune éthérées, connues pour leur éclat scintillant et leur énergie apaisante, parfaites pour des bijoux uniques."
                },
                citrine: {
                    title: "Citrine",
                    desc: "Citrine jaune ensoleillée, rayonnant de chaleur et de brillance, idéale pour des pièces de bijoux vibrantes."
                },
                garnet: {
                    title: "Grenat",
                    desc: "Grenat rouge riche, apprécié pour ses teintes chaudes et sa polyvalence dans les designs classiques et modernes."
                },
                quartz: {
                    title: "Quartz",
                    desc: "Quartz clair ou fumé, prisé pour sa clarté et son adaptabilité dans divers styles de bijoux."
                },
                turquoise: {
                    title: "Turquoise",
                    desc: "Turquoise bleu-vert vif, chérie pour sa couleur unique et sa signification culturelle dans la joaillerie."
                },
                peridot: {
                    title: "Péridot",
                    desc: "Péridot vert luxuriant, célébré pour son éclat rafraîchissant et son adéquation au port quotidien."
                }
            }
        },
        // French (fr)
        blogs: {
            hero: {
                alt: "Arrière-plan des blogs",
                title: "Nos blogs",
                subtitle: {
                    part1: "Découvrez notre collection de",
                    highlight: "perspectives et d’histoires",
                    part2: "sur les gemmes, le savoir-faire et l’artisanat derrière Marino Gems & Jewellery."
                }
            },
            posts: {
                title: "Derniers articles de blog",
                subtitle: "Plongez dans nos derniers articles pour en savoir plus sur le monde des gemmes, les tendances joaillières et l’artisanat de nos créations.",
                readMore: "Lire la suite",
                items: {
                    sapphires: {
                        title: "L’attrait intemporel des saphirs sri-lankais",
                        excerpt: "Découvrez l’histoire riche et les qualités uniques des saphirs mondialement réputés du Sri Lanka.",
                        description: "Le Sri Lanka, surnommé « l’île aux gemmes », fournit des saphirs exquis depuis plus de 2 000 ans. Célèbres pour leurs teintes bleues vibrantes et leur clarté exceptionnelle, ces pierres ont paré des royaux et des collectionneurs du monde entier. Des anciennes mines de Ratnapura aux marchés modernes, les saphirs sri-lankais continuent de fasciner par leur beauté intemporelle. Chez Marino Gems & Jewellery, nous sourçons ces gemmes de manière éthique pour créer des pièces époustouflantes qui reflètent leur riche héritage et leur qualité inégale. Découvrez les facteurs géologiques qui rendent ces saphirs uniques et pourquoi ils restent un pilier du commerce mondial des gemmes.",
                        altTexts: {
                            1: "Gros plan d’un saphir bleu vif du Sri Lanka",
                            2: "Exploitation traditionnelle de saphirs à Ratnapura",
                            3: "Saphir poli serti dans un bijou"
                        }
                    },
                    crafting: {
                        title: "Création de bijoux sur mesure : notre processus",
                        excerpt: "Découvrez comment Marino transforme des gemmes brutes en pièces de joaillerie exquises.",
                        description: "Chez Marino Gems & Jewellery, notre processus de création sur mesure allie art et précision. Il commence par la sélection de gemmes sourcées éthiquement, suivi de consultations de design collaboratives avec nos clients. Nos artisans qualifiés façonnent chaque pièce à la main, garantissant que chaque détail correspond à la vision du client. De la taille et du polissage à la sertissage et à la finition, notre processus met l’accent sur la qualité et l’individualité. Découvrez les étapes qui transforment des matières premières en trésors intemporels et pourquoi notre savoir-faire se distingue dans le monde de la haute joaillerie.",
                        altTexts: {
                            1: "Artisan taillant une gemme avec précision",
                            2: "Designer esquissant un bijou sur mesure",
                            3: "Pièce finie avec des détails intricats"
                        }
                    },
                    ethical: {
                        title: "Tendances de l’approvisionnement éthique en gemmes",
                        excerpt: "Découvrez pourquoi l’approvisionnement éthique est si important dans l’industrie des gemmes aujourd’hui.",
                        description: "L’approvisionnement éthique est au cœur des tendances modernes de la joaillerie. Chez Marino Gems & Jewellery, nous privilégions des pratiques durables pour garantir que nos gemmes sont extraites de manière responsable, en soutenant les communautés locales et en minimisant l’impact environnemental. Ce billet explore la montée de l’approvisionnement éthique, les certifications auxquelles nous adhérons et la manière dont les consommateurs exigent plus de transparence dans l’industrie. Découvrez les défis et les innovations qui façonnent la joaillerie durable et comment nous maintenons notre engagement envers l’excellence éthique dans chaque pièce que nous créons.",
                        altTexts: {
                            1: "Gemmes sourcées éthiquement sur un site minier",
                            2: "Processus de certification des gemmes durables",
                            3: "Communauté bénéficiant de l’extraction éthique"
                        }
                    },
                    history: {
                        title: "L’histoire de l’extraction de gemmes au Sri Lanka",
                        excerpt: "Découvrez les techniques anciennes et les méthodes modernes d’extraction de gemmes.",
                        description: "L’extraction de gemmes au Sri Lanka remonte à plus de 2 000 ans, avec l’exploitation traditionnelle en puits encore pratiquée dans des régions comme Ratnapura. Ce billet plonge dans l’histoire de ces techniques anciennes, l’évolution des méthodes modernes et leur impact sur l’économie et la culture sri-lankaises. Des outils utilisés par les anciens mineurs aux pratiques durables actuelles, nous explorons comment Marino Gems & Jewellery s’approvisionne en gemmes tout en préservant ce riche patrimoine. Découvrez les histoires derrière les gemmes qui ont fait du Sri Lanka un centre mondial des pierres précieuses.",
                        altTexts: {
                            1: "Exploitation traditionnelle en puits au Sri Lanka",
                            2: "Outils anciens utilisés pour l’extraction de gemmes",
                            3: "Équipement moderne d’extraction durable"
                        }
                    },
                    care: {
                        title: "Conseils pour entretenir vos bijoux en gemmes",
                        excerpt: "Apprenez à garder vos bijoux éclatants avec nos conseils d’experts.",
                        description: "Un bon entretien est essentiel pour préserver l’éclat de vos bijoux en gemmes. Ce billet propose des conseils pratiques des experts de Marino Gems & Jewellery : techniques de nettoyage, conseils de rangement et astuces pour éviter d’endommager les pierres et les métaux précieux. Que ce soit une bague en saphir ou un collier en rubis, notre guide couvre les meilleures pratiques pour le port quotidien et la conservation à long terme. Découvrez comment de simples routines d’entretien peuvent garantir que vos bijoux restent des héritages précieux pour les générations futures.",
                        altTexts: {
                            1: "Nettoyage d’une bague en saphir avec un chiffon doux",
                            2: "Rangement approprié des bijoux en gemmes",
                            3: "Inspection d’un collier pour l’entretien"
                        }
                    },
                    future: {
                        title: "L’avenir de la joaillerie : tendances émergentes",
                        excerpt: "Explorez les tendances qui façonnent l’avenir du design joaillier.",
                        description: "L’industrie joaillière évolue avec de nouveaux matériaux, designs et technologies. Ce billet explore ce qui attend la haute joaillerie : gemmes cultivées en laboratoire, designs innovants imprimés en 3D et matériaux durables. Chez Marino Gems & Jewellery, nous anticipons ces évolutions en combinant tradition et innovation moderne pour créer des pièces qui parlent aux consommateurs d’aujourd’hui. Découvrez l’influence de la personnalisation, des designs éco-responsables et des styles audacieux qui redéfinissent l’avenir de l’art joaillier.",
                        altTexts: {
                            1: "Gemmes cultivées en laboratoire sous inspection",
                            2: "Prototype de design joaillier imprimé en 3D",
                            3: "Matériaux durables dans la fabrication de bijoux"
                        }
                    }
                }
            },
            modal: {
                close: "Fermer"
            }
        },
    },
    zh: {
        navbar: {
            home: '首页',
            jewelleriesStones: '珠宝与宝石',
            gemHistory: '宝石历史',
            blogs: '博客',
            aboutUs: '关于我们',
            contactUs: '联系我们',
        },
        footer: {
            description: 'Marino Gems 是斯里兰卡首屈一指的珠宝公司，专注于精美黄金、白银和宝石创作。',
            linksTitle: '链接',
            contactTitle: '联系方式',
            copyright: '© {{year}} Marino Gems 版权所有',
            developedBy: '由...开发',
        },
        contact: {
            title: "联系我们",
            feelFree: "欢迎随时联系我们",
            weAreHere: "我们在这里为您提供全程帮助",
            description: "联系 Marino Gems & Jewellery，获取宝石和珠宝需求的专家指导与支持。",
            callCenter: "呼叫中心",
            email: "电子邮件",
            ourLocation: "我们的位置",
            socialNetwork: "社交网络",
            getInTouch: "取得联系",
            formIntro: "我们很乐意收到您的消息 — 我们的团队随时准备回答您的问题并为您提供指导。",
            nameLabel: "姓名",
            emailLabel: "电子邮件",
            contactNumberLabel: "联系电话",
            messageLabel: "留言",
            sendButton: "发送消息",
            sending: "发送中...",
            successMessage: "您的消息已发送至 WhatsApp！",
            errorMessage: "无法打开 WhatsApp。请重试。",
            findUs: "找到我们"
        },
        gemhistory: {
            hero: {
                title: "宝石历史",
                alt: "宝石历史背景",
                subtitle: {
                    part1: "在 Marino Gems & Jewelleries，我们庆祝",
                    highlight: "宝石与工艺",
                    part2: "的丰富历史，它们塑造了几个世纪以来的永恒珍宝。"
                }
            },
            history: {
                title: "斯里兰卡宝石历史",
                subtitle: "斯里兰卡，被誉为“宝石岛”，拥有超过2000年的宝石开采与贸易传奇。",
                imageAlt: "斯里兰卡宝石历史",
                text: "斯里兰卡常被称为“宝石岛”，2000多年来一直是全球珍贵与半宝石的中心。以蓝宝石、红宝石等闻名，拉特纳普勒等地区的丰富矿藏自古以来推动了繁荣的贸易。从王宫到现代市场，斯里兰卡宝石装点过世界各地的皇室与收藏家。传统开采技术至今与现代方法并存。Marino Gems & Jewelleries延续这一传统，使用符合伦理开采的宝石打造精美珠宝。"
            },
            industry: {
                title: "关于宝石产业",
                subtitle: "全球宝石产业融合古老工艺与现代创新，创造永恒价值。",
                imageAlt: "关于宝石产业",
                text: "宝石产业是传统与科技的动态结合，涵盖开采、切割、贸易与珠宝设计。全球价值超过800亿美元，依靠蓝宝石、钻石、祖母绿等宝石的魅力。从古代贸易路线到现代市场，该产业支撑数百万人生计，主要中心包括斯里兰卡、泰国和印度。Marino Gems & Jewelleries通过优先考虑道德采购与可持续实践，为这一充满活力的产业做出贡献——每件作品都体现品质与责任。"
            },
            importance: {
                title: "宝石在",
                country: "斯里兰卡",
                subtitle: "了解为什么宝石是斯里兰卡遗产、经济与全球声誉的基石。",
                items: {
                    culturalSignificance: {
                        title: "文化意义",
                        description: "宝石几个世纪以来一直是斯里兰卡文化的重要组成部分，装饰王室徽章与宗教文物，象征权力与灵性。"
                    },
                    economicImpact: {
                        title: "经济影响",
                        description: "宝石产业是斯里兰卡经济的重要支柱，为拉特纳普勒等矿区社区提供就业机会。"
                    },
                    globalReputation: {
                        title: "全球声誉",
                        description: "斯里兰卡的蓝宝石与红宝石享誉世界，吸引国际买家，使该国成为顶级宝石中心。"
                    },
                    sustainablePractices: {
                        title: "可持续实践",
                        description: "Marino Gems & Jewelleries倡导道德开采与可持续做法，保护斯里兰卡的自然资源与宝石遗产。"
                    }
                }
            }
        },
        ourproducts: {
            hero: {
                alt: "我们的产品背景",
                timeless: "永恒优雅",
                title: "我们的精美珠宝",
                description: "探索我们精心打造的宝石与珠宝系列，旨在颂扬个性与永恒之美。"
            },
            section: {
                title: "珠宝与宝石",
                subtitle: "探索我们多样化的黄金与白银珠宝，以及珍贵与半宝石系列，旨在提升您的风格。"
            },
            viewMore: "查看更多",
            categories: {
                gold: {
                    title: "黄金珠宝",
                    desc: "精工细作的黄金珠宝，将永恒优雅与现代设计完美融合。"
                },
                silver: {
                    title: "白银珠宝",
                    desc: "优雅的白银作品，兼具亲民价格与惊艳工艺，适合日常佩戴。"
                },
                precious: {
                    title: "珍贵宝石",
                    desc: "稀有而鲜艳的珍贵宝石，符合伦理采购，用于打造令人惊艳的珠宝。"
                },
                semiPrecious: {
                    title: "半宝石",
                    desc: "色彩丰富且独一无二的半宝石，非常适合定制与个性化设计。"
                }
            }
        },
        aboutus: {
            hero: {
                alt: "关于我们背景",
                title: "关于我们",
                subtitle: {
                    part1: "在 Marino Gems & Jewellery，我们将",
                    highlight: "精美宝石与精湛工艺",
                    part2: "的永恒之美带入生活，创造令人难忘的珍宝。"
                }
            },
            whoWeAre: {
                title: "我们是谁",
                subtitle: "值得信赖、合乎伦理且卓越的宝石与珠宝解决方案，依托数十年的专业知识与对工艺的热爱。",
                imageAlt: "Marino Gems & Jewellery",
                text: {
                    part1: "在",
                    part2: "，我们致力于打造反映永恒美感与卓越品质的精美宝石与珠宝。我们的团队已成功采购并制作超过",
                    pieces: "1000",
                    part3: "件独特作品，服务于遍布",
                    regions: "亚洲、欧洲、北美及其他地区",
                    part4: "的客户。我们秉持对伦理采购与精湛工艺的坚定承诺，创造彰显个性与优雅的定制设计。"
                }
            },
            brandName: "Marino Gems & Jewellery",
            chairman: {
                title: "主席寄语",
                alt: "主席寄语",
                message: "\"在 Marino Gems & Jewellery，我们的愿景是打造诉说优雅与工艺故事的永恒之作。三十多年来，我们始终追求卓越，将传统与创新融合，创造充满美感与意义的珠宝。我们的热情驱使我们坚持最高的伦理采购与品质标准，确保每一件作品成为珍贵的传家宝。我诚邀您加入我们，通过艺术创造非凡时刻的旅程。\"",
                signature: "– 主席，Marino Gems & Jewellery"
            },
            team: {
                title: "我们的团队",
                alt: "我们的团队",
                text: {
                    part1: "在",
                    part2: "的团队由充满热情的工匠、熟练的宝石学家和敬业的专业人士组成，他们将数十年的经验注入每一件作品。凭借对卓越的共同承诺，我们的团队合作打造",
                    highlight: "定制设计",
                    part3: "，体现优雅与精准，服务于遍布",
                    regions: "亚洲、欧洲、北美及其他地区",
                    part4: "的客户。我们以培养创造力与创新为荣，同时坚守最高的伦理工艺标准。"
                }
            },
            services: {
                title: "我们的服务",
                subtitle: "Marino Gems & Jewellery 提供一系列高端服务，为全球客户带来卓越工艺与个性化体验。",
                alt: "我们的服务",
                intro: "我们的服务旨在提供无与伦比的品质与满意度，通过以下方式实现每位客户的愿景：",
                crafting: "以卓越品质打造定制珠宝",
                sourcing: "全球范围内采购符合伦理的宝石",
                consultations: "提供个性化设计咨询",
                repair: "提供修复与保养服务"
            },
            contact: {
                alt: "联系背景",
                title: "打造您的永恒珍宝",
                text: "感谢您探索 Marino Gems & Jewellery。我们热衷于将您的愿景转化为精美而永恒的作品。从定制设计到专业咨询，我们的团队全程陪伴您。立即联系我们，开始打造或修复您珍爱珠宝的旅程。",
                button: "联系我们"
            }
        },
        home: {
            hero: {
                title: "探索精美宝石与珠宝",
                subtitle: {
                    highlight: "探索我们世界级的宝石收藏",
                    part2: "以热情与精准打造。"
                },
                buttons: {
                    explore: "探索系列",
                    contact: "联系我们"
                }
            },
            kandy: {
                title: "Marino Gems and Jewellery",
                subtitle: "在康提之心体验 Marino Gems & Jewellery 的艺术与传承，以卓越工艺打造。"
            },
            services: {
                items: {
                    ethicalSourcing: {
                        title: "道德宝石采购",
                        desc: "我们从可信矿源负责任地采购宝石，确保可持续性并支持斯里兰卡当地社区。"
                    },
                    bespokeDesign: {
                        title: "定制珠宝设计",
                        desc: "我们的工匠与您合作，将您的愿景与我们的专业知识融合，打造独特永恒的作品。"
                    },
                    expertCraftsmanship: {
                        title: "专家工艺",
                        desc: "每件作品均在康提工坊手工精制，采用代代传承的技术，确保无与伦比的品质。"
                    },
                    globalExpertise: {
                        title: "全球宝石专长",
                        desc: "凭借深厚的宝石学知识，我们为全球客户提供世界级宝石，包括斯里兰卡蓝宝石。"
                    },
                    trustedLegacy: {
                        title: "值得信赖的传承",
                        desc: "Marino Gems & Jewellery 在康提建立了卓越声誉，以品质与真实性赢得客户信赖。"
                    }
                }
            },
            achievements: {
                title: "我们的成就",
                items: {
                    goldProducts: { title: "黄金产品" },
                    silverProducts: { title: "白银产品" },
                    gemStones: { title: "宝石" },
                    customers: { title: "客户" }
                }
            },
            products: {
                title: "我们的产品",
                subtitle: "探索我们精致的珠宝与宝石系列。",
                viewMore: "查看更多",
                view: "查看",
                items: {
                    gold: {
                        title: "黄金珠宝",
                        desc: "精美黄金珠宝，以优雅与精准工艺打造。"
                    },
                    silver: {
                        title: "白银珠宝",
                        desc: "惊艳的白银作品，融合传统与现代。"
                    },
                    precious: {
                        title: "珍贵宝石",
                        desc: "稀有宝石，包括蓝宝石，带来永恒之美。"
                    },
                    semiPrecious: {
                        title: "半宝石",
                        desc: "鲜艳的半宝石，为独特且亲民的奢华而生。"
                    }
                }
            },
            gallery: {
                title: "我们的画廊",
                subtitle: "一瞥我们的成功故事、活动以及我们全球实现的旅程",
                images: {
                    gallery1: "珠宝展示活动",
                    gallery2: "手工金项链展示",
                    gallery3: "康提工坊制作环节",
                    gallery4: "斯里兰卡蓝宝石切割过程",
                    gallery5: "客户珠宝咨询",
                    gallery6: "Marino Gems 门店开幕活动",
                    gallery7: "白银珠宝系列发布",
                    gallery8: "斯里兰卡宝石采购",
                    gallery9: "定制珠宝设计环节",
                    gallery10: "Marino Gems 团队在展会",
                    gallery11: "客户试戴蓝宝石戒指",
                    gallery12: "工艺奖项颁奖仪式"
                }
            },
            kandyImages: {
                images: {
                    kandy1: "Marino Gems 康提门店外观",
                    kandy2: "展厅内部展示",
                    kandy3: "宝石切割工坊",
                    kandy4: "珠宝制作进行中",
                    kandy5: "客户咨询区"
                }
            },
            testimonials: {
                title: "客户评价"
            }
        },
        goldjewelleries: {
            hero: {
                alt: "黄金珠宝背景",
                title: "精美黄金珠宝",
                subtitle: {
                    highlight: "永恒的工艺与优雅",
                    part2: "每一件黄金作品均为您量身打造。"
                },
                buttons: {
                    categories: "分类",
                    shopNow: "立即购买"
                }
            },
            nav: {
                gold: "黄金珠宝",
                silver: "白银珠宝",
                precious: "珍贵宝石",
                semiPrecious: "半宝石"
            },
            goldItems: {
                title: "黄金系列",
                subtitle: "探索我们精湛的黄金珠宝系列，以精准与优雅工艺打造，适合任何场合。"
            },
            categories: {
                rings: {
                    label: "戒指",
                    desc: "优雅的黄金戒指，采用精致设计，展现永恒之美。",
                    images: { 1: "黄金戒指 1", 2: "黄金戒指 2", 3: "黄金戒指 3", 4: "黄金戒指 4" }
                },
                pendants: {
                    label: "吊坠",
                    desc: "惊艳的黄金吊坠，以优雅气质完美搭配任何项链。",
                    images: { 1: "黄金吊坠 1", 2: "黄金吊坠 2", 3: "黄金吊坠 3", 4: "黄金吊坠 4" }
                },
                necklaces: {
                    label: "项链",
                    desc: "精致的黄金项链，为任何场合提升您的风格。",
                    images: { 1: "黄金项链 1", 2: "黄金项链 2", 3: "黄金项链 3", 4: "黄金项链 4" }
                },
                earrings: {
                    label: "耳环",
                    desc: "时尚的黄金耳环，融合现代潮流与经典优雅。",
                    images: { 1: "黄金耳环 1", 2: "黄金耳环 2", 3: "黄金耳环 3", 4: "黄金耳环 4" }
                },
                bracelets: {
                    label: "手镯",
                    desc: "优雅的黄金手镯，为您的手腕增添奢华。",
                    images: { 1: "黄金手镯 1", 2: "黄金手镯 2", 3: "黄金手镯 3", 4: "黄金手镯 4" }
                },
                chains: {
                    label: "链条",
                    desc: "多功能的黄金链条，完美搭配吊坠或单独佩戴。",
                    images: { 1: "黄金链条 1", 2: "黄金链条 2", 3: "黄金链条 3", 4: "黄金链条 4" }
                },
                tiePins: {
                    label: "领带夹",
                    desc: "精致的黄金领带夹，为正式装束增添亮点。",
                    images: { 1: "黄金领带夹 1", 2: "黄金领带夹 2", 3: "黄金领带夹 3", 4: "黄金领带夹 4" }
                },
                other: {
                    label: "其他单品",
                    desc: "精选黄金单品，打造优雅造型。",
                    images: { 1: "黄金单品 1", 2: "黄金单品 2", 3: "黄金单品 3", 4: "黄金单品 4" }
                }
            },
            view: "查看"
        },
        silverjewelleries: {
            hero: {
                alt: "白银珠宝背景",
                title: "精美白银珠宝",
                subtitle: {
                    highlight: "现代优雅与精湛工艺",
                    part2: "每一件白银作品均为您量身打造。"
                },
                buttons: {
                    categories: "分类",
                    shopNow: "立即购买"
                }
            },
            nav: {
                gold: "黄金珠宝",
                silver: "白银珠宝",
                precious: "珍贵宝石",
                semiPrecious: "半宝石"
            },
            silverItems: {
                title: "白银系列",
                subtitle: "探索我们精致的白银珠宝系列，以精准与风格工艺打造，适合任何场合。"
            },
            categories: {
                rings: {
                    label: "戒指",
                    desc: "现代设计的流线型白银戒指，适合日常优雅佩戴。",
                    images: { 1: "白银戒指 1", 2: "白银戒指 2", 3: "白银戒指 3", 4: "白银戒指 4" }
                },
                pendants: {
                    label: "吊坠",
                    desc: "时尚的白银吊坠，为任何项链增添优雅气质。",
                    images: { 1: "白银吊坠 1", 2: "白银吊坠 2", 3: "白银吊坠 3", 4: "白银吊坠 4" }
                },
                necklaces: {
                    label: "项链",
                    desc: "精致的白银项链，展现优雅与多功能风格。",
                    images: { 1: "白银项链 1", 2: "白银项链 2" }
                },
                earrings: {
                    label: "耳环",
                    desc: "优雅的白银耳环，融合潮流与永恒魅力。",
                    images: { 1: "白银耳环 1", 2: "白银耳环 2", 3: "白银耳环 3" }
                },
                bracelets: {
                    label: "手镯",
                    desc: "精致的白银手镯，为您的造型增添奢华感。",
                    images: { 1: "白银手镯 1", 2: "白银手镯 2", 3: "白银手镯 3" }
                },
                chains: {
                    label: "链条",
                    desc: "多功能的白银链条，完美搭配吊坠或单独佩戴。",
                    images: { 1: "白银链条 1", 2: "白银链条 2", 3: "白银链条 3", 4: "白银链条 4" }
                },
                tiePins: {
                    label: "领带夹",
                    desc: "抛光白银领带夹，提升正式装束的格调。",
                    images: { 1: "白银领带夹 1" }
                },
                bangles: {
                    label: "手镯",
                    desc: "经典白银手镯，永恒的配饰之选。",
                    images: { 1: "白银手镯 1" }
                }
            },
            view: "查看"
        },
        preciousstones: {
            hero: {
                alt: "珍贵宝石背景",
                title: "精美珍贵宝石",
                subtitle: {
                    highlight: "永恒的美感与耀眼光芒",
                    part2: "每一颗珍贵宝石均为您精心打造。"
                },
                buttons: {
                    categories: "分类",
                    shopNow: "立即购买"
                }
            },
            nav: {
                gold: "黄金珠宝",
                silver: "白银珠宝",
                precious: "珍贵宝石",
                semiPrecious: "半宝石"
            },
            stones: {
                title: "珍贵宝石",
                subtitle: "探索我们精选的珍贵宝石，每一颗都以卓越品质与美丽著称。",
                sapphire: {
                    title: "蓝宝石",
                    desc: "深邃的蓝色蓝宝石，以惊艳的净度和耐久性著称，非常适合优雅的珠宝设计。"
                },
                ruby: {
                    title: "红宝石",
                    desc: "鲜艳的红色红宝石，象征热情与力量，完美用于大胆而奢华的设计。"
                },
                topaz: {
                    title: "黄玉",
                    desc: "光芒四射的蓝色黄玉，为任何珠宝系列增添耀眼的光彩。"
                },
                amethyst: {
                    title: "紫水晶",
                    desc: "浓郁的紫色紫水晶，因其宁静之美而在现代与经典风格中备受推崇。"
                }
            }
        },
        semipreciousstones: {
            hero: {
                alt: "半宝石背景",
                title: "精美半宝石",
                subtitle: {
                    highlight: "鲜艳色彩与独特魅力",
                    part2: "每一颗半宝石均为您精心打造。"
                },
                buttons: {
                    categories: "分类",
                    shopNow: "立即购买"
                }
            },
            nav: {
                gold: "黄金珠宝",
                silver: "白银珠宝",
                precious: "珍贵宝石",
                semiPrecious: "半宝石"
            },
            stones: {
                title: "半宝石",
                subtitle: "探索我们半宝石的鲜活魅力，每一颗都因其独特美感与多功能性而被精心挑选。",
                moonstone: {
                    title: "月光石",
                    desc: "梦幻的月光石，以其闪烁的光泽与平静能量著称，非常适合独特珠宝设计。"
                },
                citrine: {
                    title: "黄水晶",
                    desc: "阳光般的黄色黄水晶，散发温暖与光彩，完美用于充满活力的珠宝作品。"
                },
                garnet: {
                    title: "石榴石",
                    desc: "浓郁的红色石榴石，因其温暖色调而在经典与现代设计中广受喜爱。"
                },
                quartz: {
                    title: "石英",
                    desc: "透明或烟灰石英，以其纯净与多功能性在各种珠宝风格中备受推崇。"
                },
                turquoise: {
                    title: "绿松石",
                    desc: "鲜艳的蓝绿色绿松石，因其独特色彩与文化意义在珠宝中备受珍视。"
                },
                peridot: {
                    title: "橄榄石",
                    desc: "郁郁葱葱的绿色橄榄石，以其清新闪耀与日常佩戴的适宜性而闻名。"
                }
            }
        },
        // Chinese (zh - Simplified)
        // Chinese (zh - Simplified)
        blogs: {
            hero: {
                alt: "博客背景",
                title: "我们的博客",
                subtitle: {
                    part1: "探索我们的",
                    highlight: "见解与故事",
                    part2: "关于宝石、工艺以及 Marino Gems & Jewellery 背后的艺术。"
                }
            },
            posts: {
                title: "最新博客文章",
                subtitle: "深入我们的最新文章，了解宝石世界、珠宝趋势以及我们创作背后的工艺。",
                readMore: "阅读更多",
                items: {
                    sapphires: {
                        title: "斯里兰卡蓝宝石的永恒魅力",
                        excerpt: "探索斯里兰卡享誉世界的蓝宝石的丰富历史与独特品质。",
                        description: "斯里兰卡，被誉为“宝石岛”，2000多年来一直是精美蓝宝石的来源地。以鲜艳的蓝色调和卓越的净度闻名，这些宝石曾点缀全球皇室与收藏家。从拉特纳普勒的古老矿区到现代市场，斯里兰卡蓝宝石以其永恒之美持续吸引世人。在 Marino Gems & Jewellery，我们以道德方式采购这些宝石，打造出反映其深厚遗产与无与伦比品质的惊艳作品。了解使这些蓝宝石独一无二的地质因素，以及它们为何仍是全球宝石贸易的基石。",
                        altTexts: {
                            1: "斯里兰卡鲜艳蓝宝石特写",
                            2: "拉特纳普勒传统蓝宝石开采",
                            3: "抛光蓝宝石镶嵌于珠宝中"
                        }
                    },
                    crafting: {
                        title: "定制珠宝制作：我们的工艺流程",
                        excerpt: "了解 Marino 如何将原始宝石转化为精美珠宝。",
                        description: "在 Marino Gems & Jewellery，定制珠宝流程融合艺术与精准。从挑选符合伦理来源的宝石开始，到与客户共同进行设计咨询，我们的熟练工匠手工打造每件作品，确保每个细节都符合客户的愿景。从切割、抛光到镶嵌与精修，整个过程注重品质与独特性。探索我们将原材料转化为永恒珍宝的步骤，了解为何我们的工艺在高级珠宝领域独树一帜。",
                        altTexts: {
                            1: "工匠精准切割宝石",
                            2: "设计师勾勒定制珠宝草图",
                            3: "带有精致细节的完成珠宝"
                        }
                    },
                    ethical: {
                        title: "宝石道德采购的趋势",
                        excerpt: "了解道德采购为何在当今宝石行业如此重要。",
                        description: "道德采购是现代珠宝趋势的核心。在 Marino Gems & Jewellery，我们优先采用可持续实践，确保宝石负责任开采，支持当地社区并减少环境影响。本文探讨道德采购的兴起、我们遵循的认证，以及消费者如何推动行业透明度。了解塑造可持续珠宝的挑战与创新，以及我们如何在每件作品中保持对道德卓越的承诺。",
                        altTexts: {
                            1: "矿区内道德采购的宝石",
                            2: "可持续宝石认证流程",
                            3: "受益于道德开采的社区"
                        }
                    },
                    history: {
                        title: "斯里兰卡宝石开采的历史",
                        excerpt: "揭开宝石开采的古老技术与现代方法。",
                        description: "斯里兰卡的宝石开采历史超过2000年，拉特纳普勒等地区至今仍保留传统坑道开采。本文深入探讨这些古老技术的历史、现代开采方法的演变及其对斯里兰卡经济与文化的影响。从古代矿工的工具到如今的可持续实践，我们讲述 Marino Gems & Jewellery 如何在保护这一丰富遗产的同时采购宝石。了解那些让斯里兰卡成为全球宝石中心的宝石背后的故事。",
                        altTexts: {
                            1: "斯里兰卡传统坑道开采",
                            2: "宝石开采使用的古代工具",
                            3: "现代可持续开采设备"
                        }
                    },
                    care: {
                        title: "宝石珠宝保养小贴士",
                        excerpt: "学习如何用我们的专家建议让您的珠宝保持闪耀。",
                        description: "适当保养对保持宝石珠宝的光彩至关重要。本文提供 Marino Gems & Jewellery 专家的实用建议，包括清洁技巧、储存方法以及如何避免贵重宝石与金属受损。无论是蓝宝石戒指还是红宝石项链，我们的指南涵盖日常佩戴与长期保存的最佳实践。了解简单有效的保养习惯如何让您的珠宝成为代代相传的珍贵传家宝。",
                        altTexts: {
                            1: "用软布清洁蓝宝石戒指",
                            2: "宝石珠宝的正确储存方式",
                            3: "检查项链的保养需求"
                        }
                    },
                    future: {
                        title: "珠宝的未来：新兴趋势",
                        excerpt: "探索塑造珠宝设计未来的趋势。",
                        description: "珠宝行业正在演变，设计、材料与技术的新趋势不断涌现。本文探讨高级珠宝的未来走向：实验室培育宝石、创新3D打印设计以及可持续材料。在 Marino Gems & Jewellery，我们将传统与现代创新相结合，创造出与当今消费者产生共鸣的作品。了解个性化、环保设计以及大胆新风格如何重新定义珠宝工艺的未来。",
                        altTexts: {
                            1: "实验室培育宝石接受检查",
                            2: "3D打印珠宝设计原型",
                            3: "珠宝制作中的可持续材料"
                        }
                    }
                }
            },
            modal: {
                close: "关闭"
            }
        },

    },
    ja: {
        navbar: {
            home: 'ホーム',
            jewelleriesStones: 'ジュエリーと石',
            gemHistory: '宝石の歴史',
            blogs: 'ブログ',
            aboutUs: '私たちについて',
            contactUs: 'お問い合わせ',
        },
        footer: {
            description: 'Marino Gemsは、スリランカを代表する高級ジュエリー企業で、洗練された金・銀・宝石の作品を専門としています。',
            linksTitle: 'リンク',
            contactTitle: 'お問い合わせ',
            copyright: '© Copyright {{year}} Marino Gems',
            developedBy: '開発元：',
        },
        contact: {
            title: "お問い合わせ",
            feelFree: "お気軽にご連絡ください",
            weAreHere: "あらゆるステップでサポートいたします",
            description: "宝石やジュエリーに関するご相談・サポートは Marino Gems & Jewellery までお気軽にご連絡ください。",
            callCenter: "コールセンター",
            email: "メール",
            ourLocation: "当社の所在地",
            socialNetwork: "ソーシャルネットワーク",
            getInTouch: "お問い合わせ",
            formIntro: "ぜひご連絡ください — 私たちのチームがご質問にお答えし、ご案内いたします。",
            nameLabel: "お名前",
            emailLabel: "メールアドレス",
            contactNumberLabel: "連絡先電話番号",
            messageLabel: "メッセージ",
            sendButton: "メッセージを送信",
            sending: "送信中...",
            successMessage: "メッセージが WhatsApp に送信されました！",
            errorMessage: "WhatsApp を開けませんでした。もう一度お試しください。",
            findUs: "当社を探す"
        },
        gemhistory: {
            hero: {
                title: "宝石の歴史",
                alt: "宝石歴史の背景",
                subtitle: {
                    part1: "Marino Gems & Jewelleriesでは、",
                    highlight: "宝石と職人技",
                    part2: "の豊かな歴史を称え、何世紀にもわたり時代を超えた宝物を形作ってきました。"
                }
            },
            history: {
                title: "スリランカの宝石の歴史",
                subtitle: "「宝石の島」として知られるスリランカは、2000年以上にわたる宝石採掘と交易の歴史を持っています。",
                imageAlt: "スリランカの宝石の歴史",
                text: "スリランカは「宝石の島」と呼ばれ、2000年以上にわたり貴石・半貴石の世界的中心地です。サファイア、ルビーなどで有名なラトナプラ地域などの豊かな鉱床は、古来より活発な交易を支えてきました。王宮から現代市場まで、スリランカの宝石は世界中の王族やコレクターを魅了。伝統的な採掘法が現代技術と共存しています。Marino Gems & Jewelleriesはこの遺産を引き継ぎ、倫理的に採掘された宝石を使い、卓越したジュエリーを制作しています。"
            },
            industry: {
                title: "宝石産業について",
                subtitle: "世界の宝石産業は、古来の職人技と現代の革新を融合させ、永遠の価値を生み出しています。",
                imageAlt: "宝石産業について",
                text: "宝石産業は採掘・カット・取引・ジュエリーデザインに至る伝統と技術のダイナミックな融合です。グローバル市場規模は800億ドルを超え、サファイア、ダイヤモンド、エメラルドなどの魅力に支えられています。古代の交易路から現代市場まで、数百万人の生計を支え、スリランカ、タイ、インドが主要拠点です。Marino Gems & Jewelleriesは倫理的調達と持続可能な実践を優先し、この活気ある産業に貢献しています——すべての作品に品質と責任が宿っています。"
            },
            importance: {
                title: "宝石の重要性",
                country: "スリランカにおいて",
                subtitle: "なぜ宝石がスリランカの遺産、経済、世界的評価の礎であるかを発見してください。",
                items: {
                    culturalSignificance: {
                        title: "文化的意義",
                        description: "宝石は数世紀にわたりスリランカ文化に深く根ざし、王室の装飾品や宗教的遺物に用いられ、権力と精神性を象徴してきました。"
                    },
                    economicImpact: {
                        title: "経済的影響",
                        description: "宝石産業はスリランカ経済の主要な柱であり、ラトナプラなどの鉱山地域で雇用とコミュニティを支えています。"
                    },
                    globalReputation: {
                        title: "世界的評価",
                        description: "スリランカのサファイアとルビーは世界的に有名で、国際的な買い手を惹きつけ、同国を宝石のトップハブに位置づけています。"
                    },
                    sustainablePractices: {
                        title: "持続可能な取り組み",
                        description: "Marino Gems & Jewelleriesは倫理的な採掘と持続可能な方法を推進し、スリランカの自然資源と宝石遺産を守っています。"
                    }
                }
            }
        },
        ourproducts: {
            hero: {
                alt: "当社の製品背景",
                timeless: "時代を超えたエレガンス",
                title: "当社の精巧なジュエリー",
                description: "厳選された宝石とジュエリーのコレクションをご覧ください。個性と永遠の美しさを称えるためにデザインされています。"
            },
            section: {
                title: "ジュエリーと宝石",
                subtitle: "ゴールド・シルバージュエリー、貴石・半貴石の多彩なラインナップを探索し、あなたのスタイルを高めてください。"
            },
            viewMore: "詳細を見る",
            categories: {
                gold: {
                    title: "ゴールドジュエリー",
                    desc: "精密に作られたゴールドジュエリー。時代を超えたエレガンスと現代的なデザインが見事に融合しています。"
                },
                silver: {
                    title: "シルバージュエリー",
                    desc: "手頃な価格と卓越した職人技を兼ね備えたエレガントなシルバー作品。日常使いに最適です。"
                },
                precious: {
                    title: "貴石",
                    desc: "希少で鮮やかな貴石を倫理的に調達し、息をのむようなジュエリーに仕上げています。"
                },
                semiPrecious: {
                    title: "半貴石",
                    desc: "カラフルで個性的な半貴石。オーダーメイドやパーソナライズデザインに最適です。"
                }
            }
        },
        aboutus: {
            hero: {
                alt: "私たちについて背景",
                title: "私たちについて",
                subtitle: {
                    part1: "Marino Gems & Jewelleryでは、",
                    highlight: "精美な宝石と職人技",
                    part2: "の永遠の美しさを活かし、忘れられない宝物を創り出しています。"
                }
            },
            whoWeAre: {
                title: "私たちは誰か",
                subtitle: "信頼・倫理・卓越性を備えた宝石とジュエリーのソリューションを、数十年間の専門知識と職人技への情熱で支えています。",
                imageAlt: "Marino Gems & Jewellery",
                text: {
                    part1: "",
                    part2: "では、永遠の美しさと卓越した品質を反映する精美な宝石とジュエリーの制作に専念しています。私たちのチームはすでに",
                    pieces: "1000",
                    part3: "を超えるユニークな作品を調達・制作し、",
                    regions: "アジア、ヨーロッパ、北米をはじめとする",
                    part4: "地域のお客様にサービスを提供しています。倫理的な調達と卓越した職人技への深いコミットメントのもと、個性と優雅さを称えるオーダーメイドデザインを創り出しています。"
                }
            },
            brandName: "Marino Gems & Jewellery",
            chairman: {
                title: "代表メッセージ",
                alt: "代表メッセージ",
                message: "\"Marino Gems & Jewelleryでは、優雅さと職人技の物語を語る永遠の作品を生み出すことを目指しています。30年以上にわたり卓越性を追求し、伝統と革新を融合させて美と意味を持つジュエリーを制作してきました。私たちの情熱は、最高水準の倫理的調達と品質を維持し、すべての作品が大切な家宝となるよう駆り立てます。私たちの芸術を通じて特別な瞬間を創り出す旅にご一緒いただけることを心よりお待ちしています。\"",
                signature: "– 代表取締役、Marino Gems & Jewellery"
            },
            team: {
                title: "私たちのチーム",
                alt: "私たちのチーム",
                text: {
                    part1: "",
                    part2: "のチームは、情熱的な職人、熟練した宝石学者、献身的なプロフェッショナルで構成されており、数十年の経験をすべての作品に注いでいます。卓越性への共通のコミットメントのもと、私たちは協力して",
                    highlight: "オーダーメイドデザイン",
                    part3: "を生み出し、優雅さと精密さを体現しています。サービス提供地域は",
                    regions: "アジア、ヨーロッパ、北米をはじめ",
                    part4: "です。創造性と革新を育みながら、最高水準の倫理的職人技を維持することを誇りに思います。"
                }
            },
            services: {
                title: "私たちのサービス",
                subtitle: "Marino Gems & Jewelleryはプレミアムサービスを提供し、世界中のお客様に卓越した職人技とパーソナライズされた体験をお届けします。",
                alt: "私たちのサービス",
                intro: "私たちのサービスは最高の品質と満足度を提供し、お客様のビジョンを以下の形で具現化します：",
                crafting: "卓越した品質でのオーダーメイドジュエリー制作",
                sourcing: "世界中からの倫理的に採掘された宝石の調達",
                consultations: "パーソナライズされたデザイン相談",
                repair: "修理・修復サービス"
            },
            contact: {
                alt: "連絡背景",
                title: "あなたの永遠の宝物を創る",
                text: "Marino Gems & Jewelleryをご覧いただきありがとうございます。私たちはお客様のビジョンを精美で永遠の作品に変えることに情熱を注いでいます。オーダーメイドデザインから専門的な相談まで、私たちのチームはあらゆるステップでお客様をサポートします。今日ご連絡いただき、大切なジュエリーの制作や修復の旅を始めましょう。",
                button: "お問い合わせ"
            }
        },
        home: {
            hero: {
                title: "精美な宝石とジュエリーを発見",
                subtitle: {
                    highlight: "世界クラスの宝石コレクションをご覧ください",
                    part2: "情熱と精密さで作り上げられています。"
                },
                buttons: {
                    explore: "コレクションを見る",
                    contact: "お問い合わせ"
                }
            },
            kandy: {
                title: "Marino Gems and Jewellery",
                subtitle: "Marino Gems & Jewellery の芸術性と伝統を、康提の中心で卓越した品質とともに体感してください。"
            },
            services: {
                items: {
                    ethicalSourcing: {
                        title: "倫理的な宝石調達",
                        desc: "信頼できる鉱山から責任を持って宝石を調達し、スリランカの地域社会を支援しながら持続可能性を確保しています。"
                    },
                    bespokeDesign: {
                        title: "オーダーメイドジュエリー",
                        desc: "職人がお客様と協力し、独自のビジョンを当社の専門知識と融合させて唯一無二の作品を創ります。"
                    },
                    expertCraftsmanship: {
                        title: "卓越した職人技",
                        desc: "康提の工房で一代代受け継がれた技術を用い、精密に手作りされた作品は比類なき品質を誇ります。"
                    },
                    globalExpertise: {
                        title: "世界レベルの宝石知識",
                        desc: "深い宝石学の知識を基に、スリランカ産サファイアを含む最高級の宝石を世界中のお客様にお届けします。"
                    },
                    trustedLegacy: {
                        title: "信頼の伝統",
                        desc: "Marino Gems & Jewellery は康提で卓越した評判を築き、品質と本物性で信頼されています。"
                    }
                }
            },
            achievements: {
                title: "私たちの実績",
                items: {
                    goldProducts: { title: "ゴールド製品" },
                    silverProducts: { title: "シルバー製品" },
                    gemStones: { title: "宝石" },
                    customers: { title: "お客様" }
                }
            },
            products: {
                title: "私たちの製品",
                subtitle: "精美なジュエリーと宝石のラインナップをご覧ください。",
                viewMore: "さらに見る",
                view: "見る",
                items: {
                    gold: {
                        title: "ゴールドジュエリー",
                        desc: "優雅さと精密さで作り上げられた精美なゴールドジュエリー。"
                    },
                    silver: {
                        title: "シルバージュエリー",
                        desc: "伝統と現代が融合した見事なシルバー作品。"
                    },
                    precious: {
                        title: "貴石",
                        desc: "サファイアを含む希少な宝石で永遠の美を。"
                    },
                    semiPrecious: {
                        title: "半貴石",
                        desc: "鮮やかで個性的な半貴石によるユニークで手頃なラグジュアリー。"
                    }
                }
            },
            gallery: {
                title: "ギャラリー",
                subtitle: "私たちの成功物語、イベント、世界中で実現した旅のひとコマ",
                images: {
                    gallery1: "ジュエリー展示イベント",
                    gallery2: "手作りゴールドネックレス展示",
                    gallery3: "康提工房での制作シーン",
                    gallery4: "スリランカ産サファイアの研磨工程",
                    gallery5: "お客様へのジュエリー相談",
                    gallery6: "Marino Gems 店舗オープンイベント",
                    gallery7: "シルバージュエリーコレクション発表",
                    gallery8: "スリランカでの宝石調達",
                    gallery9: "オーダーメイドジュエリーデザインセッション",
                    gallery10: "Marino Gems チームの展示会出展",
                    gallery11: "サファイアリングを試着するお客様",
                    gallery12: "職人技に対する表彰式"
                }
            },
            kandyImages: {
                images: {
                    kandy1: "Marino Gems 康提店舗外観",
                    kandy2: "ショールーム内部",
                    kandy3: "宝石研磨工房",
                    kandy4: "ジュエリー制作の様子",
                    kandy5: "お客様相談エリア"
                }
            },
            testimonials: {
                title: "お客様の声"
            }
        },
        goldjewelleries: {
            hero: {
                alt: "ゴールドジュエリー背景",
                title: "精美なゴールドジュエリー",
                subtitle: {
                    highlight: "時代を超えた職人技と優雅さ",
                    part2: "すべてのゴールド作品はあなたのためにデザインされています。"
                },
                buttons: {
                    categories: "カテゴリー",
                    shopNow: "今すぐ購入"
                }
            },
            nav: {
                gold: "ゴールドジュエリー",
                silver: "シルバージュエリー",
                precious: "貴石",
                semiPrecious: "半貴石"
            },
            goldItems: {
                title: "ゴールドアイテム",
                subtitle: "精密かつ優雅に仕上げられたゴールドジュエリーのコレクションを、どんなシーンにもお楽しみください。"
            },
            categories: {
                rings: {
                    label: "リング",
                    desc: "繊細なデザインで仕上げられたエレガントなゴールドリングで、永遠の美しさを。",
                    images: { 1: "ゴールドリング 1", 2: "ゴールドリング 2", 3: "ゴールドリング 3", 4: "ゴールドリング 4" }
                },
                pendants: {
                    label: "ペンダント",
                    desc: "どんなネックレスにも洗練を添える見事なゴールドペンダント。",
                    images: { 1: "ゴールドペンダント 1", 2: "ゴールドペンダント 2", 3: "ゴールドペンダント 3", 4: "ゴールドペンダント 4" }
                },
                necklaces: {
                    label: "ネックレス",
                    desc: "どんなシーンでもスタイルを引き立てる精美なゴールドネックレス。",
                    images: { 1: "ゴールドネックレス 1", 2: "ゴールドネックレス 2", 3: "ゴールドネックレス 3", 4: "ゴールドネックレス 4" }
                },
                earrings: {
                    label: "イヤリング",
                    desc: "モダントレンドとクラシックな優雅さを融合したシックなゴールドイヤリング。",
                    images: { 1: "ゴールドイヤリング 1", 2: "ゴールドイヤリング 2", 3: "ゴールドイヤリング 3", 4: "ゴールドイヤリング 4" }
                },
                bracelets: {
                    label: "ブレスレット",
                    desc: "手首を豪華に飾る優美なゴールドブレスレット。",
                    images: { 1: "ゴールドブレスレット 1", 2: "ゴールドブレスレット 2", 3: "ゴールドブレスレット 3", 4: "ゴールドブレスレット 4" }
                },
                chains: {
                    label: "チェーン",
                    desc: "ペンダントにも単体でも使える万能なゴールドチェーン。",
                    images: { 1: "ゴールドチェーン 1", 2: "ゴールドチェーン 2", 3: "ゴールドチェーン 3", 4: "ゴールドチェーン 4" }
                },
                tiePins: {
                    label: "タイピン",
                    desc: "フォーマルな装いに華を添える洗練されたゴールドタイピン。",
                    images: { 1: "ゴールドタイピン 1", 2: "ゴールドタイピン 2", 3: "ゴールドタイピン 3", 4: "ゴールドタイピン 4" }
                },
                other: {
                    label: "その他のアイテム",
                    desc: "洗練されたスタイルのための厳選ゴールドアイテム。",
                    images: { 1: "ゴールドアイテム 1", 2: "ゴールドアイテム 2", 3: "ゴールドアイテム 3", 4: "ゴールドアイテム 4" }
                }
            },
            view: "見る"
        },
        silverjewelleries: {
            hero: {
                alt: "シルバージュエリー背景",
                title: "精美なシルバージュエリー",
                subtitle: {
                    highlight: "現代的なエレガンスと職人技",
                    part2: "すべてのシルバー作品はあなたのためにデザインされています。"
                },
                buttons: {
                    categories: "カテゴリー",
                    shopNow: "今すぐ購入"
                }
            },
            nav: {
                gold: "ゴールドジュエリー",
                silver: "シルバージュエリー",
                precious: "貴石",
                semiPrecious: "半貴石"
            },
            silverItems: {
                title: "シルバーアイテム",
                subtitle: "精密かつスタイリッシュに仕上げられたシルバージュエリーのコレクションを、どんなシーンにもお楽しみください。"
            },
            categories: {
                rings: {
                    label: "リング",
                    desc: "モダンなデザインの流線型シルバーリングで日常のエレガンスを。",
                    images: { 1: "シルバーリング 1", 2: "シルバーリング 2", 3: "シルバーリング 3", 4: "シルバーリング 4" }
                },
                pendants: {
                    label: "ペンダント",
                    desc: "どんなネックレスにも洗練を添えるシックなシルバーペンダント。",
                    images: { 1: "シルバーペンダント 1", 2: "シルバーペンダント 2", 3: "シルバーペンダント 3", 4: "シルバーペンダント 4" }
                },
                necklaces: {
                    label: "ネックレス",
                    desc: "洗練されたシルバーネックレスで多機能なスタイルを。",
                    images: { 1: "シルバーネックレス 1", 2: "シルバーネックレス 2" }
                },
                earrings: {
                    label: "イヤリング",
                    desc: "トレンドと永遠の魅力を融合したエレガントなシルバーイヤリング。",
                    images: { 1: "シルバーイヤリング 1", 2: "シルバーイヤリング 2", 3: "シルバーイヤリング 3" }
                },
                bracelets: {
                    label: "ブレスレット",
                    desc: "手首にラグジュアリーを添える洗練されたシルバーブレスレット。",
                    images: { 1: "シルバーブレスレット 1", 2: "シルバーブレスレット 2", 3: "シルバーブレスレット 3" }
                },
                chains: {
                    label: "チェーン",
                    desc: "ペンダントにも単体でも使える多機能なシルバーチェーン。",
                    images: { 1: "シルバーチェーン 1", 2: "シルバーチェーン 2", 3: "シルバーチェーン 3", 4: "シルバーチェーン 4" }
                },
                tiePins: {
                    label: "タイピン",
                    desc: "フォーマルな装いに洗練を加えるポリッシュシルバータイピン。",
                    images: { 1: "シルバータイピン 1" }
                },
                bangles: {
                    label: "バングル",
                    desc: "永遠のアクセサリーとして選ばれるクラシックなシルバーバングル。",
                    images: { 1: "シルバーバングル 1" }
                }
            },
            view: "見る"
        },
        preciousstones: {
            hero: {
                alt: "貴石背景",
                title: "精美な貴石",
                subtitle: {
                    highlight: "永遠の美しさと輝き",
                    part2: "すべての貴石はあなたのために丁寧に選ばれています。"
                },
                buttons: {
                    categories: "カテゴリー",
                    shopNow: "今すぐ購入"
                }
            },
            nav: {
                gold: "ゴールドジュエリー",
                silver: "シルバージュエリー",
                precious: "貴石",
                semiPrecious: "半貴石"
            },
            stones: {
                title: "貴石",
                subtitle: "当社の厳選された貴石の輝きをご覧ください。どれも卓越した品質と美しさで選ばれています。",
                sapphire: {
                    title: "サファイア",
                    desc: "深みのあるブルーサファイア。驚くべき透明度と耐久性で、エレガントなジュエリーに最適です。"
                },
                ruby: {
                    title: "ルビー",
                    desc: "鮮やかなレッドルビー。情熱と強さを象徴し、大胆で贅沢なデザインにぴったりです。"
                },
                topaz: {
                    title: "トパーズ",
                    desc: "輝くブルートパーズ。どのジュエリーコレクションにもきらめきを加えます。"
                },
                amethyst: {
                    title: "アメジスト",
                    desc: "豊かな紫のアメジスト。穏やかな美しさで、モダン・クラシック両方のスタイルに愛されています。"
                }
            }
        },
        semipreciousstones: {
            hero: {
                alt: "半貴石背景",
                title: "精美な半貴石",
                subtitle: {
                    highlight: "鮮やかな色彩と独特の魅力",
                    part2: "すべての半貴石はあなたのために丁寧に選ばれています。"
                },
                buttons: {
                    categories: "カテゴリー",
                    shopNow: "今すぐ購入"
                }
            },
            nav: {
                gold: "ゴールドジュエリー",
                silver: "シルバージュエリー",
                precious: "貴石",
                semiPrecious: "半貴石"
            },
            stones: {
                title: "半貴石",
                subtitle: "当社の半貴石の鮮やかな魅力をご覧ください。どれも独自の美しさと汎用性で選ばれています。",
                moonstone: {
                    title: "ムーンストーン",
                    desc: "幻想的なムーンストーン。きらめく輝きと癒しのエネルギーを持ち、ユニークなジュエリーに最適です。"
                },
                citrine: {
                    title: "シトリン",
                    desc: "陽光のようなイエローシトリン。温かみと輝きを放ち、活気あるジュエリーにぴったりです。"
                },
                garnet: {
                    title: "ガーネット",
                    desc: "濃厚なレッドガーネット。温かい色調で、クラシック・モダン両方のデザインに幅広く使われます。"
                },
                quartz: {
                    title: "クォーツ",
                    desc: "透明またはスモーキークォーツ。純度の高さと多様なスタイルへの適応力で愛されています。"
                },
                turquoise: {
                    title: "ターコイズ",
                    desc: "鮮やかなブルーグリーンのターコイズ。独特の色と文化的意義でジュエリーに欠かせません。"
                },
                peridot: {
                    title: "ペリドット",
                    desc: "鮮やかなグリーンペリドット。爽やかな輝きで日常使いに最適です。"
                }
            }
        },
        // Japanese (ja)
        blogs: {
            hero: {
                alt: "ブログ背景",
                title: "私たちのブログ",
                subtitle: {
                    part1: "宝石、職人技、そして Marino Gems & Jewellery の芸術性をめぐる",
                    highlight: "洞察とストーリー",
                    part2: "のコレクションをご覧ください。"
                }
            },
            posts: {
                title: "最新ブログ記事",
                subtitle: "最新記事に飛び込んで、宝石の世界、ジュエリートレンド、私たちの創作の裏側にある職人技についてもっと知りましょう。",
                readMore: "続きを読む",
                items: {
                    sapphires: {
                        title: "スリランカ産サファイアの永遠の魅力",
                        excerpt: "スリランカが誇る世界的に有名なサファイアの豊かな歴史と独特な品質を探ります。",
                        description: "「宝石の島」として知られるスリランカは、2000年以上にわたり極上のサファイアの産地です。鮮やかなブルーの色調と卓越した透明度で知られ、王族やコレクターを魅了してきました。ラトナプラの古い鉱山から現代の市場まで、スリランカ産サファイアは永遠の美しさで人々を惹きつけ続けます。Marino Gems & Jewellery では、これらの宝石を倫理的に調達し、その豊かな遺産と比類ない品質を映し出す素晴らしい作品を生み出しています。サファイアを特別なものにする地質的要因と、それがなぜ世界の宝石貿易の要であり続けるのかを学びましょう。",
                        altTexts: {
                            1: "鮮やかなブルーのスリランカ産サファイアのクローズアップ",
                            2: "ラトナプラでの伝統的なサファイア採掘",
                            3: "ジュエリーにセットされた研磨済みサファイア"
                        }
                    },
                    crafting: {
                        title: "オーダーメイドジュエリーの製作：私たちのプロセス",
                        excerpt: "Marino が原石をどのように精美なジュエリーに変えるのかをご覧ください。",
                        description: "Marino Gems & Jewellery では、オーダーメイドジュエリーのプロセスが芸術と精密さを融合させています。倫理的に調達された宝石の選定から始まり、クライアントとの共同デザイン相談を経て、熟練の職人が手作業で一つひとつ作り上げます。カット、研磨、セッティング、仕上げまで、すべての工程で品質と個性を重視しています。原材料が永遠の宝物へと変わる過程を知り、なぜ私たちの職人技がハイジュエリーの世界で際立つのかをご理解ください。",
                        altTexts: {
                            1: "職人が宝石を精密にカット",
                            2: "デザイナーがオーダーメイドジュエリーのスケッチを描く",
                            3: "細部までこだわった完成ジュエリー"
                        }
                    },
                    ethical: {
                        title: "倫理的な宝石調達のトレンド",
                        excerpt: "現代の宝石産業において倫理的調達がなぜ重要なのかを探ります。",
                        description: "倫理的調達は現代ジュエリーのトレンドの中心にあります。Marino Gems & Jewellery では、持続可能な方法を優先し、責任ある採掘を通じて地域社会を支え、環境への影響を最小限に抑えています。この記事では倫理的調達の台頭、私たちが遵守する認証、そして消費者が業界に求める透明性について解説します。持続可能なジュエリーを形作る課題とイノベーション、そして私たちがすべての作品で倫理的卓越性をどのように維持しているかを学びましょう。",
                        altTexts: {
                            1: "倫理的に調達された鉱山現場の宝石",
                            2: "持続可能な宝石の認証プロセス",
                            3: "倫理的採掘から恩恵を受けるコミュニティ"
                        }
                    },
                    history: {
                        title: "スリランカの宝石採掘の歴史",
                        excerpt: "古代の技術と現代の方法を紐解きます。",
                        description: "スリランカの宝石採掘の歴史は2000年以上に及び、ラトナプラなどの地域では今も伝統的な坑道採掘が行われています。この記事では、古代の採掘技術の歴史、現代採掘方法の進化、そしてそれらがスリランカの経済と文化に与えた影響を探ります。古代鉱夫の道具から現在の持続可能な手法まで、Marino Gems & Jewellery がこの豊かな遺産を保ちながら宝石を調達する方法を解説します。スリランカを世界的な宝石の中心地にした石たちの物語を知ってください。",
                        altTexts: {
                            1: "スリランカの伝統的な坑道採掘",
                            2: "宝石採掘に使われた古代の道具",
                            3: "現代の持続可能な採掘設備"
                        }
                    },
                    care: {
                        title: "宝石ジュエリーのお手入れのコツ",
                        excerpt: "専門家のアドバイスでジュエリーを輝かせ続けましょう。",
                        description: "宝石ジュエリーの輝きを保つには適切なケアが欠かせません。Marino Gems & Jewellery の専門家が実践的なアドバイスを提供します：洗浄方法、適切な保管、貴石や金属へのダメージを防ぐコツなど。サファイアのリングでもルビーのネックレスでも、日常使いから長期保存までのベストプラクティスを網羅しています。簡単で効果的なケア習慣で、世代を超えて愛される宝物にしてください。",
                        altTexts: {
                            1: "柔らかい布でサファイアリングを拭く",
                            2: "宝石ジュエリーの正しい保管方法",
                            3: "ネックレスのメンテナンス点検"
                        }
                    },
                    future: {
                        title: "ジュエリーの未来：新興トレンド",
                        excerpt: "ジュエリー・デザインの未来を形作るトレンドを探ります。",
                        description: "ジュエリー産業はデザイン、素材、技術の新トレンドで進化を続けています。ラボグロウン宝石、革新的な3Dプリントデザイン、持続可能な素材など、次に来るものを探ります。Marino Gems & Jewellery では伝統と現代のイノベーションを融合させ、現代の消費者に響く作品を生み出しています。パーソナライゼーション、エコ意識の高いデザイン、大胆な新スタイルがジュエリー工芸の未来をどう再定義しているのかを学びましょう。",
                        altTexts: {
                            1: "ラボグロウン宝石の検査",
                            2: "3Dプリントされたジュエリーデザインのプロトタイプ",
                            3: "ジュエリー製作における持続可能な素材"
                        }
                    }
                }
            },
            modal: {
                close: "閉じる"
            }
        },
    },
    // ── NEW: Italian ───────────────────────────────────────────
    it: {
        navbar: {
            home: 'Home',
            jewelleriesStones: 'Gioielli e Pietre',
            gemHistory: 'Storia delle Gemme',
            blogs: 'Blog',
            aboutUs: 'Chi Siamo',
            contactUs: 'Contattaci',
        },
        footer: {
            description: 'Marino Gems è un\'azienda di gioielli di alto livello in Sri Lanka, specializzata in creazioni squisite in oro, argento e pietre preziose.',
            linksTitle: 'Link',
            contactTitle: 'Contatti',
            copyright: '© Copyright {{year}} - Marino Gems',
            developedBy: 'Sviluppato da',
        },
        contact: {
            title: "Contattaci",
            feelFree: "Sentiti libero di contattarci",
            weAreHere: "Siamo qui per aiutarti in ogni passo",
            description: "Contatta Marino Gems & Jewellery per una consulenza esperta e supporto per le tue esigenze di gemme e gioielli.",
            callCenter: "Call Center",
            email: "Email",
            ourLocation: "La nostra posizione",
            socialNetwork: "Social Network",
            getInTouch: "Mettiti in contatto",
            formIntro: "Ci piacerebbe avere tue notizie — il nostro team è pronto a rispondere alle tue domande e guidarti.",
            nameLabel: "Nome",
            emailLabel: "Email",
            contactNumberLabel: "Numero di telefono",
            messageLabel: "Messaggio",
            sendButton: "Invia messaggio",
            sending: "Invio in corso...",
            successMessage: "Il tuo messaggio è stato inviato su WhatsApp!",
            errorMessage: "Impossibile aprire WhatsApp. Riprova.",
            findUs: "Trovaci"
        },
        gemhistory: {
            hero: {
                title: "Storia delle Gemme",
                alt: "Sfondo Storia delle Gemme",
                subtitle: {
                    part1: "Da Marino Gems & Jewelleries celebriamo la ricca storia di",
                    highlight: "gemme e artigianato",
                    part2: "che da secoli hanno plasmato tesori senza tempo."
                }
            },
            history: {
                title: "Storia delle Gemme in Sri Lanka",
                subtitle: "Lo Sri Lanka, noto come “Isola delle Gemme”, vanta una tradizione di estrazione e commercio di pietre preziose lunga oltre 2.000 anni.",
                imageAlt: "Storia delle Gemme in Sri Lanka",
                text: "Lo Sri Lanka, spesso chiamato “Isola delle Gemme”, è da oltre 2.000 anni un centro globale per gemme preziose e semipreziose. Famoso per zaffiri, rubini e altre pietre, i ricchi giacimenti di zone come Ratnapura hanno alimentato un commercio vivace fin dall’antichità. Dalle corti reali ai mercati moderni, le gemme srilankesi hanno adornato monarchi e collezionisti in tutto il mondo. Le tecniche tradizionali di estrazione convivono ancora con i metodi moderni. Marino Gems & Jewelleries porta avanti questa eredità utilizzando gemme estratte eticamente per creare gioielli raffinati."
            },
            industry: {
                title: "L’industria delle gemme",
                subtitle: "L’industria globale delle gemme unisce antica maestria e innovazione moderna, creando valore senza tempo.",
                imageAlt: "L’industria delle gemme",
                text: "L’industria delle gemme è una combinazione dinamica di tradizione e tecnologia: dall’estrazione al taglio, al commercio e al design di gioielli. Valutata oltre 80 miliardi di dollari a livello globale, prospera grazie al fascino di zaffiri, diamanti, smeraldi e altre pietre. Dalle antiche rotte commerciali ai mercati moderni, sostiene milioni di posti di lavoro, con centri chiave in Sri Lanka, Thailandia e India. Marino Gems & Jewelleries contribuisce a questo settore vitale dando priorità all’approvvigionamento etico e alle pratiche sostenibili — ogni pezzo riflette qualità e responsabilità."
            },
            importance: {
                title: "Importanza delle gemme in",
                country: "Sri Lanka",
                subtitle: "Scopri perché le gemme sono un pilastro del patrimonio, dell’economia e della reputazione globale dello Sri Lanka.",
                items: {
                    culturalSignificance: {
                        title: "Significato culturale",
                        description: "Le gemme sono da secoli parte integrante della cultura srilankese, adornando insegne reali e oggetti religiosi, simboli di potere e spiritualità."
                    },
                    economicImpact: {
                        title: "Impatto economico",
                        description: "L’industria delle gemme è un importante contributore all’economia dello Sri Lanka, creando occupazione e sostenendo le comunità nelle zone minerarie come Ratnapura."
                    },
                    globalReputation: {
                        title: "Reputazione globale",
                        description: "Gli zaffiri e i rubini dello Sri Lanka sono rinomati in tutto il mondo, attirando acquirenti internazionali e consolidando il paese come hub di eccellenza per le gemme."
                    },
                    sustainablePractices: {
                        title: "Pratiche sostenibili",
                        description: "Marino Gems & Jewelleries promuove l’estrazione etica e metodi sostenibili, preservando le risorse naturali e il patrimonio gemmologico dello Sri Lanka."
                    }
                }
            }
        },
        ourproducts: {
            hero: {
                alt: "Sfondo dei nostri prodotti",
                timeless: "Eleganza senza tempo",
                title: "I nostri gioielli squisiti",
                description: "Scopri la nostra collezione di pietre preziose e gioielli realizzati con cura, pensati per celebrare l’individualità e la bellezza eterna."
            },
            section: {
                title: "Gioielli e Pietre",
                subtitle: "Esplora la nostra vasta gamma di gioielli in oro e argento, insieme a pietre preziose e semi-preziose, creati per esaltare il tuo stile."
            },
            viewMore: "Vedi di più",
            categories: {
                gold: {
                    title: "Gioielli in Oro",
                    desc: "Gioielli in oro raffinati, lavorati con precisione, che uniscono eleganza senza tempo a un design moderno."
                },
                silver: {
                    title: "Gioielli in Argento",
                    desc: "Pezzi eleganti in argento che combinano accessibilità con una lavorazione straordinaria, perfetti per l’uso quotidiano."
                },
                precious: {
                    title: "Pietre Preziose",
                    desc: "Pietre preziose rare e vivaci, estratte in modo etico per creare gioielli mozzafiato."
                },
                semiPrecious: {
                    title: "Pietre Semi-preziose",
                    desc: "Pietre semi-preziose colorate e uniche, ideali per creazioni su misura e personalizzate."
                }
            }
        },
        aboutus: {
            hero: {
                alt: "Sfondo Chi siamo",
                title: "Chi siamo",
                subtitle: {
                    part1: "Da Marino Gems & Jewellery portiamo la bellezza senza tempo delle",
                    highlight: "gemme squisite e dell’artigianato",
                    part2: "per creare tesori indimenticabili."
                }
            },
            whoWeAre: {
                title: "Chi siamo",
                subtitle: "Soluzioni affidabili, etiche ed eccezionali per gemme e gioielli, supportate da decenni di esperienza e dalla passione per l’artigianato.",
                imageAlt: "Marino Gems & Jewellery",
                text: {
                    part1: "Da",
                    part2: ", ci dedichiamo alla creazione di gemme e gioielli squisiti che riflettono bellezza senza tempo e qualità eccezionale. Il nostro team ha già procurato e realizzato oltre",
                    pieces: "1000",
                    part3: "pezzi unici, servendo clienti in",
                    regions: "Asia, Europa, Nord America e oltre",
                    part4: ". Con un profondo impegno per la sourcing etica e la maestria artigianale, creiamo design su misura che celebrano individualità ed eleganza."
                }
            },
            brandName: "Marino Gems & Jewellery",
            chairman: {
                title: "Messaggio del Presidente",
                alt: "Messaggio del Presidente",
                message: "\"Da Marino Gems & Jewellery, la nostra visione è creare pezzi senza tempo che raccontano storie di eleganza e artigianato. Da oltre tre decenni perseguiamo l’eccellenza, fondendo tradizione e innovazione per realizzare gioielli che trasmettono bellezza e significato. La nostra passione ci spinge a mantenere i più alti standard di approvvigionamento etico e qualità, affinché ogni creazione diventi un’eredità preziosa. Vi invito a unirvi a noi in questo viaggio per creare momenti straordinari attraverso la nostra arte.\"",
                signature: "– Presidente, Marino Gems & Jewellery"
            },
            team: {
                title: "Il nostro team",
                alt: "Il nostro team",
                text: {
                    part1: "Il nostro team presso",
                    part2: "è composto da artigiani appassionati, gemmologi qualificati e professionisti dedicati che portano decenni di esperienza in ogni creazione. Con un impegno condiviso verso l’eccellenza, collaboriamo per realizzare",
                    highlight: "design su misura",
                    part3: "che incarnano eleganza e precisione, servendo clienti in",
                    regions: "Asia, Europa, Nord America e oltre",
                    part4: ". Siamo orgogliosi di coltivare creatività e innovazione mantenendo i più alti standard di artigianato etico."
                }
            },
            services: {
                title: "I nostri servizi",
                subtitle: "Marino Gems & Jewellery offre una gamma di servizi premium, garantendo artigianato eccezionale ed esperienze personalizzate ai clienti in tutto il mondo.",
                alt: "I nostri servizi",
                intro: "I nostri servizi sono pensati per garantire qualità e soddisfazione senza pari, dando vita alla visione di ogni cliente attraverso:",
                crafting: "Creazione di gioielli su misura di qualità eccezionale",
                sourcing: "Approvvigionamento etico di gemme a livello globale",
                consultations: "Consulenze personalizzate di design",
                repair: "Servizi di riparazione e restauro"
            },
            contact: {
                alt: "Sfondo Contatti",
                title: "Creare i tuoi tesori senza tempo",
                text: "Grazie per aver esplorato Marino Gems & Jewellery. Siamo appassionati di trasformare la tua visione in pezzi squisiti e senza tempo. Dai design su misura alle consulenze esperte, il nostro team è qui per guidarti in ogni fase. Contattaci oggi per iniziare il tuo viaggio verso la creazione o il restauro del tuo gioiello amato.",
                button: "Contattaci"
            }
        },
        home: {
            hero: {
                title: "Scopri gemme e gioielli squisiti",
                subtitle: {
                    highlight: "Esplora la nostra collezione di gemme di classe mondiale",
                    part2: "realizzate con passione e precisione."
                },
                buttons: {
                    explore: "Scopri le collezioni",
                    contact: "Contattaci"
                }
            },
            kandy: {
                title: "Marino Gems and Jewellery",
                subtitle: "Vivi l’arte e l’eredità di Marino Gems & Jewellery, realizzata con eccellenza nel cuore di Kandy."
            },
            services: {
                items: {
                    ethicalSourcing: {
                        title: "Approvvigionamento etico di gemme",
                        desc: "Procacciamo le nostre gemme in modo responsabile da miniere affidabili, promuovendo sostenibilità e sostegno alle comunità locali in Sri Lanka."
                    },
                    bespokeDesign: {
                        title: "Design di gioielli su misura",
                        desc: "I nostri artigiani collaborano con te per creare gioielli personalizzati, unendo la tua visione alla nostra competenza."
                    },
                    expertCraftsmanship: {
                        title: "Artigianato di alto livello",
                        desc: "Ogni pezzo è realizzato a mano nel nostro laboratorio di Kandy con tecniche perfezionate nel corso di generazioni."
                    },
                    globalExpertise: {
                        title: "Competenza globale in gemmologia",
                        desc: "Grazie a una profonda conoscenza di gemmologia offriamo gemme di livello mondiale, inclusi zaffiri dello Sri Lanka, a clienti in tutto il mondo."
                    },
                    trustedLegacy: {
                        title: "Eredità affidabile",
                        desc: "Marino Gems & Jewellery si è guadagnato una reputazione di eccellenza a Kandy, apprezzato per qualità e autenticità."
                    }
                }
            },
            achievements: {
                title: "I nostri traguardi",
                items: {
                    goldProducts: { title: "Prodotti in oro" },
                    silverProducts: { title: "Prodotti in argento" },
                    gemStones: { title: "Pietre preziose" },
                    customers: { title: "Clienti" }
                }
            },
            products: {
                title: "I nostri prodotti",
                subtitle: "Scopri la nostra raffinata selezione di gioielli e pietre preziose.",
                viewMore: "Vedi di più",
                view: "Vedi",
                items: {
                    gold: {
                        title: "Gioielli in oro",
                        desc: "Gioielli in oro squisiti, lavorati con eleganza e precisione."
                    },
                    silver: {
                        title: "Gioielli in argento",
                        desc: "Splendidi pezzi in argento che fondono tradizione e modernità."
                    },
                    precious: {
                        title: "Pietre preziose",
                        desc: "Gemme rare, inclusi zaffiri, per una bellezza senza tempo."
                    },
                    semiPrecious: {
                        title: "Pietre semi-preziose",
                        desc: "Pietre semi-preziose vivaci per un lusso unico e accessibile."
                    }
                }
            },
            gallery: {
                title: "La nostra galleria",
                subtitle: "Uno sguardo alle nostre storie di successo, eventi e ai viaggi che abbiamo reso possibili in tutto il mondo",
                images: {
                    gallery1: "Evento di presentazione gioielli",
                    gallery2: "Esposizione collana d’oro fatta a mano",
                    gallery3: "Sessione di lavorazione nell’atelier di Kandy",
                    gallery4: "Processo di taglio di uno zaffiro srilankese",
                    gallery5: "Consulenza cliente per gioielli",
                    gallery6: "Evento di apertura negozio Marino Gems",
                    gallery7: "Lancio collezione gioielli in argento",
                    gallery8: "Approvvigionamento gemme in Sri Lanka",
                    gallery9: "Sessione di design gioielli su misura",
                    gallery10: "Team Marino Gems a fiera commerciale",
                    gallery11: "Cliente prova anello con zaffiro",
                    gallery12: "Cerimonia di premiazione per artigianato"
                }
            },
            kandyImages: {
                images: {
                    kandy1: "Facciata negozio Marino Gems a Kandy",
                    kandy2: "Interno showroom",
                    kandy3: "Laboratorio taglio gemme",
                    kandy4: "Lavorazione gioielli in corso",
                    kandy5: "Area consulenza clienti"
                }
            },
            testimonials: {
                title: "Cosa dicono i nostri clienti"
            }
        },
        goldjewelleries: {
            hero: {
                alt: "Sfondo gioielli in oro",
                title: "Gioielli in oro squisiti",
                subtitle: {
                    highlight: "Artigianato senza tempo ed eleganza",
                    part2: "in ogni pezzo d’oro, creato per te."
                },
                buttons: {
                    categories: "Categorie",
                    shopNow: "Acquista ora"
                }
            },
            nav: {
                gold: "Gioielli in oro",
                silver: "Gioielli in argento",
                precious: "Pietre preziose",
                semiPrecious: "Pietre semi-preziose"
            },
            goldItems: {
                title: "Articoli in oro",
                subtitle: "Scopri la nostra straordinaria collezione di gioielli in oro, realizzati con precisione ed eleganza per ogni occasione."
            },
            categories: {
                rings: {
                    label: "Anelli",
                    desc: "Eleganti anelli in oro con design intricati per una bellezza senza tempo.",
                    images: { 1: "Anello in oro 1", 2: "Anello in oro 2", 3: "Anello in oro 3", 4: "Anello in oro 4" }
                },
                pendants: {
                    label: "Pendenti",
                    desc: "Splendidi pendenti in oro per impreziosire qualsiasi collana con raffinatezza.",
                    images: { 1: "Pendente in oro 1", 2: "Pendente in oro 2", 3: "Pendente in oro 3", 4: "Pendente in oro 4" }
                },
                necklaces: {
                    label: "Collane",
                    desc: "Collane in oro squisite che esaltano il tuo stile in ogni occasione.",
                    images: { 1: "Collana in oro 1", 2: "Collana in oro 2", 3: "Collana in oro 3", 4: "Collana in oro 4" }
                },
                earrings: {
                    label: "Orecchini",
                    desc: "Orecchini in oro chic che fondono tendenze moderne ed eleganza classica.",
                    images: { 1: "Orecchino in oro 1", 2: "Orecchino in oro 2", 3: "Orecchino in oro 3", 4: "Orecchino in oro 4" }
                },
                bracelets: {
                    label: "Bracciali",
                    desc: "Bracciali in oro graziosi progettati per adornare il polso con lusso.",
                    images: { 1: "Bracciale in oro 1", 2: "Bracciale in oro 2", 3: "Bracciale in oro 3", 4: "Bracciale in oro 4" }
                },
                chains: {
                    label: "Catene",
                    desc: "Catene in oro versatili, perfette per pendenti o da indossare da sole.",
                    images: { 1: "Catena in oro 1", 2: "Catena in oro 2", 3: "Catena in oro 3", 4: "Catena in oro 4" }
                },
                tiePins: {
                    label: "Spille da cravatta",
                    desc: "Spille da cravatta in oro sofisticate per dare un tocco distintivo all’abbigliamento formale.",
                    images: { 1: "Spilla da cravatta in oro 1", 2: "Spilla da cravatta in oro 2", 3: "Spilla da cravatta in oro 3", 4: "Spilla da cravatta in oro 4" }
                },
                other: {
                    label: "Altri articoli",
                    desc: "Collezione selezionata di articoli in oro per un look raffinato.",
                    images: { 1: "Articolo in oro 1", 2: "Articolo in oro 2", 3: "Articolo in oro 3", 4: "Articolo in oro 4" }
                }
            },
            view: "Vedi"
        },
        silverjewelleries: {
            hero: {
                alt: "Sfondo gioielli in argento",
                title: "Gioielli in argento squisiti",
                subtitle: {
                    highlight: "Eleganza moderna e artigianato",
                    part2: "in ogni pezzo d’argento, creato per te."
                },
                buttons: {
                    categories: "Categorie",
                    shopNow: "Acquista ora"
                }
            },
            nav: {
                gold: "Gioielli in oro",
                silver: "Gioielli in argento",
                precious: "Pietre preziose",
                semiPrecious: "Pietre semi-preziose"
            },
            silverItems: {
                title: "Articoli in argento",
                subtitle: "Scopri la nostra collezione squisita di gioielli in argento, realizzati con precisione e stile per ogni occasione."
            },
            categories: {
                rings: {
                    label: "Anelli",
                    desc: "Anelli in argento eleganti con design moderno per un’eleganza quotidiana.",
                    images: { 1: "Anello in argento 1", 2: "Anello in argento 2", 3: "Anello in argento 3", 4: "Anello in argento 4" }
                },
                pendants: {
                    label: "Pendenti",
                    desc: "Pendenti in argento chic che aggiungono un tocco di raffinatezza.",
                    images: { 1: "Pendente in argento 1", 2: "Pendente in argento 2", 3: "Pendente in argento 3", 4: "Pendente in argento 4" }
                },
                necklaces: {
                    label: "Collane",
                    desc: "Collane in argento eleganti per un look raffinato e versatile.",
                    images: { 1: "Collana in argento 1", 2: "Collana in argento 2" }
                },
                earrings: {
                    label: "Orecchini",
                    desc: "Orecchini in argento eleganti che uniscono tendenza e fascino senza tempo.",
                    images: { 1: "Orecchino in argento 1", 2: "Orecchino in argento 2", 3: "Orecchino in argento 3" }
                },
                bracelets: {
                    label: "Bracciali",
                    desc: "Bracciali in argento sofisticati per un tocco di lusso.",
                    images: { 1: "Bracciale in argento 1", 2: "Bracciale in argento 2", 3: "Bracciale in argento 3" }
                },
                chains: {
                    label: "Catene",
                    desc: "Catene in argento versatili, perfette per pendenti o da sole.",
                    images: { 1: "Catena in argento 1", 2: "Catena in argento 2", 3: "Catena in argento 3", 4: "Catena in argento 4" }
                },
                tiePins: {
                    label: "Spille da cravatta",
                    desc: "Spille da cravatta in argento lucidate per valorizzare l’abbigliamento formale.",
                    images: { 1: "Spilla da cravatta in argento 1" }
                },
                bangles: {
                    label: "Bracciali rigidi",
                    desc: "Bracciali rigidi in argento classici per una scelta di accessorio senza tempo.",
                    images: { 1: "Bracciale rigido in argento 1" }
                }
            },
            view: "Vedi"
        },
        preciousstones: {
            hero: {
                alt: "Sfondo pietre preziose",
                title: "Pietre preziose squisite",
                subtitle: {
                    highlight: "Bellezza senza tempo e splendore",
                    part2: "in ogni pietra preziosa, creata per te."
                },
                buttons: {
                    categories: "Categorie",
                    shopNow: "Acquista ora"
                }
            },
            nav: {
                gold: "Gioielli in oro",
                silver: "Gioielli in argento",
                precious: "Pietre preziose",
                semiPrecious: "Pietre semi-preziose"
            },
            stones: {
                title: "Pietre preziose",
                subtitle: "Scopri lo splendore delle nostre pietre preziose, ognuna selezionata per la sua qualità eccezionale e bellezza.",
                sapphire: {
                    title: "Zaffiri",
                    desc: "Zaffiri blu profondo, rinomati per la loro straordinaria chiarezza e resistenza, perfetti per gioielli eleganti."
                },
                ruby: {
                    title: "Rubini",
                    desc: "Rubini rossi vivaci, simbolo di passione e forza, ideali per design audaci e lussuosi."
                },
                topaz: {
                    title: "Topazi",
                    desc: "Topazi blu radiosi, che offrono una brillantezza scintillante per arricchire qualsiasi collezione di gioielli."
                },
                amethyst: {
                    title: "Ametiste",
                    desc: "Ametiste viola intenso, apprezzate per la loro bellezza calmante e versatilità in stili moderni e classici."
                }
            }
        },
        semipreciousstones: {
            hero: {
                alt: "Sfondo pietre semi-preziose",
                title: "Pietre semi-preziose squisite",
                subtitle: {
                    highlight: "Colori vivaci e fascino unico",
                    part2: "in ogni pietra semi-preziosa, creata per te."
                },
                buttons: {
                    categories: "Categorie",
                    shopNow: "Acquista ora"
                }
            },
            nav: {
                gold: "Gioielli in oro",
                silver: "Gioielli in argento",
                precious: "Pietre preziose",
                semiPrecious: "Pietre semi-preziose"
            },
            stones: {
                title: "Pietre semi-preziose",
                subtitle: "Scopri l’allure vibrante delle nostre pietre semi-preziose, ognuna scelta per la sua bellezza unica e versatilità.",
                moonstone: {
                    title: "Pietre di luna",
                    desc: "Pietre di luna eteree, note per il loro bagliore scintillante e l’energia calmante, perfette per gioielli unici."
                },
                citrine: {
                    title: "Citrino",
                    desc: "Citrino giallo sole, irradiante calore e brillantezza, ideale per pezzi di gioielleria vivaci."
                },
                garnet: {
                    title: "Granato",
                    desc: "Granato rosso ricco, apprezzato per le sue calde tonalità e versatilità nei design classici e moderni."
                },
                quartz: {
                    title: "Quarzo",
                    desc: "Quarzo chiaro o fumé, amato per la sua purezza e adattabilità in vari stili di gioielleria."
                },
                turquoise: {
                    title: "Turchese",
                    desc: "Turchese blu-verde vivido, amato per il suo colore unico e il significato culturale nella gioielleria."
                },
                peridot: {
                    title: "Peridoto",
                    desc: "Peridoto verde lussureggiante, celebrato per il suo scintillio rinfrescante e l’idoneità all’uso quotidiano."
                }
            }
        },
        // Italian (it)
        blogs: {
            hero: {
                alt: "Sfondo blog",
                title: "I nostri blog",
                subtitle: {
                    part1: "Esplora la nostra collezione di",
                    highlight: "approfondimenti e storie",
                    part2: "su gemme, artigianato e l’arte dietro Marino Gems & Jewellery."
                }
            },
            posts: {
                title: "Ultimi articoli del blog",
                subtitle: "Tuffati nei nostri ultimi articoli per scoprire di più sul mondo delle gemme, le tendenze della gioielleria e l’artigianato dietro le nostre creazioni.",
                readMore: "Leggi di più",
                items: {
                    sapphires: {
                        title: "L’eterno fascino degli zaffiri dello Sri Lanka",
                        excerpt: "Scopri la ricca storia e le qualità uniche degli zaffiri rinomati in tutto il mondo dello Sri Lanka.",
                        description: "Lo Sri Lanka, noto come “isola delle gemme”, fornisce zaffiri squisiti da oltre 2.000 anni. Celebri per le loro intense tonalità blu e la chiarezza eccezionale, queste gemme hanno adornato monarchi e collezionisti di tutto il mondo. Dalle antiche miniere di Ratnapura ai mercati moderni, gli zaffiri srilankesi continuano a incantare con la loro bellezza senza tempo. Da Marino Gems & Jewellery li procuriamo eticamente per creare pezzi straordinari che riflettono il loro ricco patrimonio e la qualità ineguagliabile. Scopri i fattori geologici che li rendono unici e perché restano un pilastro del commercio globale delle gemme.",
                        altTexts: {
                            1: "Primo piano di uno zaffiro blu intenso dello Sri Lanka",
                            2: "Estrazione tradizionale di zaffiri a Ratnapura",
                            3: "Zaffiro lucidato incastonato in un gioiello"
                        }
                    },
                    crafting: {
                        title: "Creazione di gioielli su misura: il nostro processo",
                        excerpt: "Scopri come Marino trasforma gemme grezze in pezzi di gioielleria squisiti.",
                        description: "Da Marino Gems & Jewellery il processo di creazione su misura unisce arte e precisione. Si parte dalla selezione di gemme eticamente reperite, seguita da consulenze di design collaborative con i clienti. I nostri abili artigiani realizzano ogni pezzo a mano, assicurando che ogni dettaglio corrisponda alla visione del cliente. Dal taglio e lucidatura al montaggio e finitura, il processo pone al centro qualità e individualità. Scopri i passaggi che trasformano materie prime in tesori senza tempo e perché la nostra maestria si distingue nel mondo dell’alta gioielleria.",
                        altTexts: {
                            1: "Artigiano che taglia una gemma con precisione",
                            2: "Designer che disegna un gioiello su misura",
                            3: "Pezzo finito con dettagli intricati"
                        }
                    },
                    ethical: {
                        title: "Tendenze nell’approvvigionamento etico di gemme",
                        excerpt: "Scopri perché l’approvvigionamento etico è così importante nell’industria delle gemme oggi.",
                        description: "L’approvvigionamento etico è al centro delle tendenze moderne della gioielleria. Da Marino Gems & Jewellery diamo priorità a pratiche sostenibili per garantire che le nostre gemme siano estratte responsabilmente, sostenendo le comunità locali e riducendo l’impatto ambientale. Questo articolo esplora l’ascesa dell’approvvigionamento etico, le certificazioni che seguiamo e come i consumatori spingano per maggiore trasparenza nel settore. Scopri le sfide e le innovazioni che plasmano la gioielleria sostenibile e come manteniamo il nostro impegno per l’eccellenza etica in ogni creazione.",
                        altTexts: {
                            1: "Gemme eticamente reperite in un sito minerario",
                            2: "Processo di certificazione per gemme sostenibili",
                            3: "Comunità che beneficia dell’estrazione etica"
                        }
                    },
                    history: {
                        title: "La storia dell’estrazione di gemme in Sri Lanka",
                        excerpt: "Scopri le tecniche antiche e i metodi moderni di estrazione delle gemme.",
                        description: "L’estrazione di gemme in Sri Lanka risale a oltre 2.000 anni fa, con l’estrazione tradizionale in pozzi ancora praticata in aree come Ratnapura. Questo articolo esplora la storia di queste antiche tecniche, l’evoluzione dei metodi moderni e il loro impatto sull’economia e sulla cultura dello Sri Lanka. Dagli strumenti usati dagli antichi minatori alle pratiche sostenibili odierne, vediamo come Marino Gems & Jewellery reperisca gemme preservando questo ricco patrimonio. Scopri le storie dietro le gemme che hanno reso lo Sri Lanka un hub globale di pietre preziose.",
                        altTexts: {
                            1: "Estrazione tradizionale in pozzi in Sri Lanka",
                            2: "Strumenti antichi usati nell’estrazione di gemme",
                            3: "Attrezzatura moderna per estrazione sostenibile"
                        }
                    },
                    care: {
                        title: "Consigli per la cura dei tuoi gioielli con gemme",
                        excerpt: "Impara a mantenere i tuoi gioielli splendenti con i nostri consigli da esperti.",
                        description: "La cura adeguata è essenziale per preservare la brillantezza dei tuoi gioielli con gemme. Questo articolo offre consigli pratici degli esperti di Marino Gems & Jewellery: tecniche di pulizia, consigli di conservazione e modi per evitare danni a gemme e metalli preziosi. Che si tratti di un anello con zaffiro o di una collana con rubino, la nostra guida copre le migliori pratiche per l’uso quotidiano e la conservazione a lungo termine. Scopri come semplici routine di cura possano garantire che i tuoi gioielli restino un’eredità preziosa per le generazioni future.",
                        altTexts: {
                            1: "Pulizia di un anello con zaffiro con un panno morbido",
                            2: "Conservazione corretta dei gioielli con gemme",
                            3: "Ispezione di una collana per la manutenzione"
                        }
                    },
                    future: {
                        title: "Il futuro della gioielleria: tendenze emergenti",
                        excerpt: "Esplora le tendenze che stanno plasmando il futuro del design gioielliero.",
                        description: "L’industria della gioielleria sta evolvendo con nuove tendenze in design, materiali e tecnologia. Questo articolo esplora cosa riserva il futuro all’alta gioielleria: gemme coltivate in laboratorio, design innovativi stampati in 3D e materiali sostenibili. Da Marino Gems & Jewellery anticipiamo questi cambiamenti, fondendo tradizione e innovazione moderna per creare pezzi che parlano ai consumatori di oggi. Scopri l’influenza della personalizzazione, dei design eco-consapevoli e dei nuovi stili audaci che stanno ridefinendo il futuro dell’arte orafa.",
                        altTexts: {
                            1: "Gemmi coltivati in laboratorio sotto ispezione",
                            2: "Prototipo di design gioielliero stampato in 3D",
                            3: "Materiali sostenibili nella creazione di gioielli"
                        }
                    }
                }
            },
            modal: {
                close: "Chiudi"
            }
        },
    },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en',          // Default language
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;